export default [
  {
    local: "ACB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL BOGADO/AGROSERVICIOS",
    coordenadas: "33°16'20\"S  60°34'14\"W",
    latitud: -60.57066,
    longitud: -33.27226,
    elev: 44,
    uom_elev: "Metros",
    ref: "Coronel Bogado",
    distancia_ref: 6,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ACH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL ACHA",
    coordenadas: "37°24' 6\"S  64°36'49\"W",
    latitud: -64.61351,
    longitud: -37.40164,
    elev: 277,
    uom_elev: "Metros",
    ref: "General Acha",
    distancia_ref: 3,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "ACM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ARRECIFES/LA CURA MALAL",
    coordenadas: "34° 4'33\"S  60° 8'30\"W",
    latitud: -60.1417,
    longitud: -34.07574,
    elev: 37,
    uom_elev: "Metros",
    ref: "Arrecifes",
    distancia_ref: 4,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ADO",
    oaci: "SAWD",
    iata: "PUD",
    tipo: "Aerodromo",
    denominacion: "PUERTO DESEADO",
    coordenadas: "47°44' 6\"S  65°54'15\"W",
    latitud: -65.9041,
    longitud: -47.73511,
    elev: 82,
    uom_elev: "Metros",
    ref: "Puerto Deseado",
    distancia_ref: 2,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "ADT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BANDERA/AGROSERVICIOS DOÑA TERESA",
    coordenadas: "28°51'19\"S  62°15'53\"W",
    latitud: -62.26462,
    longitud: -28.85541,
    elev: 75,
    uom_elev: "Metros",
    ref: "Bandera",
    distancia_ref: 4,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "ADU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BANDERA/DUTTO",
    coordenadas: "28°52' 1\"S  62°14'17\"W",
    latitud: -62.23812,
    longitud: -28.86691,
    elev: 87,
    uom_elev: "Metros",
    ref: "Bandera",
    distancia_ref: 3,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "AER",
    oaci: "SABE",
    iata: "AEP",
    tipo: "Aerodromo",
    denominacion: "BUENOS AIRES/AEROPARQUE J. NEWBERY",
    coordenadas: "34°33'32\"S  58°24'59\"W",
    latitud: -58.41638889,
    longitud: -34.55888889,
    elev: 5.6,
    uom_elev: "Metros",
    ref: "Ciudad de Buenos Aires",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "JOINT",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "AGI",
    oaci: "SAVA",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PIEDRA DEL AGUILA",
    coordenadas: "40°11'32\"S  70° 0'39\"W",
    latitud: -70.01075,
    longitud: -40.19232,
    elev: 649,
    uom_elev: "Metros",
    ref: "Piedra del Aguila",
    distancia_ref: 17,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "AGR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ALTA GRACIA",
    coordenadas: "31°39' 4\"S  64°23'38\"W",
    latitud: -64.39388889,
    longitud: -31.65111111,
    elev: 533,
    uom_elev: "Metros",
    ref: "Alta Gracia",
    distancia_ref: 2,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "AII",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHACABUCO/LAS DOS A",
    coordenadas: "34°48'40\"S  60°30'60\"W",
    latitud: -60.51661,
    longitud: -34.81116,
    elev: 60,
    uom_elev: "Metros",
    ref: "Chacabuco",
    distancia_ref: 20,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "AJA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA LAJA",
    coordenadas: "31°21' 5\"S  68°28'23\"W",
    latitud: -68.47305556,
    longitud: -31.35138889,
    elev: 650,
    uom_elev: "Metros",
    ref: "La Laja",
    distancia_ref: 1,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN JUAN",
    inhab: "NO",
  },
  {
    local: "ALC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AMEGHINO/LA CHACRA",
    coordenadas: "34°48'34\"S  62°31'23\"W",
    latitud: -62.52293,
    longitud: -34.80942,
    elev: 109,
    uom_elev: "Metros",
    ref: "Florentino Ameghino",
    distancia_ref: 7,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ALL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ALLEN",
    coordenadas: "38°57'30\"S  67°48'10\"W",
    latitud: -67.80277778,
    longitud: -38.95833333,
    elev: 290,
    uom_elev: "Metros",
    ref: "Allen",
    distancia_ref: 3.5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "ALR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ALEJANDRO ROCA",
    coordenadas: "33°20'55\"S  63°43'48\"W",
    latitud: -63.73,
    longitud: -33.34861111,
    elev: 210,
    uom_elev: "Metros",
    ref: "Alejandro Roca",
    distancia_ref: 1.5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "ALT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CRUZ ALTA",
    coordenadas: "33° 0'28\"S  61°50'13\"W",
    latitud: -61.83694444,
    longitud: -33.00777778,
    elev: 97,
    uom_elev: "Metros",
    ref: "Cruz Alta",
    distancia_ref: 2,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "ALV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ALVEAR/AGROALVEAR SRL",
    coordenadas: "33° 4' 7\"S  60°40' 1\"W",
    latitud: -60.66682,
    longitud: -33.06853,
    elev: 32,
    uom_elev: "Metros",
    ref: "Alvear",
    distancia_ref: 4.5,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "AMA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ROBERTS/LA AMALIA",
    coordenadas: "35° 6' 2\"S  62° 0'60\"W",
    latitud: -62.01657,
    longitud: -35.10043,
    elev: 100,
    uom_elev: "Metros",
    ref: "Roberts",
    distancia_ref: 6.5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "AME",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AMEGHINO/SIGFRIDO ROHR",
    coordenadas: "34°49'50\"S  62°28' 4\"W",
    latitud: -62.46787,
    longitud: -34.83057,
    elev: 110,
    uom_elev: "Metros",
    ref: "Florentino Ameghino",
    distancia_ref: 2,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "AMG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AMEGHINO",
    coordenadas: "34°50'43\"S  62°28'58\"W",
    latitud: -62.48266,
    longitud: -34.84541,
    elev: 110,
    uom_elev: "Metros",
    ref: "Florentino Ameghino",
    distancia_ref: 2.5,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ANA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PARANA/AEROCLUB",
    coordenadas: "31°45'28\"S  60°22'26\"W",
    latitud: -60.37388889,
    longitud: -31.75777778,
    elev: 60,
    uom_elev: "Metros",
    ref: "La Picada",
    distancia_ref: 15,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "AND",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ANDALGALA",
    coordenadas: "27°37'41\"S  66°20'34\"W",
    latitud: -66.34277778,
    longitud: -27.62805556,
    elev: 900,
    uom_elev: "Metros",
    ref: "Andalgala",
    distancia_ref: 1,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CATAMARCA",
    inhab: "NO",
  },
  {
    local: "APO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "APOSTOLES",
    coordenadas: "27°54'12\"S  55°45'56\"W",
    latitud: -55.76555556,
    longitud: -27.90333333,
    elev: 117,
    uom_elev: "Metros",
    ref: "Apostoles",
    distancia_ref: 1.6,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "ARB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ARRIBEÑOS",
    coordenadas: "34°13'19\"S  61°23'12\"W",
    latitud: -61.38666667,
    longitud: -34.22194444,
    elev: 82,
    uom_elev: "Metros",
    ref: "Arribeños",
    distancia_ref: 3.3,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ARS",
    oaci: "SAVR",
    iata: "ARR",
    tipo: "Aerodromo",
    denominacion: "ALTO RIO SENGUERR/D. C. SZLAPELIS",
    coordenadas: "45° 0'48\"S  70°48'46\"W",
    latitud: -70.81282,
    longitud: -45.0132,
    elev: 697,
    uom_elev: "Metros",
    ref: "Alto Rio Senguerr",
    distancia_ref: 3,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "ARY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ARROYITO/ARCOR",
    coordenadas: "31°25'20\"S  63° 0'18\"W",
    latitud: -63.005,
    longitud: -31.42222222,
    elev: 148,
    uom_elev: "Metros",
    ref: "Arroyito",
    distancia_ref: 4,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "ATE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ZARATE",
    coordenadas: "34° 7' 6\"S  59° 4'58\"W",
    latitud: -59.08266,
    longitud: -34.11829,
    elev: 26,
    uom_elev: "Metros",
    ref: "Zarate",
    distancia_ref: 6,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ATN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TRENQUE LAUQUEN/LA ARGENTINA",
    coordenadas: "35°59'52\"S  62°42'23\"W",
    latitud: -62.70635,
    longitud: -35.99773,
    elev: 95,
    uom_elev: "Metros",
    ref: "Trenque Lauquen",
    distancia_ref: 2,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "AUL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AMEGHINO/AUGUSTO LEGUIZAMON",
    coordenadas: "34°49' 5\"S  62°28'38\"W",
    latitud: -62.47709,
    longitud: -34.81797,
    elev: 109,
    uom_elev: "Metros",
    ref: "Florentino Ameghino",
    distancia_ref: 3,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "AVA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ALVEAR/AEROPARQUE ROSARIO",
    coordenadas: "33° 2'49\"S  60°35'51\"W",
    latitud: -60.59756,
    longitud: -33.04691,
    elev: 26,
    uom_elev: "Metros",
    ref: "Alvear",
    distancia_ref: 2.5,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "AVL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AVELLANEDA/PRESIDENTE AVELLANEDA",
    coordenadas: "29° 6'22\"S  59°39'27\"W",
    latitud: -59.6575,
    longitud: -29.10611111,
    elev: 45,
    uom_elev: "Metros",
    ref: "Avellaneda",
    distancia_ref: 1,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "AYA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AYACUCHO",
    coordenadas: "37° 9'45\"S  58°28'23\"W",
    latitud: -58.47305556,
    longitud: -37.1625,
    elev: 77,
    uom_elev: "Metros",
    ref: "Ayacucho",
    distancia_ref: 0.9,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BAD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BERON DE ASTRADA/DINALUCA S.A.",
    coordenadas: "27°22'58\"S  57°38'39\"W",
    latitud: -57.64416667,
    longitud: -27.38277778,
    elev: 67,
    uom_elev: "Metros",
    ref: "Beron de Astrada",
    distancia_ref: 21,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "BAI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAGO BUENOS AIRES",
    coordenadas: "46°34'34\"S  70°56'53\"W",
    latitud: -70.94805556,
    longitud: -46.57611111,
    elev: 387,
    uom_elev: "Metros",
    ref: "Perito Moreno",
    distancia_ref: 2.5,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "BAL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BALCARCE",
    coordenadas: "37°54'55\"S  58°20'37\"W",
    latitud: -58.34361111,
    longitud: -37.91527778,
    elev: 120,
    uom_elev: "Metros",
    ref: "Balcarce",
    distancia_ref: 12,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BAR",
    oaci: "SAZS",
    iata: "BRC",
    tipo: "Aerodromo",
    denominacion: "SAN CARLOS DE BARILOCHE",
    coordenadas: "41° 9' 4\"S  71° 9'28\"W",
    latitud: -71.15777778,
    longitud: -41.15111111,
    elev: 846,
    uom_elev: "Metros",
    ref: "San Carlos de Bariloche",
    distancia_ref: 13,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "BAS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BASAVILBASO",
    coordenadas: "32°21'42\"S  58°52'54\"W",
    latitud: -58.8816,
    longitud: -32.3616,
    elev: 60,
    uom_elev: "Metros",
    ref: "Basavilbaso",
    distancia_ref: 1,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "BCA",
    oaci: "SAZB",
    iata: "BHI",
    tipo: "Aerodromo",
    denominacion: "BAHIA BLANCA/COMANDANTE ESPORA",
    coordenadas: "38°43'39\"S  62° 9'12\"W",
    latitud: -62.15333333,
    longitud: -38.7275,
    elev: 75,
    uom_elev: "Metros",
    ref: "Bahia Blanca",
    distancia_ref: 10,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "JOINT",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BDO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BARADERO",
    coordenadas: "33°49'16\"S  59°29'34\"W",
    latitud: -59.49279,
    longitud: -33.82122,
    elev: 29,
    uom_elev: "Metros",
    ref: "Baradero",
    distancia_ref: 1.5,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BDR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BAHIA DORADA",
    coordenadas: "41°50'34\"S  65° 4'56\"W",
    latitud: -65.08222222,
    longitud: -41.84277778,
    elev: 36,
    uom_elev: "Metros",
    ref: "Sierra Grande",
    distancia_ref: 35,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "BEL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BELL VILLE",
    coordenadas: "32°39'30\"S  62°42' 7\"W",
    latitud: -62.70194444,
    longitud: -32.65833333,
    elev: 131,
    uom_elev: "Metros",
    ref: "Bell Ville",
    distancia_ref: 2.5,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "BEX",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BARADERO",
    coordenadas: "33°51'31\"S  59°28' 9\"W",
    latitud: -59.46911,
    longitud: -33.85864,
    elev: 26,
    uom_elev: "Metros",
    ref: "Pueblo Alsina",
    distancia_ref: 9,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "ULM",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BHB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BAHIA BLANCA/AEROCLUB",
    coordenadas: "38°40'19\"S  62°21' 9\"W",
    latitud: -62.3525,
    longitud: -38.67194444,
    elev: 15,
    uom_elev: "Metros",
    ref: "Bahia Blanca",
    distancia_ref: 9,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BHT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BRAGADO/HARAS TRELLIRIS",
    coordenadas: "35°19'53\"S  60°34'44\"W",
    latitud: -60.57884,
    longitud: -35.33147,
    elev: 60,
    uom_elev: "Metros",
    ref: "Bragado",
    distancia_ref: 12,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BIO",
    oaci: "SAWT",
    iata: "RYO",
    tipo: "Aerodromo",
    denominacion: "EL TURBIO/28 DE NOVIEMBRE",
    coordenadas: "51°36'18\"S  72°13'13\"W",
    latitud: -72.22034,
    longitud: -51.60502,
    elev: 273,
    uom_elev: "Metros",
    ref: "El Turbio",
    distancia_ref: 10,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "BLA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BALCARCE/EA. LA ALBORADA",
    coordenadas: "37°27'46\"S  58°11'18\"W",
    latitud: -58.18833333,
    longitud: -37.46277778,
    elev: 64,
    uom_elev: "Metros",
    ref: "Balcarce",
    distancia_ref: 43,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BLC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BALCARCE/EA. LOS CARDOS",
    coordenadas: "37°44' 7\"S  58° 2'18\"W",
    latitud: -58.03821,
    longitud: -37.73529,
    elev: 120,
    uom_elev: "Metros",
    ref: "Balcarce",
    distancia_ref: 21,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BLE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BALCARCE/EA. LA ESTRELLA",
    coordenadas: "37°33'34\"S  58°39'58\"W",
    latitud: -58.66611111,
    longitud: -37.55944444,
    elev: 139,
    uom_elev: "Metros",
    ref: "Balcarce",
    distancia_ref: 53,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BLL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MIRAMAR/LAS CORTADERAS",
    coordenadas: "38°21'17\"S  58° 6'31\"W",
    latitud: -58.10861111,
    longitud: -38.35472222,
    elev: 16,
    uom_elev: "Metros",
    ref: "Mechongue",
    distancia_ref: 25,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BLN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LONDRES/BELEN",
    coordenadas: "27°42'29\"S  67° 5'42\"W",
    latitud: -67.095,
    longitud: -27.70805556,
    elev: 1200,
    uom_elev: "Metros",
    ref: "Belen",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CATAMARCA",
    inhab: "NO",
  },
  {
    local: "BLR",
    oaci: "SAZI",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BOLIVAR",
    coordenadas: "36°11'12\"S  61° 4'33\"W",
    latitud: -61.07583333,
    longitud: -36.18666667,
    elev: 94,
    uom_elev: "Metros",
    ref: "San Carlos de Bolivar",
    distancia_ref: 6,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BMO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BRAGADO/MALFATO",
    coordenadas: "35° 9' 6\"S  60°30'20\"W",
    latitud: -60.50555556,
    longitud: -35.15166667,
    elev: 57,
    uom_elev: "Metros",
    ref: "Bragado",
    distancia_ref: 4,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BOE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MORTEROS/AEROBOERO",
    coordenadas: "30°43'51\"S  62° 0'29\"W",
    latitud: -62.00809,
    longitud: -30.73091,
    elev: 96,
    uom_elev: "Metros",
    ref: "Morteros",
    distancia_ref: 1,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "BOG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL BOGADO/FUMIGACIONES CAMPAGNUCCI",
    coordenadas: "33°19'27\"S  60°39'58\"W",
    latitud: -60.66617,
    longitud: -33.32404,
    elev: 48,
    uom_elev: "Metros",
    ref: "Coronel Bogado",
    distancia_ref: 6,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "BOL",
    oaci: "SAVB",
    iata: "EHL",
    tipo: "Aerodromo",
    denominacion: "EL BOLSON",
    coordenadas: "41°56'36\"S  71°31'56\"W",
    latitud: -71.53215,
    longitud: -41.94323,
    elev: 348,
    uom_elev: "Metros",
    ref: "El Bolson",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "BOM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BOMBAL/GRAN ANCONA",
    coordenadas: "33°26'19\"S  61°18'12\"W",
    latitud: -61.30323,
    longitud: -33.43852,
    elev: 97,
    uom_elev: "Metros",
    ref: "Bombal",
    distancia_ref: 3,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "BOS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LOBOS",
    coordenadas: "35°12'39\"S  59° 8'12\"W",
    latitud: -59.13666667,
    longitud: -35.21083333,
    elev: 29,
    uom_elev: "Metros",
    ref: "Lobos",
    distancia_ref: 3,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BPS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BRINKMANN/PABLO SIERRA AEROAPLICACIONES",
    coordenadas: "30°55'46\"S  62° 3' 2\"W",
    latitud: -62.05055556,
    longitud: -30.92944444,
    elev: 100,
    uom_elev: "Metros",
    ref: "Brinckmann",
    distancia_ref: 6.5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "BRA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BRAGADO",
    coordenadas: "35° 8'43\"S  60°28'55\"W",
    latitud: -60.48194444,
    longitud: -35.14527778,
    elev: 60,
    uom_elev: "Metros",
    ref: "Bragado",
    distancia_ref: 2,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BRF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BAHIA BLANCA/LA REFORMA",
    coordenadas: "38°43'50\"S  63°17'14\"W",
    latitud: -63.28722,
    longitud: -38.7305,
    elev: 67,
    uom_elev: "Metros",
    ref: "Bahia Blanca",
    distancia_ref: 88,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "BRQ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BUTA RANQUIL/EL PORTON",
    coordenadas: "37°11'42\"S  69°36'35\"W",
    latitud: -69.60972222,
    longitud: -37.195,
    elev: 870,
    uom_elev: "Metros",
    ref: "Buta Ranquil",
    distancia_ref: 22,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "BTA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BELLA VISTA",
    coordenadas: "28°31'34\"S  59° 2'17\"W",
    latitud: -59.03805556,
    longitud: -28.52611111,
    elev: 55,
    uom_elev: "Metros",
    ref: "Bella Vista",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "BTS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORRAL DE BUSTOS",
    coordenadas: "33°16'53\"S  62° 9' 5\"W",
    latitud: -62.15138889,
    longitud: -33.28138889,
    elev: 120,
    uom_elev: "Metros",
    ref: "Corral de Bustos",
    distancia_ref: 2,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CAF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAFAYATE",
    coordenadas: "26° 3'51\"S  65°55'50\"W",
    latitud: -65.93055556,
    longitud: -26.06416667,
    elev: 1639,
    uom_elev: "Metros",
    ref: "Cafayate",
    distancia_ref: 1,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "CAL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAMPO ARENAL",
    coordenadas: "27° 4'20\"S  66°35'11\"W",
    latitud: -66.58638889,
    longitud: -27.07222222,
    elev: 2324,
    uom_elev: "Metros",
    ref: "Santa Maria",
    distancia_ref: 58,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CATAMARCA",
    inhab: "NO",
  },
  {
    local: "CAM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORRALITO/ALFONSO MENGO",
    coordenadas: "32° 1'28\"S  64°16'46\"W",
    latitud: -64.27944444,
    longitud: -32.02444444,
    elev: 545,
    uom_elev: "Metros",
    ref: "Corralito",
    distancia_ref: 7,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CAT",
    oaci: "SANC",
    iata: "CTC",
    tipo: "Aerodromo",
    denominacion: "CATAMARCA",
    coordenadas: "28°35'35\"S  65°45' 4\"W",
    latitud: -65.75111111,
    longitud: -28.59305556,
    elev: 464,
    uom_elev: "Metros",
    ref: "San Fernando del Valle de Catamarca",
    distancia_ref: 15,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CATAMARCA",
    inhab: "NO",
  },
  {
    local: "CAY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN CAYETANO",
    coordenadas: "38°20' 2\"S  59°37'49\"W",
    latitud: -59.63027778,
    longitud: -38.33388889,
    elev: 100,
    uom_elev: "Metros",
    ref: "San Cayetano",
    distancia_ref: 1.5,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CBA",
    oaci: "SACO",
    iata: "COR",
    tipo: "Aerodromo",
    denominacion: "CORDOBA/ING. AER. A. L. V. TARAVELLA",
    coordenadas: "31°18'36\"S  64°12'30\"W",
    latitud: -64.20833333,
    longitud: -31.31,
    elev: 489,
    uom_elev: "Metros",
    ref: "Cordoba",
    distancia_ref: 9,
    direccion_ref: "NNO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CBB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑADA ROSQUIN/ByB SERVICIOS AGROPECUARIOS",
    coordenadas: "32° 6'42\"S  61°37'55\"W",
    latitud: -61.63196,
    longitud: -32.11159,
    elev: 73,
    uom_elev: "Metros",
    ref: "Cañada Rosquin",
    distancia_ref: 7,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "CBD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CABILDO",
    coordenadas: "38°29'55\"S  61°53' 3\"W",
    latitud: -61.88416667,
    longitud: -38.49861111,
    elev: 159,
    uom_elev: "Metros",
    ref: "Cabildo",
    distancia_ref: 1.5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CCA",
    oaci: "SATU",
    iata: "UZU",
    tipo: "Aerodromo",
    denominacion: "CURUZU CUATIA",
    coordenadas: "29°46'21\"S  57°58'58\"W",
    latitud: -57.98277778,
    longitud: -29.7725,
    elev: 70,
    uom_elev: "Metros",
    ref: "Curuzu Cuatia",
    distancia_ref: 4,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "CCH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARLOS CASARES/HAYDEE",
    coordenadas: "35°40'12\"S  61°24'20\"W",
    latitud: -61.405525,
    longitud: -35.6698945,
    elev: 82,
    uom_elev: "Metros",
    ref: "Carlos Casares",
    distancia_ref: 6,
    direccion_ref: "SW",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CCI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CALCHAQUI",
    coordenadas: "29°51' 6\"S  60°17'31\"W",
    latitud: -60.29201667,
    longitud: -29.85157222,
    elev: 56,
    uom_elev: "Metros",
    ref: "Calchaqui",
    distancia_ref: 4,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "CCM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARLOS CASARES/MALATINI",
    coordenadas: "35°34' 9\"S  61°22' 6\"W",
    latitud: -61.36821,
    longitud: -35.56915,
    elev: 82,
    uom_elev: "Metros",
    ref: "Carlos Casares",
    distancia_ref: 6,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CCO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARLOS CASARES/OTTAVIANI",
    coordenadas: "35°38'53\"S  61°21' 1\"W",
    latitud: -61.35038,
    longitud: -35.64817,
    elev: 82,
    uom_elev: "Metros",
    ref: "Carlos Casares",
    distancia_ref: 2,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CCP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CONCEPCION",
    coordenadas: "27°20'41\"S  65°37' 1\"W",
    latitud: -65.61694444,
    longitud: -27.34472222,
    elev: 386,
    uom_elev: "Metros",
    ref: "Concepcion",
    distancia_ref: 2.4,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TUCUMAN",
    inhab: "NO",
  },
  {
    local: "CCS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CACHI",
    coordenadas: "25° 6'19\"S  66° 9'26\"W",
    latitud: -66.1572,
    longitud: -25.10518,
    elev: 2510,
    uom_elev: "Metros",
    ref: "Cachi",
    distancia_ref: 2,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "CDA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SARGENTO CABRAL/CONDOR DEL AIRE",
    coordenadas: "33°27'57\"S  60°37'43\"W",
    latitud: -60.62857,
    longitud: -33.46586,
    elev: 56,
    uom_elev: "Metros",
    ref: "Sargento Cabral",
    distancia_ref: 4,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "CDI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARCARAÑA/DI GIUSEPPE",
    coordenadas: "32°53'28\"S  61° 7'27\"W",
    latitud: -61.12414,
    longitud: -32.89099,
    elev: 89,
    uom_elev: "Metros",
    ref: "Carcaraña",
    distancia_ref: 5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "CDL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑADA DE LUQUE/BIONDI",
    coordenadas: "30°45'28\"S  63°44'53\"W",
    latitud: -63.74818,
    longitud: -30.75769,
    elev: 249,
    uom_elev: "Metros",
    ref: "Cañada de Luque",
    distancia_ref: 3,
    direccion_ref: "SW",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CDS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑADON SECO",
    coordenadas: "46°32'17\"S  67°33'35\"W",
    latitud: -67.55972222,
    longitud: -46.53805556,
    elev: 90,
    uom_elev: "Metros",
    ref: "Cañadon Seco",
    distancia_ref: 5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "CDU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CONCEPCION DEL URUGUAY",
    coordenadas: "32°27'18\"S  58°18'24\"W",
    latitud: -58.30666667,
    longitud: -32.455,
    elev: 34,
    uom_elev: "Metros",
    ref: "Concepcion del Uruguay",
    distancia_ref: 8,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "CED",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MERCEDES",
    coordenadas: "33°38'32\"S  65°25'14\"W",
    latitud: -65.42051,
    longitud: -33.6422,
    elev: 515,
    uom_elev: "Metros",
    ref: "Villa Mercedes",
    distancia_ref: 3,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "CEJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS CEJAS/AGROALAS SRL",
    coordenadas: "26°52'11\"S  64°44'45\"W",
    latitud: -64.74583333,
    longitud: -26.86972222,
    elev: 346,
    uom_elev: "Metros",
    ref: "Las Cejas",
    distancia_ref: 2,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TUCUMAN",
    inhab: "NO",
  },
  {
    local: "CFU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARHUE/FUMAGRO",
    coordenadas: "37°12'53\"S  62°46'50\"W",
    latitud: -62.78055556,
    longitud: -37.21472222,
    elev: 111,
    uom_elev: "Metros",
    ref: "Carhue",
    distancia_ref: 5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CHA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHARATA",
    coordenadas: "27°12'59\"S  61°12'36\"W",
    latitud: -61.21011,
    longitud: -27.21639,
    elev: 92,
    uom_elev: "Metros",
    ref: "Charata",
    distancia_ref: 10,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "CHC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHAJARI/EA. LA CHOZA",
    coordenadas: "30°32'20\"S  58°17'34\"W",
    latitud: -58.29287,
    longitud: -30.53899,
    elev: 72,
    uom_elev: "Metros",
    ref: "Chajari",
    distancia_ref: 39,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "CHJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHAJARI",
    coordenadas: "30°45'14\"S  58° 0' 0\"W",
    latitud: -58.00002,
    longitud: -30.7539,
    elev: 53,
    uom_elev: "Metros",
    ref: "Chajari",
    distancia_ref: 1.5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "CHM",
    oaci: "SAHC",
    iata: "HOS",
    tipo: "Aerodromo",
    denominacion: "CHOS MALAL",
    coordenadas: "37°26'39\"S  70°13'23\"W",
    latitud: -70.22305556,
    longitud: -37.44416667,
    elev: 850,
    uom_elev: "Metros",
    ref: "Chos Malal",
    distancia_ref: 10,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "CHO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHOLILA",
    coordenadas: "42°28'50\"S  71°27'25\"W",
    latitud: -71.45682,
    longitud: -42.4806,
    elev: 574,
    uom_elev: "Metros",
    ref: "Cholila",
    distancia_ref: 4,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "CHP",
    oaci: "SAZY",
    iata: "CPC",
    tipo: "Aerodromo",
    denominacion: "SAN MARTIN DE LOS ANDES/AVIADOR C. CAMPOS",
    coordenadas: "40° 4'31\"S  71° 8'14\"W",
    latitud: -71.13722222,
    longitud: -40.07527778,
    elev: 783,
    uom_elev: "Metros",
    ref: "San Martin de los Andes",
    distancia_ref: 20,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "CHR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHACHARRAMENDI",
    coordenadas: "37°20'24\"S  65°38'49\"W",
    latitud: -65.64701,
    longitud: -37.34005,
    elev: 290,
    uom_elev: "Metros",
    ref: "Chacharramendi",
    distancia_ref: 0.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "CHT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHARATA/EL GRINGO",
    coordenadas: "27°18'23\"S  61°12'37\"W",
    latitud: -61.21041,
    longitud: -27.30629,
    elev: 92,
    uom_elev: "Metros",
    ref: "Charata",
    distancia_ref: 10,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "CHY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHIVILCOY",
    coordenadas: "34°57'45\"S  60° 1'56\"W",
    latitud: -60.03222222,
    longitud: -34.9625,
    elev: 53,
    uom_elev: "Metros",
    ref: "Chivilcoy",
    distancia_ref: 7,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CIF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ARRECIFES/AEROCLUB",
    coordenadas: "34° 4'43\"S  60° 2'46\"W",
    latitud: -60.04602,
    longitud: -34.07849,
    elev: 43,
    uom_elev: "Metros",
    ref: "Arrecifes",
    distancia_ref: 4.5,
    direccion_ref: "ESE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CII",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORRIENTES/ITA IBATE",
    coordenadas: "27°26'54\"S  57°25'20\"W",
    latitud: -57.42222222,
    longitud: -27.44833333,
    elev: 68,
    uom_elev: "Metros",
    ref: "Ita Ibate",
    distancia_ref: 8,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "CIP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CIPOLLETTI/AEROCLUB",
    coordenadas: "38°53'34\"S  67°59'20\"W",
    latitud: -67.98888889,
    longitud: -38.89277778,
    elev: 270,
    uom_elev: "Metros",
    ref: "Cipolletti",
    distancia_ref: 5.5,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "CIT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORRIENTES/ITATI",
    coordenadas: "27°18'12\"S  58°18'55\"W",
    latitud: -58.31527778,
    longitud: -27.30333333,
    elev: 60,
    uom_elev: "Metros",
    ref: "Itati",
    distancia_ref: 8,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "CLD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHAÑAR LADEADO",
    coordenadas: "33°20'21\"S  62° 2'13\"W",
    latitud: -62.03693,
    longitud: -33.3391,
    elev: 112,
    uom_elev: "Metros",
    ref: "Chañar Ladeado",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "CLE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORRALITO/LOMAS DEL ESPINILLO",
    coordenadas: "32° 5'17\"S  64°10'11\"W",
    latitud: -64.16972222,
    longitud: -32.08805556,
    elev: 439.5,
    uom_elev: "Metros",
    ref: "Rio Tercero",
    distancia_ref: 9,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CLH",
    oaci: "SAVH",
    iata: "LHS",
    tipo: "Aerodromo",
    denominacion: "LAS HERAS",
    coordenadas: "46°32'19\"S  68°57'57\"W",
    latitud: -68.96583,
    longitud: -46.53848,
    elev: 330,
    uom_elev: "Metros",
    ref: "Las Heras",
    distancia_ref: 2,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "CLI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CALILEGUA",
    coordenadas: "23°46'54\"S  64°44'59\"W",
    latitud: -64.74972222,
    longitud: -23.78166667,
    elev: 442,
    uom_elev: "Metros",
    ref: "Calilegua",
    distancia_ref: 1.7,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "JUJUY",
    inhab: "NO",
  },
  {
    local: "CLN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "COLON",
    coordenadas: "32°15'39\"S  58° 9'22\"W",
    latitud: -58.15611111,
    longitud: -32.26083333,
    elev: 20,
    uom_elev: "Metros",
    ref: "Colon",
    distancia_ref: 5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "CLT",
    oaci: "",
    iata: "CCT",
    tipo: "Aerodromo",
    denominacion: "COLONIA CATRIEL",
    coordenadas: "37°54'29\"S  67°49'44\"W",
    latitud: -67.82881,
    longitud: -37.90819,
    elev: 313,
    uom_elev: "Metros",
    ref: "Catriel",
    distancia_ref: 4,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "CNA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑUELAS",
    coordenadas: "35° 6'42\"S  58°43'35\"W",
    latitud: -58.72638889,
    longitud: -35.11166667,
    elev: 30,
    uom_elev: "Metros",
    ref: "Cañuelas",
    distancia_ref: 5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CNO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARMEN DE ARECO",
    coordenadas: "34°25' 5\"S  59°52'28\"W",
    latitud: -59.87444444,
    longitud: -34.41805556,
    elev: 49,
    uom_elev: "Metros",
    ref: "Carmen de Areco",
    distancia_ref: 5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CNS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CANALS",
    coordenadas: "33°33'45\"S  62°52' 9\"W",
    latitud: -62.86911,
    longitud: -33.56247,
    elev: 116,
    uom_elev: "Metros",
    ref: "Canals",
    distancia_ref: 0.5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "COA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ARIAS",
    coordenadas: "33°39'52\"S  62°22'30\"W",
    latitud: -62.37505556,
    longitud: -33.66431111,
    elev: 121.5,
    uom_elev: "Metros",
    ref: "Arias",
    distancia_ref: 3,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "COL",
    oaci: "SAZQ",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIO COLORADO",
    coordenadas: "38°59'42\"S  64° 8'25\"W",
    latitud: -64.14027778,
    longitud: -38.995,
    elev: 84,
    uom_elev: "Metros",
    ref: "Rio Colorado",
    distancia_ref: 5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "CON",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "COLON",
    coordenadas: "33°55'21\"S  61° 2'47\"W",
    latitud: -61.04638889,
    longitud: -33.9225,
    elev: 90,
    uom_elev: "Metros",
    ref: "Colon",
    distancia_ref: 5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CPO",
    oaci: "SADO",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAMPO DE MAYO",
    coordenadas: "34°32' 4\"S  58°40'19\"W",
    latitud: -58.672,
    longitud: -34.53433,
    elev: 24,
    uom_elev: "Metros",
    ref: "Estacion San Miguel",
    distancia_ref: 3.5,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "MIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CQN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "COSQUIN/SANTA MARIA",
    coordenadas: "31°17' 9\"S  64°27'20\"W",
    latitud: -64.45555556,
    longitud: -31.28583333,
    elev: 700,
    uom_elev: "Metros",
    ref: "Cosquin",
    distancia_ref: 4.5,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CQZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑADA QUIROZ",
    coordenadas: "27°32'59\"S  58°43' 3\"W",
    latitud: -58.7175,
    longitud: -27.54972222,
    elev: 55,
    uom_elev: "Metros",
    ref: "Corrientes",
    distancia_ref: 15,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "CRD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CONCORDIA/AEROCLUB",
    coordenadas: "31°18'14\"S  58° 0'54\"W",
    latitud: -58.015,
    longitud: -31.30388889,
    elev: 90,
    uom_elev: "Metros",
    ref: "Concordia",
    distancia_ref: 10,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "CRR",
    oaci: "SARC",
    iata: "CNQ",
    tipo: "Aerodromo",
    denominacion: "CORRIENTES",
    coordenadas: "27°26'44\"S  58°45'43\"W",
    latitud: -58.76194444,
    longitud: -27.44555556,
    elev: 61.5,
    uom_elev: "Metros",
    ref: "Corrientes",
    distancia_ref: 7.5,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "CRV",
    oaci: "SAVC",
    iata: "CRD",
    tipo: "Aerodromo",
    denominacion: "COMODORO RIVADAVIA/GRAL. E. MOSCONI",
    coordenadas: "45°47' 7\"S  67°27'56\"W",
    latitud: -67.46555556,
    longitud: -45.78527778,
    elev: 57.6,
    uom_elev: "Metros",
    ref: "Comodoro Rivadavia",
    distancia_ref: 11,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "JOINT",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "CSA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CALCHIN/AEROCAMPO SERVICIOS AEREOS",
    coordenadas: "31°39'27\"S  63°16'34\"W",
    latitud: -63.27608,
    longitud: -31.65737,
    elev: 202,
    uom_elev: "Metros",
    ref: "Calchin",
    distancia_ref: 5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CSJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MORTEROS/CAMPO SAN JOSE",
    coordenadas: "30°46'37\"S  62° 0'53\"W",
    latitud: -62.01466,
    longitud: -30.77697,
    elev: 101,
    uom_elev: "Metros",
    ref: "Morteros",
    distancia_ref: 6,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CSP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAPITAN SARMIENTO/SAN PATRICIO",
    coordenadas: "34° 2'25\"S  59°41'40\"W",
    latitud: -59.69444444,
    longitud: -34.04027778,
    elev: 45,
    uom_elev: "Metros",
    ref: "Capitan Sarmiento",
    distancia_ref: 16.7,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CSQ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAPITAN SARMIENTO/QUEBRACHO HERRADO",
    coordenadas: "34° 9'22\"S  59°52'24\"W",
    latitud: -59.87336,
    longitud: -34.15622,
    elev: 52,
    uom_elev: "Metros",
    ref: "Capitan Sarmiento",
    distancia_ref: 8,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CSR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARLOS CASARES",
    coordenadas: "35°37'47\"S  61°23'38\"W",
    latitud: -61.39401,
    longitud: -35.6298,
    elev: 80,
    uom_elev: "Metros",
    ref: "Carlos Casares",
    distancia_ref: 2,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CSU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHAJARI/SUR",
    coordenadas: "30°48' 8\"S  58° 0'51\"W",
    latitud: -58.01428056,
    longitud: -30.80216944,
    elev: 69,
    uom_elev: "Metros",
    ref: "Chajari",
    distancia_ref: 5,
    direccion_ref: "SSW",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "CTA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "COPETONAS",
    coordenadas: "38°44'37\"S  60°33'12\"W",
    latitud: -60.55343,
    longitud: -38.74354,
    elev: 51,
    uom_elev: "Metros",
    ref: "Copetonas",
    distancia_ref: 9,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CTP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CATRILO/ESTABLECIMIENTO LA MARIA PILAR",
    coordenadas: "36°29'19\"S  63°25'59\"W",
    latitud: -63.43305556,
    longitud: -36.48861111,
    elev: 125,
    uom_elev: "Metros",
    ref: "Catrilo",
    distancia_ref: 9,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "CTS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAPITAN SARMIENTO",
    coordenadas: "34° 9'52\"S  59°43'53\"W",
    latitud: -59.73148,
    longitud: -34.16435,
    elev: 49,
    uom_elev: "Metros",
    ref: "Capitan Sarmiento",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "CUA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIO CUARTO/AEROCLUB",
    coordenadas: "33° 9'38\"S  64°20'14\"W",
    latitud: -64.33722222,
    longitud: -33.16055556,
    elev: 424,
    uom_elev: "Metros",
    ref: "Rio Cuarto",
    distancia_ref: 4,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CUM",
    oaci: "SACC",
    iata: "LCM",
    tipo: "Aerodromo",
    denominacion: "LA CUMBRE",
    coordenadas: "31° 0'21\"S  64°31'56\"W",
    latitud: -64.5321,
    longitud: -31.00589,
    elev: 1138,
    uom_elev: "Metros",
    ref: "La Cumbre",
    distancia_ref: 4.5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CUT",
    oaci: "SAZW",
    iata: "CUT",
    tipo: "Aerodromo",
    denominacion: "CUTRAL-CO",
    coordenadas: "38°56'23\"S  69°15'54\"W",
    latitud: -69.265,
    longitud: -38.93972222,
    elev: 650,
    uom_elev: "Metros",
    ref: "Cutral Co",
    distancia_ref: 2,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "CVV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA VALERIA",
    coordenadas: "34°21'23\"S  64°54' 4\"W",
    latitud: -64.90111111,
    longitud: -34.35638889,
    elev: 290,
    uom_elev: "Metros",
    ref: "Villa Valeria",
    distancia_ref: 2,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "CZU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CURUZU CUATIA/AEROCLUB",
    coordenadas: "29°46'44\"S  58° 5'49\"W",
    latitud: -58.09694444,
    longitud: -29.77888889,
    elev: 80,
    uom_elev: "Metros",
    ref: "Curuzu Cuatia",
    distancia_ref: 1.5,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "DAR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "DARREGUEIRA",
    coordenadas: "37°42'44\"S  63° 9'45\"W",
    latitud: -63.16253,
    longitud: -37.7122,
    elev: 198,
    uom_elev: "Metros",
    ref: "Darregueira",
    distancia_ref: 1.5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DFR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "DAIREAUX/FUMIGACIONES RODRIGUEZ",
    coordenadas: "36°35'27\"S  61°46'30\"W",
    latitud: -61.77504,
    longitud: -36.59076,
    elev: 113,
    uom_elev: "Metros",
    ref: "Daireaux",
    distancia_ref: 2,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DIA",
    oaci: "SAAC",
    iata: "COC",
    tipo: "Aerodromo",
    denominacion: "CONCORDIA/COMODORO PIERRESTEGUI",
    coordenadas: "31°17'49\"S  57°59'48\"W",
    latitud: -57.99666667,
    longitud: -31.29694444,
    elev: 34,
    uom_elev: "Metros",
    ref: "Concordia",
    distancia_ref: 12,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "DIL",
    oaci: "SAZT",
    iata: "TDL",
    tipo: "Aerodromo",
    denominacion: "TANDIL/HEROES DE MALVINAS",
    coordenadas: "37°14' 4\"S  59°13'43\"W",
    latitud: -59.22858611,
    longitud: -37.23437778,
    elev: 175,
    uom_elev: "Metros",
    ref: "Tandil",
    distancia_ref: 13,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DIO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TANDIL/COMANDANTE EDUARDO A. OLIVERO",
    coordenadas: "37°20'48\"S  58°58'58\"W",
    latitud: -58.98268,
    longitud: -37.34678,
    elev: 193,
    uom_elev: "Metros",
    ref: "Tandil",
    distancia_ref: 15,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DOF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MARTINEZ DE HOZ/FUMIGACIONES ORTEGA",
    coordenadas: "35°16'41\"S  61°33'13\"W",
    latitud: -61.55366,
    longitud: -35.27799,
    elev: 89,
    uom_elev: "Metros",
    ref: "Coronel Martinez de Hoz",
    distancia_ref: 8,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DOL",
    oaci: "SAZD",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "DOLORES",
    coordenadas: "36°19'12\"S  57°43'14\"W",
    latitud: -57.72055556,
    longitud: -36.32,
    elev: 10,
    uom_elev: "Metros",
    ref: "Dolores",
    distancia_ref: 4,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DOP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MENDOZA/LA PUNTILLA",
    coordenadas: "32°57'45\"S  68°52'26\"W",
    latitud: -68.87395,
    longitud: -32.96254,
    elev: 942,
    uom_elev: "Metros",
    ref: "Ap. El Plumerillo",
    distancia_ref: 8.5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "DOR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL DORREGO",
    coordenadas: "38°44'28\"S  61°15'21\"W",
    latitud: -61.25583333,
    longitud: -38.74111111,
    elev: 120,
    uom_elev: "Metros",
    ref: "Coronel Dorrego",
    distancia_ref: 2,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DOZ",
    oaci: "SAME",
    iata: "MDZ",
    tipo: "Aerodromo",
    denominacion: "MENDOZA/EL PLUMERILLO",
    coordenadas: "32°49'54\"S  68°47'34\"W",
    latitud: -68.79277778,
    longitud: -32.83166667,
    elev: 704,
    uom_elev: "Metros",
    ref: "Mendoza",
    distancia_ref: 8,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "DRA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAAVEDRA",
    coordenadas: "37°44'59\"S  62°20' 2\"W",
    latitud: -62.33392,
    longitud: -37.74961,
    elev: 317,
    uom_elev: "Metros",
    ref: "Saavedra",
    distancia_ref: 3,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DRX",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "DAIREAUX",
    coordenadas: "36°34'58\"S  61°47' 3\"W",
    latitud: -61.78416667,
    longitud: -36.58277778,
    elev: 116,
    uom_elev: "Metros",
    ref: "Daireaux",
    distancia_ref: 3.5,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "DRY",
    oaci: "SAVY",
    iata: "PMY",
    tipo: "Aerodromo",
    denominacion: "PUERTO MADRYN/EL TEHUELCHE",
    coordenadas: "42°45'33\"S  65° 6'10\"W",
    latitud: -65.10277778,
    longitud: -42.75916667,
    elev: 130,
    uom_elev: "Metros",
    ref: "Puerto Madryn",
    distancia_ref: 5.3,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "DTE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "DIAMANTE",
    coordenadas: "32° 0'58\"S  60°34'60\"W",
    latitud: -60.58329,
    longitud: -32.01621,
    elev: 75,
    uom_elev: "Metros",
    ref: "Diamante",
    distancia_ref: 4.5,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "EAU",
    oaci: "SAWO",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "USHUAIA/EST. AERONAVAL",
    coordenadas: "54°49'22\"S  68°18'15\"W",
    latitud: -68.30416667,
    longitud: -54.82277778,
    elev: 6,
    uom_elev: "Metros",
    ref: "Ushuaia",
    distancia_ref: 1,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "EBF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ESPERANZA/ANIBAL BRIZI",
    coordenadas: "31°24'20\"S  60°53'58\"W",
    latitud: -60.89944444,
    longitud: -31.40555556,
    elev: 39,
    uom_elev: "Metros",
    ref: "Esperanza",
    distancia_ref: 1.5,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ECA",
    oaci: "SAWC",
    iata: "FTE",
    tipo: "Aerodromo",
    denominacion: "EL CALAFATE",
    coordenadas: "50°16'48\"S  72° 3'11\"W",
    latitud: -72.05305556,
    longitud: -50.28,
    elev: 204,
    uom_elev: "Metros",
    ref: "El Calafate",
    distancia_ref: 16.6,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "ECX",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EDUARDO CASTEX",
    coordenadas: "35°52'56\"S  64°16'30\"W",
    latitud: -64.275,
    longitud: -35.88222222,
    elev: 183,
    uom_elev: "Metros",
    ref: "Eduardo Castex",
    distancia_ref: 4.5,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "EDO",
    oaci: "SACD",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL OLMEDO",
    coordenadas: "31°29'12\"S  64° 8'27\"W",
    latitud: -64.14083,
    longitud: -31.48679,
    elev: 432,
    uom_elev: "Metros",
    ref: "Coronel Olmedo",
    distancia_ref: 1.2,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "EGO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS PAREJAS/EL GAUCHO",
    coordenadas: "32°37'46\"S  61°32'40\"W",
    latitud: -61.54444444,
    longitud: -32.62944444,
    elev: 105,
    uom_elev: "Metros",
    ref: "Las Parejas",
    distancia_ref: 6,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ELC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VEINTICINCO DE MAYO/ESTANCIA LA CRIOLLA",
    coordenadas: "35°32'12\"S  60° 7'45\"W",
    latitud: -60.12916667,
    longitud: -35.53666667,
    elev: 48,
    uom_elev: "Metros",
    ref: "25 de Mayo",
    distancia_ref: 12,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ELD",
    oaci: "SATD",
    iata: "ELO",
    tipo: "Aerodromo",
    denominacion: "ELDORADO",
    coordenadas: "26°23'49\"S  54°34'29\"W",
    latitud: -54.57472222,
    longitud: -26.39694444,
    elev: 209,
    uom_elev: "Metros",
    ref: "Eldorado",
    distancia_ref: 5,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "ELL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MAR DEL SUR/EA. LUCILA",
    coordenadas: "38°18'31\"S  58° 6'18\"W",
    latitud: -58.105,
    longitud: -38.30861111,
    elev: 22,
    uom_elev: "Metros",
    ref: "Mar del Sur",
    distancia_ref: 5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ELP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANTA ROSA/EL PAMPERO",
    coordenadas: "36°35'50\"S  64°11'12\"W",
    latitud: -64.18672,
    longitud: -36.59712,
    elev: 178,
    uom_elev: "Metros",
    ref: "Santa Rosa",
    distancia_ref: 10,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "ELZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ELIZALDE",
    coordenadas: "34°58'30\"S  57°57'45\"W",
    latitud: -57.9625,
    longitud: -34.975,
    elev: 7,
    uom_elev: "Metros",
    ref: "Rufino de Elizalde",
    distancia_ref: 2,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "EMA",
    oaci: "SAVD",
    iata: "EMX",
    tipo: "Aerodromo",
    denominacion: "EL MAITEN",
    coordenadas: "42° 1'48\"S  71°10'15\"W",
    latitud: -71.17083333,
    longitud: -42.03,
    elev: 718,
    uom_elev: "Metros",
    ref: "El Maiten",
    distancia_ref: 3,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "EML",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL BRANDSEN/EL MANANTIAL",
    coordenadas: "35°11'40\"S  58°21'36\"W",
    latitud: -58.35994,
    longitud: -35.19441,
    elev: 15,
    uom_elev: "Metros",
    ref: "Coronel Brandsen",
    distancia_ref: 12.5,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ENO",
    oaci: "SADJ",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MARIANO MORENO",
    coordenadas: "34°33'36\"S  58°47'23\"W",
    latitud: -58.78972222,
    longitud: -34.56,
    elev: 32,
    uom_elev: "Metros",
    ref: "Jose C. Paz",
    distancia_ref: 7,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ENV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIACHUELO/NUEVA VALENCIA",
    coordenadas: "27°35'15\"S  58°49' 8\"W",
    latitud: -58.819,
    longitud: -27.58744,
    elev: 57,
    uom_elev: "Metros",
    ref: "Corrientes",
    distancia_ref: 13.5,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "EPZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ESPERANZA",
    coordenadas: "31°28'24\"S  60°50'43\"W",
    latitud: -60.84527778,
    longitud: -31.47333333,
    elev: 38,
    uom_elev: "Metros",
    ref: "Esperanza",
    distancia_ref: 8,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ERE",
    oaci: "SANW",
    iata: "CRR",
    tipo: "Aerodromo",
    denominacion: "CERES",
    coordenadas: "29°52'18\"S  61°55'37\"W",
    latitud: -61.92696,
    longitud: -29.87161,
    elev: 87,
    uom_elev: "Metros",
    ref: "Ceres",
    distancia_ref: 0.7,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ERT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA MERCEDES/EA. DON ROBERTO",
    coordenadas: "34° 0' 4\"S  65°21'60\"W",
    latitud: -65.36657,
    longitud: -34.0011,
    elev: 436,
    uom_elev: "Metros",
    ref: "Villa Mercedes",
    distancia_ref: 37,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "ESN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ESQUINA",
    coordenadas: "30° 2'51\"S  59°32' 7\"W",
    latitud: -59.53521,
    longitud: -30.04762,
    elev: 39,
    uom_elev: "Metros",
    ref: "Esquina",
    distancia_ref: 4,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "ESQ",
    oaci: "SAVE",
    iata: "EQS",
    tipo: "Aerodromo",
    denominacion: "ESQUEL/BRIGADIER GENERAL ANTONIO PARODI",
    coordenadas: "42°54'14\"S  71° 8' 8\"W",
    latitud: -71.13554,
    longitud: -42.90381,
    elev: 799,
    uom_elev: "Metros",
    ref: "Esquel",
    distancia_ref: 12,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "ESR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EL ESPINILLO/ESTANCIA SAN RAFAEL",
    coordenadas: "25° 2'36\"S  58°35'29\"W",
    latitud: -58.59132,
    longitud: -25.04338,
    elev: 88,
    uom_elev: "Metros",
    ref: "El Espinillo",
    distancia_ref: 8,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "FORMOSA",
    inhab: "NO",
  },
  {
    local: "ETB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EL TREBOL",
    coordenadas: "32°12'58\"S  61°42'59\"W",
    latitud: -61.71634,
    longitud: -32.2162,
    elev: 92,
    uom_elev: "Metros",
    ref: "El Trebol",
    distancia_ref: 5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "EVC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GDOR. VALENTIN VIRASORO/EA. VILLA CORINA",
    coordenadas: "28° 2'28\"S  56° 4'16\"W",
    latitud: -56.07106,
    longitud: -28.04099,
    elev: 123,
    uom_elev: "Metros",
    ref: "Gobernador Valentin Virasoro",
    distancia_ref: 5,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "EZA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LOS CONQUISTADORES/BUENA ESPERANZA",
    coordenadas: "30°31'14\"S  58°23'59\"W",
    latitud: -58.39961,
    longitud: -30.52042,
    elev: 75,
    uom_elev: "Metros",
    ref: "Los Conquistadores",
    distancia_ref: 8,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "EZE",
    oaci: "SAEZ",
    iata: "EZE",
    tipo: "Aerodromo",
    denominacion: "EZEIZA/MINISTRO PISTARINI",
    coordenadas: "34°49'20\"S  58°32' 9\"W",
    latitud: -58.53583333,
    longitud: -34.82222222,
    elev: 20.5,
    uom_elev: "Metros",
    ref: "Capital Federal",
    distancia_ref: 22,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "EZP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EZPELETA",
    coordenadas: "34°44'47\"S  58°12'12\"W",
    latitud: -58.20333333,
    longitud: -34.74638889,
    elev: 3,
    uom_elev: "Metros",
    ref: "Ezpeleta",
    distancia_ref: 3,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "FAE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FIRMAT/AEROCLUB",
    coordenadas: "33°25'45\"S  61°30'40\"W",
    latitud: -61.51124,
    longitud: -33.42909,
    elev: 105,
    uom_elev: "Metros",
    ref: "Firmat",
    distancia_ref: 3,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "FAG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FEDERAL/LA ANGELITA",
    coordenadas: "30°51' 8\"S  58°42'24\"W",
    latitud: -58.70666667,
    longitud: -30.85222222,
    elev: 70,
    uom_elev: "Metros",
    ref: "Federal",
    distancia_ref: 13,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "FDD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FORTIN DRAGONES/EL DESAFIO",
    coordenadas: "23°14'33\"S  63°19'23\"W",
    latitud: -63.32305556,
    longitud: -23.2425,
    elev: 244,
    uom_elev: "Metros",
    ref: "Dragones",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "FDO",
    oaci: "SADF",
    iata: "FDO",
    tipo: "Aerodromo",
    denominacion: "SAN FERNANDO",
    coordenadas: "34°27'16\"S  58°35'27\"W",
    latitud: -58.59091,
    longitud: -34.45454,
    elev: 3,
    uom_elev: "Metros",
    ref: "San Fernando",
    distancia_ref: 2,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "FIM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FIRMAT",
    coordenadas: "33°28' 5\"S  61°30' 4\"W",
    latitud: -61.50111111,
    longitud: -33.46805556,
    elev: 105,
    uom_elev: "Metros",
    ref: "Firmat",
    distancia_ref: 1.7,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "FLO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS FLORES",
    coordenadas: "36° 3'59\"S  59° 6' 2\"W",
    latitud: -59.10055556,
    longitud: -36.06638889,
    elev: 34,
    uom_elev: "Metros",
    ref: "Las Flores",
    distancia_ref: 5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "FMA",
    oaci: "SACA",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORDOBA/CAPITAN D. OMAR DARIO GELARDI",
    coordenadas: "31°26'31\"S  64°15'30\"W",
    latitud: -64.25847,
    longitud: -31.44195,
    elev: 486,
    uom_elev: "Metros",
    ref: "Cordoba",
    distancia_ref: 7,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANO",
    fir: "SACF",
    uso: "MIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "FOR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FORMOSA/AEROCLUB",
    coordenadas: "26°18' 5\"S  58°17'54\"W",
    latitud: -58.29833333,
    longitud: -26.30138889,
    elev: 70,
    uom_elev: "Metros",
    ref: "Formosa",
    distancia_ref: 15,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "FORMOSA",
    inhab: "NO",
  },
  {
    local: "FRA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN FRANCISCO",
    coordenadas: "31°24'47\"S  62° 7'59\"W",
    latitud: -62.13305556,
    longitud: -31.41305556,
    elev: 114,
    uom_elev: "Metros",
    ref: "San Francisco",
    distancia_ref: 5,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "FRO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ROSARIO DE LA FRONTERA",
    coordenadas: "25°49'34\"S  64°57'48\"W",
    latitud: -64.96323,
    longitud: -25.82616,
    elev: 837,
    uom_elev: "Metros",
    ref: "Rosario de la Frontera",
    distancia_ref: 3.6,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "FRS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FRIAS",
    coordenadas: "28°37'43\"S  65° 6'48\"W",
    latitud: -65.11333333,
    longitud: -28.62861111,
    elev: 330,
    uom_elev: "Metros",
    ref: "Frias",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "FSA",
    oaci: "SARF",
    iata: "FMA",
    tipo: "Aerodromo",
    denominacion: "FORMOSA",
    coordenadas: "26°12'46\"S  58°13'41\"W",
    latitud: -58.22805556,
    longitud: -26.21277778,
    elev: 59,
    uom_elev: "Metros",
    ref: "Formosa",
    distancia_ref: 7,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "FORMOSA",
    inhab: "NO",
  },
  {
    local: "FUN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "DEAN FUNES",
    coordenadas: "30°22'46\"S  64°22'47\"W",
    latitud: -64.37973,
    longitud: -30.37934,
    elev: 689,
    uom_elev: "Metros",
    ref: "Dean Funes",
    distancia_ref: 4.5,
    direccion_ref: "NNO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "FVA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FLORENCIO VARELA/EL PAJARO",
    coordenadas: "34°49'36\"S  58°19' 0\"W",
    latitud: -58.31666667,
    longitud: -34.82666667,
    elev: 16,
    uom_elev: "Metros",
    ref: "Florencio Varela",
    distancia_ref: 3.5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GAA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GUALEGUAY/AGROAEREO GUALEGUAY",
    coordenadas: "33° 2'18\"S  59°26'24\"W",
    latitud: -59.43992,
    longitud: -33.03832,
    elev: 16,
    uom_elev: "Metros",
    ref: "Gualeguay",
    distancia_ref: 17,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "GAI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GANCEDO/AGROAIRE",
    coordenadas: "27°29'41\"S  61°39'32\"W",
    latitud: -61.65877,
    longitud: -27.49486,
    elev: 115,
    uom_elev: "Metros",
    ref: "Gancedo",
    distancia_ref: 1,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "GAL",
    oaci: "SAWG",
    iata: "RGL",
    tipo: "Aerodromo",
    denominacion: "RIO GALLEGOS/PILOTO CIVIL NORBERTO FERNANDEZ",
    coordenadas: "51°36'32\"S  69°18'44\"W",
    latitud: -69.31217,
    longitud: -51.60881,
    elev: 19,
    uom_elev: "Metros",
    ref: "Rio Gallegos",
    distancia_ref: 4.5,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "GAR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL ALVEAR",
    coordenadas: "35°58'44\"S  59°54'25\"W",
    latitud: -59.90699,
    longitud: -35.97895,
    elev: 50,
    uom_elev: "Metros",
    ref: "General Alvear",
    distancia_ref: 11.5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GAS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL VILLEGAS",
    coordenadas: "34°59'46\"S  62°59'56\"W",
    latitud: -62.99883,
    longitud: -34.99615,
    elev: 117,
    uom_elev: "Metros",
    ref: "General Villegas",
    distancia_ref: 4.5,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GBE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL BELGRANO",
    coordenadas: "35°45' 7\"S  58°27'48\"W",
    latitud: -58.46327,
    longitud: -35.75191,
    elev: 12,
    uom_elev: "Metros",
    ref: "General Belgrano",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GBL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALTA/GENERAL BELGRANO",
    coordenadas: "24°44'45\"S  65°25' 8\"W",
    latitud: -65.41888889,
    longitud: -24.74583333,
    elev: 1261,
    uom_elev: "Metros",
    ref: "Salta",
    distancia_ref: 3,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "GCR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GOBERNADOR CRESPO/AEROCLUB",
    coordenadas: "30°23'14\"S  60°22' 9\"W",
    latitud: -60.36916667,
    longitud: -30.38722222,
    elev: 52,
    uom_elev: "Metros",
    ref: "Gobernador Crespo",
    distancia_ref: 4.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "GDH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL DEHEZA",
    coordenadas: "32°44'42\"S  63°47'46\"W",
    latitud: -63.79611111,
    longitud: -32.745,
    elev: 274,
    uom_elev: "Metros",
    ref: "General Deheza",
    distancia_ref: 0.3,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "GDO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GANCEDO/PULVERIZACIONES.M.H.",
    coordenadas: "27°28'42\"S  61°38'40\"W",
    latitud: -61.64441,
    longitud: -27.47845,
    elev: 97,
    uom_elev: "Metros",
    ref: "Gancedo",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "GEP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GUALEGUAYCHU/EL POTRERO",
    coordenadas: "32°58'29\"S  58°15'14\"W",
    latitud: -58.25388889,
    longitud: -32.97472222,
    elev: 27,
    uom_elev: "Metros",
    ref: "Gualeguaychu",
    distancia_ref: 25,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "GES",
    oaci: "SAZV",
    iata: "VLG",
    tipo: "Aerodromo",
    denominacion: "VILLA GESELL",
    coordenadas: "37°14' 4\"S  57° 1'26\"W",
    latitud: -57.02388889,
    longitud: -37.23444444,
    elev: 10,
    uom_elev: "Metros",
    ref: "Villa Gesell",
    distancia_ref: 3,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GEZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL RODRIGUEZ/EAA",
    coordenadas: "34°40'49\"S  59° 2' 9\"W",
    latitud: -59.03583333,
    longitud: -34.68027778,
    elev: 28,
    uom_elev: "Metros",
    ref: "General Rodriguez",
    distancia_ref: 10,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GIL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN ANDRES DE GILES",
    coordenadas: "34°28'13\"S  59°25'29\"W",
    latitud: -59.42472222,
    longitud: -34.47027778,
    elev: 51,
    uom_elev: "Metros",
    ref: "San Andres de Giles",
    distancia_ref: 3,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GIT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GOYA/ITALAVIATION",
    coordenadas: "29° 9'31\"S  59°10'46\"W",
    latitud: -59.17949,
    longitud: -29.15852,
    elev: 64,
    uom_elev: "Metros",
    ref: "Goya",
    distancia_ref: 7,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "GLH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL LAS HERAS",
    coordenadas: "34°55'14\"S  58°54'59\"W",
    latitud: -58.91638889,
    longitud: -34.92055556,
    elev: 35,
    uom_elev: "Metros",
    ref: "General Las Heras",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GLM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GUALEGUAYCHU/BLM CABAÑAS",
    coordenadas: "32°58'39\"S  58°31'20\"W",
    latitud: -58.52222222,
    longitud: -32.9775,
    elev: 7.17,
    uom_elev: "Metros",
    ref: "Gualeguaychu",
    distancia_ref: 2.2,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "GLP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GUALEGUAYCHU/EA. LA PROVIDENCIA",
    coordenadas: "32°56'29\"S  58°33'53\"W",
    latitud: -58.56483,
    longitud: -32.9414,
    elev: 20,
    uom_elev: "Metros",
    ref: "Gualeguaychu",
    distancia_ref: 8,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "GNA",
    oaci: "SAMA",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL ALVEAR",
    coordenadas: "35° 3'34\"S  67°41'35\"W",
    latitud: -67.69319,
    longitud: -35.05939,
    elev: 454,
    uom_elev: "Metros",
    ref: "General Alvear",
    distancia_ref: 7.5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "GNR",
    oaci: "SAHR",
    iata: "GNR",
    tipo: "Aerodromo",
    denominacion: "GENERAL ROCA/DR. ARTURO HUMBERTO ILLIA",
    coordenadas: "39° 0' 0\"S  67°37'11\"W",
    latitud: -67.61972222,
    longitud: -39,
    elev: 260,
    uom_elev: "Metros",
    ref: "General Roca",
    distancia_ref: 4.8,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "GNV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL VIAMONTE/LOS TOLDOS",
    coordenadas: "34°58'38\"S  61° 1'15\"W",
    latitud: -61.02083333,
    longitud: -34.97722222,
    elev: 72,
    uom_elev: "Metros",
    ref: "General Viamonte",
    distancia_ref: 3.1,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GOC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GOBERNADOR CASTRO/EL GIRASOL",
    coordenadas: "33°40' 7\"S  59°50' 3\"W",
    latitud: -59.83415,
    longitud: -33.66857,
    elev: 28,
    uom_elev: "Metros",
    ref: "Gobernador Castro",
    distancia_ref: 4,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GOM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑADA DE GOMEZ",
    coordenadas: "32°48'32\"S  61°21'57\"W",
    latitud: -61.36579,
    longitud: -32.80887,
    elev: 82,
    uom_elev: "Metros",
    ref: "Cañada de Gomez",
    distancia_ref: 1.5,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "GOR",
    oaci: "SACT",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GOBERNADOR GORDILLO/CHAMICAL",
    coordenadas: "30°20'39\"S  66°17'39\"W",
    latitud: -66.29403,
    longitud: -30.34416,
    elev: 458,
    uom_elev: "Metros",
    ref: "El Chamical",
    distancia_ref: 2,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA RIOJA",
    inhab: "NO",
  },
  {
    local: "GOY",
    oaci: "SATG",
    iata: "OYA",
    tipo: "Aerodromo",
    denominacion: "GOYA",
    coordenadas: "29° 6'21\"S  59°13' 7\"W",
    latitud: -59.21874,
    longitud: -29.10595,
    elev: 39,
    uom_elev: "Metros",
    ref: "Goya",
    distancia_ref: 6,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "GOZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GOMEZ",
    coordenadas: "35° 5'44\"S  58° 5' 9\"W",
    latitud: -58.0858,
    longitud: -35.09556,
    elev: 19,
    uom_elev: "Metros",
    ref: "Gomez",
    distancia_ref: 8,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GPF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL PICO/CEREALES ANAHI RUCA",
    coordenadas: "35°40'25\"S  63°43' 5\"W",
    latitud: -63.71805556,
    longitud: -35.67361111,
    elev: 139,
    uom_elev: "Metros",
    ref: "General Pico",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "GPI",
    oaci: "SAZG",
    iata: "GPO",
    tipo: "Aerodromo",
    denominacion: "GENERAL PICO",
    coordenadas: "35°41'41\"S  63°45'32\"W",
    latitud: -63.75888889,
    longitud: -35.69472222,
    elev: 140,
    uom_elev: "Metros",
    ref: "General Pico",
    distancia_ref: 3.5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "GPK",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL PINEDO/KALBERMATTER",
    coordenadas: "27°15'37\"S  61°28'28\"W",
    latitud: -61.47444444,
    longitud: -27.26027778,
    elev: 101,
    uom_elev: "Metros",
    ref: "General Pinedo",
    distancia_ref: 20,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "GPO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL PINEDO",
    coordenadas: "27°20'38\"S  61°16'29\"W",
    latitud: -61.27484,
    longitud: -27.34401,
    elev: 91,
    uom_elev: "Metros",
    ref: "General Pinedo",
    distancia_ref: 2,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "GRA",
    oaci: "SAWE",
    iata: "RGA",
    tipo: "Aerodromo",
    denominacion: "RIO GRANDE",
    coordenadas: "53°46'39\"S  67°44'58\"W",
    latitud: -67.74952,
    longitud: -53.7776,
    elev: 20,
    uom_elev: "Metros",
    ref: "Rio Grande",
    distancia_ref: 9,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "GRE",
    oaci: "SAWR",
    iata: "GGS",
    tipo: "Aerodromo",
    denominacion: "GOBERNADOR GREGORES",
    coordenadas: "48°46'60\"S  70° 9'44\"W",
    latitud: -70.16222222,
    longitud: -48.78333333,
    elev: 356,
    uom_elev: "Metros",
    ref: "Gobernador Gregores",
    distancia_ref: 5,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "GRZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL RODRIGUEZ",
    coordenadas: "34°34'58\"S  59° 0' 2\"W",
    latitud: -59.00055556,
    longitud: -34.58277778,
    elev: 28,
    uom_elev: "Metros",
    ref: "General Rodriguez",
    distancia_ref: 10,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "ULM",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GSE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GUAVIRAVI/EA. SANTA ELISA",
    coordenadas: "29°18'16\"S  56°52'52\"W",
    latitud: -56.88124,
    longitud: -29.30444,
    elev: 63,
    uom_elev: "Metros",
    ref: "Guaviravi",
    distancia_ref: 8.7,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "GTE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GUATRACHE",
    coordenadas: "37°42'19\"S  63°33'25\"W",
    latitud: -63.55708,
    longitud: -37.70516,
    elev: 175,
    uom_elev: "Metros",
    ref: "Guatrache",
    distancia_ref: 3,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "GUA",
    oaci: "SAAG",
    iata: "GHU",
    tipo: "Aerodromo",
    denominacion: "GUALEGUAYCHU",
    coordenadas: "33° 0'20\"S  58°36'46\"W",
    latitud: -58.61277778,
    longitud: -33.00555556,
    elev: 23,
    uom_elev: "Metros",
    ref: "Gualeguaychu",
    distancia_ref: 8,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "GVA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL ALVEAR/AEROCLUB",
    coordenadas: "34°58'11\"S  67°43'27\"W",
    latitud: -67.72416667,
    longitud: -34.96972222,
    elev: 466,
    uom_elev: "Metros",
    ref: "General Alvear",
    distancia_ref: 4,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "GVZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GONZALEZ CHAVES",
    coordenadas: "38° 1'59\"S  60° 8' 2\"W",
    latitud: -60.13388889,
    longitud: -38.03305556,
    elev: 194,
    uom_elev: "Metros",
    ref: "Adolfo Gonzalez Chaves",
    distancia_ref: 2.5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "GYA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GOYA/AEROCLUB",
    coordenadas: "29°10'11\"S  59°14'49\"W",
    latitud: -59.24699,
    longitud: -29.16975,
    elev: 38,
    uom_elev: "Metros",
    ref: "Goya",
    distancia_ref: 1.5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "GYT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GOBERNADOR GARMENDIA/AGRO SERVICIO YORIS",
    coordenadas: "26°34'45\"S  64°31'43\"W",
    latitud: -64.52869,
    longitud: -26.57916,
    elev: 318,
    uom_elev: "Metros",
    ref: "Gobernador Garmendia",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TUCUMAN",
    inhab: "NO",
  },
  {
    local: "HAB",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA AM1",
    coordenadas: "52°31' 9\"S  68°23' 9\"W",
    latitud: -68.385833,
    longitud: -52.519167,
    elev: 30,
    uom_elev: "Metros",
    ref: "Estrecho de Magallanes",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HAC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "ALPA CORRAL/JUAN Y LUCI",
    coordenadas: "32°41'24\"S  64°42'60\"W",
    latitud: -64.716543,
    longitud: -32.689893,
    elev: 733,
    uom_elev: "Metros",
    ref: "Alpa Corral",
    distancia_ref: 0,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HAD",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA AM2",
    coordenadas: "52°32'56\"S  68°18'45\"W",
    latitud: -68.3125,
    longitud: -52.548889,
    elev: 44,
    uom_elev: "Metros",
    ref: "Estrecho de Magallanes",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HAG",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LUJAN/SOL DE AGOSTO",
    coordenadas: "34°31'60\"S  58°58'15\"W",
    latitud: -58.970859,
    longitud: -34.53325,
    elev: 10,
    uom_elev: "Metros",
    ref: "Lujan",
    distancia_ref: 5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HAI",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "VILLA CARLOS PAZ/NORBERTO CORDEIRO",
    coordenadas: "31°24'51\"S  64°29'49\"W",
    latitud: -64.497037,
    longitud: -31.41415,
    elev: 621,
    uom_elev: "Metros",
    ref: "Margen E Rio San Antonio y Rio Uruguay",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HAM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA AM3",
    coordenadas: "52°31'22\"S  68°16'51\"W",
    latitud: -68.280833,
    longitud: -52.522778,
    elev: 41,
    uom_elev: "Metros",
    ref: "Estrecho de Magallanes",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HAS",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PARANA/AMARRAS DEL SOL",
    coordenadas: "31°42'31\"S  60°30' 3\"W",
    latitud: -60.50083333,
    longitud: -31.70861111,
    elev: 16,
    uom_elev: "Metros",
    ref: "Parana",
    distancia_ref: 4,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "HAT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "ALMAFUERTE/TRANSENER S.A.",
    coordenadas: "32°12'13\"S  64°18'53\"W",
    latitud: -64.314603,
    longitud: -32.20354,
    elev: 500,
    uom_elev: "Metros",
    ref: "Almafuerte",
    distancia_ref: 6.3,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HAU",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/AUTODROMO CIUDAD DE BS. AS.",
    coordenadas: "34°41'38\"S  58°27'38\"W",
    latitud: -58.460425,
    longitud: -34.693918,
    elev: 16,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HBA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN CARLOS DE BARILOCHE/ARELAUQUEN",
    coordenadas: "41° 9'40\"S  71°21'56\"W",
    latitud: -71.36568,
    longitud: -41.161161,
    elev: 945,
    uom_elev: "Metros",
    ref: "San Carlos de Bariloche",
    distancia_ref: 8,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "HBC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/B. CHURRUCA",
    coordenadas: "34°38'27\"S  58°24'34\"W",
    latitud: -58.409441,
    longitud: -34.64073,
    elev: 6,
    uom_elev: "Metros",
    ref: "Ciudad de Buenos Aires",
    distancia_ref: 0,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HBI",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CORDOBA/HELIPUERTO CENTRO CIVICO BICENTENARIO",
    coordenadas: "31°25'13\"S  64°10'24\"W",
    latitud: -64.173382,
    longitud: -31.420398,
    elev: 392,
    uom_elev: "Metros",
    ref: "Aeropuerto",
    distancia_ref: 12,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HBM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/MADERO",
    coordenadas: "34°37'18\"S  58°20'42\"W",
    latitud: -58.344913,
    longitud: -34.621535,
    elev: 5,
    uom_elev: "Metros",
    ref: "Ciudad de Buenos Aires",
    distancia_ref: 0,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HBO",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "EL BRACHO/TRANSENER S.A.",
    coordenadas: "26°59'37\"S  65° 9'49\"W",
    latitud: -65.163478,
    longitud: -26.993528,
    elev: 378,
    uom_elev: "Metros",
    ref: "El Bracho",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TUCUMAN",
    inhab: "NO",
  },
  {
    local: "HBP",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BAHIA BLANCA/PBB POLISUR S.A.",
    coordenadas: "38°46'24\"S  62°17'38\"W",
    latitud: -62.293984,
    longitud: -38.77345,
    elev: 5,
    uom_elev: "Metros",
    ref: "Bahia Blanca",
    distancia_ref: 6.5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HBR",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CORDOBA/BERRINI",
    coordenadas: "31°26'23\"S  64°20'37\"W",
    latitud: -64.34373,
    longitud: -31.439765,
    elev: 552,
    uom_elev: "Metros",
    ref: "Cordoba",
    distancia_ref: 14,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HBT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA PLATA",
    coordenadas: "34°54' 2\"S  57°55'46\"W",
    latitud: -57.92948611,
    longitud: -34.90044444,
    elev: 6,
    uom_elev: "Metros",
    ref: "La Plata",
    distancia_ref: 3,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HCA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "COSTA AZUL/LA CALDERA",
    coordenadas: "36°40' 1\"S  56°40'43\"W",
    latitud: -56.678721,
    longitud: -36.666985,
    elev: 10,
    uom_elev: "Metros",
    ref: "Duhau, Av. Belgrano y Av. Costanera",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HCC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CHOEL  CHOEL/TRANSENER S.A.",
    coordenadas: "39°33'60\"S  65°41'20\"W",
    latitud: -65.68877,
    longitud: -39.566662,
    elev: 130,
    uom_elev: "Metros",
    ref: "Lamarque",
    distancia_ref: 16,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "HCD",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN MARTIN DE LOS ANDES/EA. LA CANDELARIA",
    coordenadas: "40° 2'39\"S  71°21'60\"W",
    latitud: -71.366646,
    longitud: -40.044053,
    elev: 914,
    uom_elev: "Metros",
    ref: "San Martin de los Andes",
    distancia_ref: 13,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "HCE",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA/RIO CULLEN-HIDRACENTRO TOTAL AUSTRAL",
    coordenadas: "52°50'11\"S  68°10'44\"W",
    latitud: -68.178889,
    longitud: -52.836389,
    elev: 39,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HCG",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "EZEIZA/TRANSENER S.A.",
    coordenadas: "34°54'44\"S  58°43'11\"W",
    latitud: -58.719844,
    longitud: -34.912354,
    elev: 20,
    uom_elev: "Metros",
    ref: "Cañuelas",
    distancia_ref: 15,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HCI",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BELEN DE ESCOBAR/CABAÑA SAN ISIDRO LABRADOR I",
    coordenadas: "34°22'43\"S  58°47'19\"W",
    latitud: -58.78852,
    longitud: -34.378674,
    elev: 12,
    uom_elev: "Metros",
    ref: "Belen de Escobar",
    distancia_ref: 3,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HCL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CATAN LIL/EA. SANTA ISABEL",
    coordenadas: "39°53' 5\"S  70°30'50\"W",
    latitud: -70.513907,
    longitud: -39.884782,
    elev: 950,
    uom_elev: "Metros",
    ref: "Departamento de Collon Cura",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "HCN",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "EMBALSE/CENTRAL NUCLEAR",
    coordenadas: "32°13'46\"S  64°26'24\"W",
    latitud: -64.439904,
    longitud: -32.229454,
    elev: 530,
    uom_elev: "Metros",
    ref: "Embalse",
    distancia_ref: 0,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HCO",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CHENAUT/EL CAPRICHO",
    coordenadas: "34°13'58\"S  59°18'57\"W",
    latitud: -59.315902,
    longitud: -34.232743,
    elev: 30,
    uom_elev: "Metros",
    ref: "Estacion Chenaut",
    distancia_ref: 6,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HCP",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "YACIMIENTO CAÑADON ALFA/TOTAL AUSTRAL S.A.",
    coordenadas: "52°44'19\"S  68°34'21\"W",
    latitud: -68.572493,
    longitud: -52.738661,
    elev: 87,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HCR",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BARREALES - GRAN MENDOZA/TRANSENER S.A.",
    coordenadas: "33° 5'57\"S  68°34'46\"W",
    latitud: -68.579397,
    longitud: -33.099208,
    elev: 674,
    uom_elev: "Metros",
    ref: "Barreales",
    distancia_ref: 0,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "HCS",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CAPILLA DEL SEÑOR/LAS ARAUCARIAS",
    coordenadas: "34°18'25\"S  59°10'13\"W",
    latitud: -59.170276,
    longitud: -34.307048,
    elev: 25,
    uom_elev: "Metros",
    ref: "Capilla del Señor",
    distancia_ref: 6.5,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HCT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CAMPANA/TRANSENER S.A.",
    coordenadas: "34°10'28\"S  58°59'58\"W",
    latitud: -58.999307,
    longitud: -34.174379,
    elev: 10,
    uom_elev: "Metros",
    ref: "Campana",
    distancia_ref: 3,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HCU",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CORDOBA/CIUDAD UNIVERSITARIA",
    coordenadas: "31°26'27\"S  64°11'25\"W",
    latitud: -64.190266,
    longitud: -31.440805,
    elev: 440,
    uom_elev: "Metros",
    ref: "Medina Allende, Av. Ciudad de Valparaiso y vias FCGBM",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HCV",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CABO VIRGENES/BRM CABO VIRGENES",
    coordenadas: "52°19'49\"S  68°24'30\"W",
    latitud: -68.408453,
    longitud: -52.330311,
    elev: 55,
    uom_elev: "Metros",
    ref: "Rio Gallegos",
    distancia_ref: 120,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "HDA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/DARSENA SUR",
    coordenadas: "34°37'40\"S  58°21' 6\"W",
    latitud: -58.351532,
    longitud: -34.627862,
    elev: 5,
    uom_elev: "Metros",
    ref: "Isla Demarchi",
    distancia_ref: 0,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "MIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HDI",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/DINES DR. E. ESCUDERO",
    coordenadas: "34°34'21\"S  58°24' 2\"W",
    latitud: -58.400458,
    longitud: -34.572579,
    elev: 6,
    uom_elev: "Metros",
    ref: "Salguero y Costanera",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HDL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "JUNIN DE LOS ANDES/CASA DE LATA",
    coordenadas: "39°48'56\"S  71°10'12\"W",
    latitud: -71.16995,
    longitud: -39.815579,
    elev: 982,
    uom_elev: "Metros",
    ref: "Junin de los Andes",
    distancia_ref: 12,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "HDR",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "GRANADERO BAIGORRIA/HOSPITAL R. CARRILLO",
    coordenadas: "32°51' 7\"S  60°42'33\"W",
    latitud: -60.709211,
    longitud: -32.851806,
    elev: 37,
    uom_elev: "Metros",
    ref: "Granadero Baigorria",
    distancia_ref: 1,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "HDS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "HENDERSON",
    coordenadas: "36°18'55\"S  61°44'52\"W",
    latitud: -61.74777778,
    longitud: -36.31527778,
    elev: 150,
    uom_elev: "Metros",
    ref: "Henderson",
    distancia_ref: 2.5,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HDT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "DON TORCUATO/TIMEN S.A.",
    coordenadas: "34°29'46\"S  58°36'29\"W",
    latitud: -58.608031,
    longitud: -34.496085,
    elev: 6,
    uom_elev: "Metros",
    ref: "Ex Aerodromo Don Torcuato",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HEA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA AM6",
    coordenadas: "52°36'30\"S  68° 7'40\"W",
    latitud: -68.127778,
    longitud: -52.608333,
    elev: 32,
    uom_elev: "Metros",
    ref: "Cabo Virgenes",
    distancia_ref: 34,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HEC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA PLATA/ECODYMA S.C.A.",
    coordenadas: "34°56'27\"S  57°59'31\"W",
    latitud: -57.991881,
    longitud: -34.940786,
    elev: 14,
    uom_elev: "Metros",
    ref: "Estacion La Plata",
    distancia_ref: 5.5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HEN",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BAHIA SAN SEBASTIAN/PLANTA CRUZ DEL SUR",
    coordenadas: "53°19'23\"S  68°15'58\"W",
    latitud: -68.266107,
    longitud: -53.32299,
    elev: 53,
    uom_elev: "Metros",
    ref: "Rio Grande",
    distancia_ref: 64,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HES",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "ARIES/TOTAL FINA",
    coordenadas: "52°40'59\"S  68° 2'31\"W",
    latitud: -68.041944,
    longitud: -52.683056,
    elev: 0,
    uom_elev: "Pies",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HET",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SANTIAGO DEL ESTERO/HELIPUERTO EDIFICIO TRIBUNALES",
    coordenadas: "27°46'53\"S  64°15'54\"W",
    latitud: -64.265127,
    longitud: -27.781396,
    elev: 195,
    uom_elev: "Metros",
    ref: "Av. H. Yrigoyen entre Av. Alvear y Chacabuco",
    distancia_ref: "",
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "HEV",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "ALMIRANTE BROWN/DESTACAMENTO POLICIAL EL VAPOR",
    coordenadas: "34°50' 5\"S  58°23' 6\"W",
    latitud: -58.384984,
    longitud: -34.834672,
    elev: 28,
    uom_elev: "Metros",
    ref: "Destacamento Policial El Vapor",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HFA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/FUERZA AEREA",
    coordenadas: "34°35'10\"S  58°22' 5\"W",
    latitud: -58.368051,
    longitud: -34.58598,
    elev: 6,
    uom_elev: "Metros",
    ref: "Estacion Retiro",
    distancia_ref: 0.5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "MIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HFC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SALTA/FINCA LAS COSTAS",
    coordenadas: "24°46'13\"S  65°29'44\"W",
    latitud: -65.495501,
    longitud: -24.770405,
    elev: 1311,
    uom_elev: "Metros",
    ref: "Salta",
    distancia_ref: 8.5,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "HFV",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "FLORENCIO VARELA/COLONIA LA CAPILLA",
    coordenadas: "34°55' 1\"S  58°15' 1\"W",
    latitud: -58.250221,
    longitud: -34.916875,
    elev: 25,
    uom_elev: "Metros",
    ref: "Florencio Varela",
    distancia_ref: 9,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HGA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CAÑUELAS/CAÑUELAS GAS S.A.",
    coordenadas: "35° 3'30\"S  58°47'17\"W",
    latitud: -58.788161,
    longitud: -35.058342,
    elev: 30,
    uom_elev: "Metros",
    ref: "Cañuelas",
    distancia_ref: 9,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HGB",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SALTA/CENTRO CIVICO GRAND BOURG",
    coordenadas: "24°46'51\"S  65°27' 4\"W",
    latitud: -65.451084,
    longitud: -24.780762,
    elev: 1260,
    uom_elev: "Metros",
    ref: "Salta",
    distancia_ref: 4,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "HGM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "GONZALEZ CATAN/LAR DE PAZ S.A.",
    coordenadas: "34°46'35\"S  58°39'30\"W",
    latitud: -58.658271,
    longitud: -34.776299,
    elev: 15,
    uom_elev: "Metros",
    ref: "Estacion FFCC Gonzalez Catan",
    distancia_ref: 1.3,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HGN",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/CENTINELA",
    coordenadas: "34°34'57\"S  58°22'28\"W",
    latitud: -58.374528,
    longitud: -34.582445,
    elev: 13,
    uom_elev: "Metros",
    ref: "Ciudad de Buenos Aires",
    distancia_ref: 0,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "JOINT",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HGS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "HUGHES/PLUS AGROSERVICIOS AEREOS",
    coordenadas: "33°48'40\"S  61°20'15\"W",
    latitud: -61.3375,
    longitud: -33.81111111,
    elev: 97,
    uom_elev: "Metros",
    ref: "Hughes",
    distancia_ref: 1,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "HHL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LAS LAJAS/EA. HAYCHOL",
    coordenadas: "38°32'53\"S  70°40'39\"W",
    latitud: -70.677494,
    longitud: -38.548178,
    elev: 1051,
    uom_elev: "Metros",
    ref: "Las Lajas",
    distancia_ref: 35,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "HHM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SALTA/HOSPITAL DE MILAGRO",
    coordenadas: "24°46'23\"S  65°24'56\"W",
    latitud: -65.415621,
    longitud: -24.772921,
    elev: 1240,
    uom_elev: "Metros",
    ref: "Salta",
    distancia_ref: 3,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "HHT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "DON TORCUATO/TECNOCOPTER S.A.",
    coordenadas: "34°29'34\"S  58°36'25\"W",
    latitud: -58.606915,
    longitud: -34.492668,
    elev: 20,
    uom_elev: "Metros",
    ref: "Ex Aerodromo Don Torcuato",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HHW",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "MORENO/HELIWEST",
    coordenadas: "34°38' 3\"S  58°45' 6\"W",
    latitud: -58.751782,
    longitud: -34.634199,
    elev: 21.5,
    uom_elev: "Metros",
    ref: "Moreno",
    distancia_ref: 3.9,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HIL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "GRAL. VILLEGAS/SAN ISIDRO LABRADOR II",
    coordenadas: "35° 4'54\"S  63° 4'48\"W",
    latitud: -63.079953,
    longitud: -35.081749,
    elev: 115,
    uom_elev: "Metros",
    ref: "General Villegas",
    distancia_ref: 8,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HIS",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA MATANZA/CAMPANOPOLIS",
    coordenadas: "34°47'30\"S  58°36' 7\"W",
    latitud: -58.601878,
    longitud: -34.791733,
    elev: 6,
    uom_elev: "Metros",
    ref: "Aeropuerto Ezeiza / Ministro Pistarini",
    distancia_ref: 7,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HIT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "ITUZAINGO/TRANSENER",
    coordenadas: "27°33'31\"S  56°39'30\"W",
    latitud: -56.658294,
    longitud: -27.558575,
    elev: 71,
    uom_elev: "Metros",
    ref: "Ituzaingo",
    distancia_ref: 4,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "HJN",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "JUNIN DE LOS ANDES/EA. PALITUE",
    coordenadas: "39°51'10\"S  71° 2'47\"W",
    latitud: -71.046426,
    longitud: -39.852774,
    elev: 859,
    uom_elev: "Metros",
    ref: "Junin de los Andes",
    distancia_ref: 10,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "HLE",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LAGO ESCONDIDO/HIDDEN LAKE S.A.",
    coordenadas: "41°42'12\"S  71°36'28\"W",
    latitud: -71.607697,
    longitud: -41.70337,
    elev: 830,
    uom_elev: "Metros",
    ref: "El Bolson",
    distancia_ref: 31,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "HLF",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CAPILLA DEL SEÑOR/LOS FRESNOS",
    coordenadas: "34°16'54\"S  59° 7' 7\"W",
    latitud: -59.118616,
    longitud: -34.2816,
    elev: 34,
    uom_elev: "Metros",
    ref: "Capilla del Señor",
    distancia_ref: 2.2,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HLH",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LUJAN/HOMAQ",
    coordenadas: "34°33'26\"S  59° 2'45\"W",
    latitud: -59.045919,
    longitud: -34.557353,
    elev: 24,
    uom_elev: "Metros",
    ref: "Lujan",
    distancia_ref: 6,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HLI",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "DON TORCUATO/HELICENTER",
    coordenadas: "34°29'51\"S  58°36'25\"W",
    latitud: -58.606884,
    longitud: -34.497531,
    elev: 3.87,
    uom_elev: "Metros",
    ref: "Ex Aerodromo Don Torcuato",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HLL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN CARLOS DE BARILOCHE/COMPLEJO LLAO LLAO",
    coordenadas: "41° 3'17\"S  71°32' 2\"W",
    latitud: -71.533825,
    longitud: -41.054659,
    elev: 775,
    uom_elev: "Metros",
    ref: "San Carlos de Bariloche",
    distancia_ref: 20,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "HLP",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA PLATA/HELIPUERTO D.P.A.O.",
    coordenadas: "34°57'35\"S  57°53'35\"W",
    latitud: -57.893075,
    longitud: -34.959802,
    elev: 19,
    uom_elev: "Metros",
    ref: "Extremo W del aerodromo",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HLR",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LOS CARDALES/LA RESERVA",
    coordenadas: "34°16'14\"S  58°54' 2\"W",
    latitud: -58.900427,
    longitud: -34.270449,
    elev: 6,
    uom_elev: "Metros",
    ref: "Los Cardales",
    distancia_ref: 10,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HLS",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "OPEN DOOR/LA SUPERBA",
    coordenadas: "34°30' 3\"S  59° 0'55\"W",
    latitud: -59.015184,
    longitud: -34.500721,
    elev: 0,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HLT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "VILLA ROSA/LAS CHACRITAS",
    coordenadas: "34°24'17\"S  58°51'49\"W",
    latitud: -58.863589,
    longitud: -34.404632,
    elev: 19.66,
    uom_elev: "Metros",
    ref: "Villa Rosa",
    distancia_ref: 1.5,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HLU",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LUJAN/TRANSENER S.A.",
    coordenadas: "32°22' 0\"S  66° 3'59\"W",
    latitud: -66.066423,
    longitud: -32.366669,
    elev: 600,
    uom_elev: "Metros",
    ref: "Lujan",
    distancia_ref: 9,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "HMA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HUDSON/MANUEL AFONSO",
    coordenadas: "34°48'56\"S  58°11'43\"W",
    latitud: -58.195412,
    longitud: -34.815509,
    elev: 11,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HMC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "GARIN/MIRAFLORES COUNTRY CLUB",
    coordenadas: "34°26'45\"S  58°44' 3\"W",
    latitud: -58.734061,
    longitud: -34.445915,
    elev: 21,
    uom_elev: "Metros",
    ref: "Garin",
    distancia_ref: 2.6,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HMD",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/HELIPUERTO SWISS MEDICAL",
    coordenadas: "34°34'52\"S  58°25'46\"W",
    latitud: -58.429528,
    longitud: -34.581053,
    elev: 59,
    uom_elev: "Metros",
    ref: "Juan B. Justo 909",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HME",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PILAR/MEMORIAL",
    coordenadas: "34°26'40\"S  58°50'12\"W",
    latitud: -58.836706,
    longitud: -34.444449,
    elev: 19,
    uom_elev: "Metros",
    ref: "Ruta Panamericana Km. 46",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HMF",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA MATANZA/OFICIAL SUBINSPECTOR GUSTAVO SOAREZ DE SOUZA",
    coordenadas: "34°43'25\"S  58°30'54\"W",
    latitud: -58.514923,
    longitud: -34.723585,
    elev: 43,
    uom_elev: "Metros",
    ref: "Ruta 4 y Autopista Richieri",
    distancia_ref: 0,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HMG",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES / MADERO HARBOUR",
    coordenadas: "34°37'16\"S  58°21'39\"W",
    latitud: -58.36092778,
    longitud: -34.62097778,
    elev: 78.8,
    uom_elev: "Metros",
    ref: "Edificio T5 - Complejo Madero Harbour",
    distancia_ref: "",
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HMH",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN FERNANDO/PARANA MINI",
    coordenadas: "34°10'16\"S  58°30'39\"W",
    latitud: -58.510795,
    longitud: -34.171041,
    elev: 5,
    uom_elev: "Metros",
    ref: "Rio Parana Mini",
    distancia_ref: 0,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HMM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "DR. MARIANO MORENO",
    coordenadas: "34°33'46\"S  58°47'26\"W",
    latitud: -58.790569,
    longitud: -34.562908,
    elev: 32,
    uom_elev: "Metros",
    ref: "Jose C. Paz",
    distancia_ref: 7,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "MIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HMQ",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA AM5",
    coordenadas: "52°34'14\"S  68°15'12\"W",
    latitud: -68.253333,
    longitud: -52.570556,
    elev: 30,
    uom_elev: "Metros",
    ref: "Estrecho de Magallanes",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HMT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "MONTE CRISTO/TRANSENER S.A.",
    coordenadas: "31°20'21\"S  63°54'50\"W",
    latitud: -63.913851,
    longitud: -31.3392,
    elev: 330,
    uom_elev: "Metros",
    ref: "Monte Cristo",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HMY",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA MATANZA/TERMINAL Y.P.F.",
    coordenadas: "34°43'55\"S  58°33'28\"W",
    latitud: -58.557711,
    longitud: -34.731886,
    elev: 10,
    uom_elev: "Metros",
    ref: "Ruta Prov. 21 y Av. Cristiania",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HNB",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "TIGRE/NORDELTA",
    coordenadas: "34°26'23\"S  58°38'32\"W",
    latitud: -58.642147,
    longitud: -34.439639,
    elev: 5,
    uom_elev: "Metros",
    ref: "Tigre",
    distancia_ref: 2,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HNE",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "VILLA NUEVA/DAYRY PARTNERS AMERICAS MANUFACTURING ARGENTINA S.A",
    coordenadas: "32°26'16\"S  63°13'27\"W",
    latitud: -63.22409,
    longitud: -32.437713,
    elev: 195,
    uom_elev: "Metros",
    ref: "Villa Nueva",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HNH",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA NOBLE HOUSTON COLBERT",
    coordenadas: "53° 5'54\"S  67°13'13\"W",
    latitud: -67.220278,
    longitud: -53.098333,
    elev: 63.5,
    uom_elev: "Metros",
    ref: "Cuenca Marina Austral I Aguas Juridiccionales Argentinas",
    distancia_ref: "",
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HNO",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA/RIO CULLEN-HIDRANORT",
    coordenadas: "52°49'14\"S  68°13' 9\"W",
    latitud: -68.219167,
    longitud: -52.820556,
    elev: 20,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HNP",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/HOSPITAL NACIONAL DE PEDIATRIA PROF. JUAN GARRAHAM",
    coordenadas: "34°37'52\"S  58°23'38\"W",
    latitud: -58.393835,
    longitud: -34.63098,
    elev: 39,
    uom_elev: "Metros",
    ref: "Av. Juan de Garay y Pichincha",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HOB",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "ALTA GRACIA/ORESTE BERTA",
    coordenadas: "31°37'59\"S  64°23'52\"W",
    latitud: -64.397768,
    longitud: -31.633061,
    elev: 570,
    uom_elev: "Metros",
    ref: "Alta Gracia",
    distancia_ref: 3.5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HOC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA OCEANIC CHAMPION",
    coordenadas: "52°50' 0\"S  66°25' 0\"W",
    latitud: -66.41666667,
    longitud: -52.83333333,
    elev: 20,
    uom_elev: "Metros",
    ref: "Rio Grande",
    distancia_ref: 138.9,
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HOS",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA MOVIL OCEAN SCEPTER",
    coordenadas: "46°28' 0\"S  67°25'60\"W",
    latitud: -67.433333,
    longitud: -46.466667,
    elev: 154,
    uom_elev: "Metros",
    ref: "Golfo San Jorge",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "HPA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/PRESIDENCIA DE LA NACION",
    coordenadas: "34°36'23\"S  58°22' 6\"W",
    latitud: -58.368322,
    longitud: -34.606433,
    elev: 8,
    uom_elev: "Metros",
    ref: "Av Madero,Tte. Gral. Peron y Av. La Rabida",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HPC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CORDOBA/POLICIA PROVINCIA DE CORDOBA",
    coordenadas: "31°24'30\"S  64°11'58\"W",
    latitud: -64.199434,
    longitud: -31.40821,
    elev: 393,
    uom_elev: "Metros",
    ref: "Cordoba",
    distancia_ref: 0,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HPD",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "MENDOZA/POLICIA DE LA PROVINCIA DE MENDOZA",
    coordenadas: "32°52'42\"S  68°52' 4\"W",
    latitud: -68.867744,
    longitud: -32.878387,
    elev: 807,
    uom_elev: "Metros",
    ref: "Aeropuerto de Mendoza",
    distancia_ref: 8,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "HPE",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PARANA/HOSPITAL MATERNO INFANTIL SAN ROQUE",
    coordenadas: "31°43'48\"S  60°31'17\"W",
    latitud: -60.521265,
    longitud: -31.730027,
    elev: 81,
    uom_elev: "Metros",
    ref: "Parana",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "HPG",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PIEDRA DEL AGUILA/TRANSENER S.A.",
    coordenadas: "40° 9'41\"S  70° 2'33\"W",
    latitud: -70.042408,
    longitud: -40.161297,
    elev: 702,
    uom_elev: "Metros",
    ref: "Piedra del Aguila",
    distancia_ref: 13.5,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "HPI",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PILAR GOLF/PIERO VARA",
    coordenadas: "34°25'59\"S  58°58'21\"W",
    latitud: -58.972486,
    longitud: -34.433128,
    elev: 12,
    uom_elev: "Metros",
    ref: "Pilar",
    distancia_ref: 6,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HPL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA RIOJA/HELIPUERTO POLICIA PROVINCIAL C.A.P.E.",
    coordenadas: "29°26' 8\"S  66°51'48\"W",
    latitud: -66.863203,
    longitud: -29.435592,
    elev: 520,
    uom_elev: "Metros",
    ref: "La Rioja",
    distancia_ref: 2.6,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA RIOJA",
    inhab: "NO",
  },
  {
    local: "HPM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "LA PLATA/POLICLINICO SAN MARTIN",
    coordenadas: "34°55'29\"S  57°55'19\"W",
    latitud: -57.921928,
    longitud: -34.924584,
    elev: 21,
    uom_elev: "Metros",
    ref: "Av. 1 y Calle 71",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HPN",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/P.N.A. OF. PPAL. BALLESTRA",
    coordenadas: "34°34'38\"S  58°23' 2\"W",
    latitud: -58.383829,
    longitud: -34.577207,
    elev: 6,
    uom_elev: "Metros",
    ref: "Junin y Rafael Obligado (Darsena F)",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "MIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HPO",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PUERTO ESPERANZA",
    coordenadas: "25°59'25\"S  54°38'18\"W",
    latitud: -54.638298,
    longitud: -25.99034,
    elev: 155,
    uom_elev: "Metros",
    ref: "Esperanza",
    distancia_ref: 4.7,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "HPS",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PACHON/HELIPUERTO PACHON MINERA S.A.",
    coordenadas: "31°45'36\"S  70°24'44\"W",
    latitud: -70.41209,
    longitud: -31.760056,
    elev: 3600,
    uom_elev: "Metros",
    ref: "Pachon",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN JUAN",
    inhab: "NO",
  },
  {
    local: "HPT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN MARTIN/COOPERATIVA DE TRABAJOS PORTUARIOS LIMITADA",
    coordenadas: "32°43' 9\"S  60°43'35\"W",
    latitud: -60.72647778,
    longitud: -32.71917778,
    elev: 9,
    uom_elev: "Metros",
    ref: "Puerto General San Martin",
    distancia_ref: 0.5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "HPU",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "PUELCHES/TRANSENER S.A.",
    coordenadas: "38° 8'52\"S  65°49'30\"W",
    latitud: -65.824946,
    longitud: -38.147703,
    elev: 229,
    uom_elev: "Metros",
    ref: "Puelches",
    distancia_ref: 8,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "HRC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CARMEN DE ARECO/SAN JOAQUIN",
    coordenadas: "34°20'19\"S  59°43'17\"W",
    latitud: -59.721463,
    longitud: -34.338474,
    elev: 42,
    uom_elev: "Metros",
    ref: "Carmen de Areco",
    distancia_ref: 16,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HRE",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "RECREO/TRANSENER S.A.",
    coordenadas: "29°15'46\"S  65° 3'30\"W",
    latitud: -65.058247,
    longitud: -29.262769,
    elev: 247,
    uom_elev: "Metros",
    ref: "Recreo",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CATAMARCA",
    inhab: "NO",
  },
  {
    local: "HRI",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA CARINA/TOTAL FINA ELF",
    coordenadas: "52°45'26\"S  67°13'10\"W",
    latitud: -67.219444,
    longitud: -52.757222,
    elev: 0,
    uom_elev: "Pies",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HRM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN MARTIN DE LOS ANDES/RANCHO DE MONTAÑA",
    coordenadas: "40° 9' 8\"S  71°17' 7\"W",
    latitud: -71.285379,
    longitud: -40.152264,
    elev: 1005,
    uom_elev: "Metros",
    ref: "San Martin de los Andes",
    distancia_ref: 5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "HRR",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "MORRISON",
    coordenadas: "32°35'10\"S  62°50' 6\"W",
    latitud: -62.83505,
    longitud: -32.586092,
    elev: 142,
    uom_elev: "Metros",
    ref: "Morrison",
    distancia_ref: 3.5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HRT",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "ROMANG/TRANSENER S.A.",
    coordenadas: "29°27'41\"S  59°45'53\"W",
    latitud: -59.764765,
    longitud: -29.461483,
    elev: 58,
    uom_elev: "Metros",
    ref: "Romang",
    distancia_ref: 3.5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "HRW",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "RIO GRANDE/EA. RIO EWAN",
    coordenadas: "54°14' 1\"S  67°12'48\"W",
    latitud: -67.21324,
    longitud: -54.23355,
    elev: 33.7,
    uom_elev: "Metros",
    ref: "Rio Grande",
    distancia_ref: 59,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HSC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SPEGAZZINI/CENTRAL TERMICA",
    coordenadas: "34°54' 7\"S  58°36'56\"W",
    latitud: -58.61566667,
    longitud: -34.90202778,
    elev: 17,
    uom_elev: "Metros",
    ref: "Carlos Spegazzini",
    distancia_ref: 2.2,
    direccion_ref: "NW",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HSD",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "MORENO/COUNTRY CLUB SAN DIEGO",
    coordenadas: "34°36' 2\"S  58°50'27\"W",
    latitud: -58.840928,
    longitud: -34.600466,
    elev: 23.5,
    uom_elev: "Metros",
    ref: "Moreno",
    distancia_ref: 7.5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HSG",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUENOS AIRES/SANATORIO GÜEMES",
    coordenadas: "34°35'49\"S  58°25'19\"W",
    latitud: -58.421945,
    longitud: -34.59703,
    elev: 82,
    uom_elev: "Metros",
    ref: "Facundo Acuña de Figueroa y Av. Cordoba",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CIUDAD AUTONOMA DE BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HSH",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN ANDRES DE GILES/HOSPITAL MUNICIPAL",
    coordenadas: "34°26'56\"S  59°26'58\"W",
    latitud: -59.449417,
    longitud: -34.448879,
    elev: 47,
    uom_elev: "Metros",
    ref: "Rawson entre Soule y Campora",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HSJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CURUZU CUATIA/EA. SAN JUAN",
    coordenadas: "29°36' 6\"S  58° 1'19\"W",
    latitud: -58.02205,
    longitud: -29.60179,
    elev: 82,
    uom_elev: "Metros",
    ref: "Curuzu Cuatia",
    distancia_ref: 20,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "HSM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "TIGRE/ISLA SANTA MONICA",
    coordenadas: "34°24'53\"S  58°30'27\"W",
    latitud: -58.507365,
    longitud: -34.414724,
    elev: 3,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HSN",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SAN NICOLAS DE LOS ARROYOS/MIGUEL COLOMBISE",
    coordenadas: "33°21'32\"S  60°14'58\"W",
    latitud: -60.249353,
    longitud: -33.358932,
    elev: 27,
    uom_elev: "Metros",
    ref: "Estacion FFCC local",
    distancia_ref: 2.7,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HSR",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SANTA CRUZ/EA. SAN RAMON",
    coordenadas: "50°18'11\"S  69°55' 4\"W",
    latitud: -69.917664,
    longitud: -50.303036,
    elev: 374,
    uom_elev: "Metros",
    ref: "Puerto Santa Cruz",
    distancia_ref: 104,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "HSW",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPLATAFORMA SWIBER PJW3000",
    coordenadas: "53° 4'35\"S  67°57'50\"W",
    latitud: -67.96400424,
    longitud: -53.07649481,
    elev: 36,
    uom_elev: "Metros",
    ref: "Campo Vega Pleyade (531929S-0674311W 530346S-0674649W 525444S-0680635W 525554S-0681826W)",
    distancia_ref: "",
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HTA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "CONCEPCION DEL URUGUAY/HELIPUERTO TALITAS",
    coordenadas: "32°32'53\"S  58°14'27\"W",
    latitud: -58.240705,
    longitud: -32.548188,
    elev: 8,
    uom_elev: "Metros",
    ref: "Concepcion del Uruguay",
    distancia_ref: 17,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "HTD",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "TANDIL/EA. LA PASCUALA",
    coordenadas: "37°23'37\"S  58°57'59\"W",
    latitud: -58.966403,
    longitud: -37.393711,
    elev: 220,
    uom_elev: "Metros",
    ref: "Tandil",
    distancia_ref: 22.3,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HTE",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "SALTA/TEMET",
    coordenadas: "24°50'10\"S  65°22'20\"W",
    latitud: -65.372347,
    longitud: -24.836242,
    elev: 1180,
    uom_elev: "Metros",
    ref: "Salta",
    distancia_ref: 6.5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "HTL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "TRENQUE LAUQUEN/EA. LA CHACOTA",
    coordenadas: "35°54'48\"S  62°38'30\"W",
    latitud: -62.641667,
    longitud: -35.913333,
    elev: 90,
    uom_elev: "Metros",
    ref: "Trenque Lauquen",
    distancia_ref: 13,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HTS",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "EL TURBIO/EA. SANTA ANA",
    coordenadas: "51°41' 9\"S  71°58' 4\"W",
    latitud: -71.967747,
    longitud: -51.685796,
    elev: 665,
    uom_elev: "Metros",
    ref: "El Turbio",
    distancia_ref: 9.5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "HUE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARHUE",
    coordenadas: "37°11'38\"S  62°46'53\"W",
    latitud: -62.78138889,
    longitud: -37.19388889,
    elev: 110,
    uom_elev: "Metros",
    ref: "Carhue",
    distancia_ref: 1.5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HUG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "HUANGUELEN",
    coordenadas: "37° 3'10\"S  61°57'12\"W",
    latitud: -61.95324,
    longitud: -37.05267,
    elev: 158,
    uom_elev: "Metros",
    ref: "Huanguelen",
    distancia_ref: 2,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HUI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "HUINCA RENANCO",
    coordenadas: "34°49'13\"S  64°22'27\"W",
    latitud: -64.37412,
    longitud: -34.82041,
    elev: 180,
    uom_elev: "Metros",
    ref: "Huinca Renanco",
    distancia_ref: 2,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HUM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "HUMBOLDT/ESTABLECIMIENTO LA ADELITA",
    coordenadas: "31°23'23\"S  61° 8'33\"W",
    latitud: -61.14256,
    longitud: -31.38986,
    elev: 50,
    uom_elev: "Metros",
    ref: "Humboldt",
    distancia_ref: 5.5,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "HUP",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "GENERAL ALVEAR/UNIDAD PENITENCIARIA N° 30",
    coordenadas: "36° 2'40\"S  60° 1' 0\"W",
    latitud: -60.016667,
    longitud: -36.044444,
    elev: 55,
    uom_elev: "Metros",
    ref: "General Alvear",
    distancia_ref: 2.5,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HUU",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "HELIPUERTO SATURNINO UNZUE",
    coordenadas: "35°25'24\"S  60° 9'34\"W",
    latitud: -60.159541,
    longitud: -35.423236,
    elev: 50,
    uom_elev: "Metros",
    ref: "Estacion FFCC",
    distancia_ref: 8,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HVA",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "TIGRE/VILLA LA ÑATA",
    coordenadas: "34°22'31\"S  58°39'21\"W",
    latitud: -58.655755,
    longitud: -34.375231,
    elev: 3,
    uom_elev: "Metros",
    ref: "Estacion FFCC Tigre",
    distancia_ref: 8.6,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HVM",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "VILLA MARTELLI/CITEFA",
    coordenadas: "34°33'28\"S  58°30'20\"W",
    latitud: -58.505501,
    longitud: -34.557728,
    elev: 17,
    uom_elev: "Metros",
    ref: "Zufriategui,Mansi y Gral. Paz",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "HWG",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "BUQUE W. G. VESPUCCI",
    coordenadas: "52°53'60\"S  66°49' 0\"W",
    latitud: -66.81666667,
    longitud: -52.9,
    elev: 28,
    uom_elev: "Metros",
    ref: "25 de Mayo 555 Piso 19-20 CABA",
    distancia_ref: 0,
    direccion_ref: "",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "HYC",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "YACANTO DE CALAMUCHITA/ROCA VAL",
    coordenadas: "32° 3'35\"S  64°46'49\"W",
    latitud: -64.780353,
    longitud: -32.05978,
    elev: 1050,
    uom_elev: "Metros",
    ref: "Villa Yacanto",
    distancia_ref: 3,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "HZA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MAIPU/ESTABLECIMIENTO EL ARAZA",
    coordenadas: "36°46'33\"S  57°38'34\"W",
    latitud: -57.64277778,
    longitud: -36.77583333,
    elev: 93,
    uom_elev: "Metros",
    ref: "Estacion Santo Domingo",
    distancia_ref: 8.5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "IAA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "INTENDENTE ALVEAR/AZCARATE IRATORSA",
    coordenadas: "35°11'19\"S  63°36'38\"W",
    latitud: -63.61052,
    longitud: -35.18862,
    elev: 127,
    uom_elev: "Metros",
    ref: "Intendente Alvear",
    distancia_ref: 5,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "IAC",
    oaci: "SASQ",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA QUIACA/DR. GUILLERMO EUGENIO SNOPEK",
    coordenadas: "22° 9'43\"S  65°34'19\"W",
    latitud: -65.57207,
    longitud: -22.16195,
    elev: 3480,
    uom_elev: "Metros",
    ref: "La Quiaca",
    distancia_ref: 6,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "JUJUY",
    inhab: "NO",
  },
  {
    local: "IAL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "INTENDENTE ALVEAR",
    coordenadas: "35°14' 1\"S  63°33'57\"W",
    latitud: -63.56571,
    longitud: -35.23368,
    elev: 127,
    uom_elev: "Metros",
    ref: "Intendente Alvear",
    distancia_ref: 2.5,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "IBA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "INES INDART/BELINGUERES AVIACION",
    coordenadas: "34°16'40\"S  60°30'16\"W",
    latitud: -60.50444444,
    longitud: -34.27777778,
    elev: 63.7,
    uom_elev: "Metros",
    ref: "Salto",
    distancia_ref: 14,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "IBY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ISLAS DEL IBICUY",
    coordenadas: "33°44'38\"S  58°40'52\"W",
    latitud: -58.68099,
    longitud: -33.7439,
    elev: 6,
    uom_elev: "Metros",
    ref: "Islas de Ibicuy",
    distancia_ref: 3,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "ICO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "COMODORO RIVADAVIA/13 DE DICIEMBRE",
    coordenadas: "45°54'15\"S  67°33'32\"W",
    latitud: -67.55888889,
    longitud: -45.90416667,
    elev: 52,
    uom_elev: "Metros",
    ref: "Comodoro Rivadavia",
    distancia_ref: 8,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "IGL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "INGENIERO LUIGGI",
    coordenadas: "35°21'20\"S  64°28'31\"W",
    latitud: -64.47527,
    longitud: -35.35546,
    elev: 193,
    uom_elev: "Metros",
    ref: "Ingeniero Luiggi",
    distancia_ref: 2,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "IGU",
    oaci: "SARI",
    iata: "IGR",
    tipo: "Aerodromo",
    denominacion: "CATARATAS DEL  IGUAZU/MY. D. CARLOS EDUARDO KRAUSE",
    coordenadas: "25°44'14\"S  54°28'25\"W",
    latitud: -54.47354,
    longitud: -25.73722,
    elev: 279,
    uom_elev: "Metros",
    ref: "Cataratas del Iguazu",
    distancia_ref: 18,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "IJC",
    oaci: "SAVJ",
    iata: "IGB",
    tipo: "Aerodromo",
    denominacion: "INGENIERO JACOBACCI/CABO F.A.A. H. R. BORDON",
    coordenadas: "41°19'16\"S  69°34'34\"W",
    latitud: -69.57611111,
    longitud: -41.32111111,
    elev: 892,
    uom_elev: "Metros",
    ref: "Ingeniero Jacobacci",
    distancia_ref: 2.5,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "ILD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CASILDA",
    coordenadas: "33° 3'45\"S  61°12'35\"W",
    latitud: -61.20973,
    longitud: -33.06242,
    elev: 77,
    uom_elev: "Metros",
    ref: "Casilda",
    distancia_ref: 3,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ILM",
    oaci: "SADQ",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "QUILMES",
    coordenadas: "34°42'23\"S  58°14'41\"W",
    latitud: -58.24461,
    longitud: -34.70643,
    elev: 2,
    uom_elev: "Metros",
    ref: "Quilmes",
    distancia_ref: 2,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "IRA",
    oaci: "SAEM",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MIRAMAR",
    coordenadas: "38°13'34\"S  57°52'15\"W",
    latitud: -57.87083333,
    longitud: -38.22611111,
    elev: 13,
    uom_elev: "Metros",
    ref: "Miramar",
    distancia_ref: 4,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "IRI",
    oaci: "SATI",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BERNARDO DE IRIGOYEN",
    coordenadas: "26°16'54\"S  53°40'21\"W",
    latitud: -53.67257,
    longitud: -26.28171,
    elev: 815,
    uom_elev: "Metros",
    ref: "Bernardo de Irigoyen",
    distancia_ref: 4,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "ITO",
    oaci: "SANO",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHILECITO/BRIG. MY. JUAN FACUNDO QUIROGA",
    coordenadas: "29°13'24\"S  67°26'22\"W",
    latitud: -67.43944444,
    longitud: -29.22333333,
    elev: 945,
    uom_elev: "Metros",
    ref: "Chilecito",
    distancia_ref: 7.2,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA RIOJA",
    inhab: "NO",
  },
  {
    local: "IVB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ISLA VERDE/D. HECTOR BIONDI",
    coordenadas: "33°14'48\"S  62°24'55\"W",
    latitud: -62.41538,
    longitud: -33.24674,
    elev: 118,
    uom_elev: "Metros",
    ref: "Isla Verde",
    distancia_ref: 1,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "IVL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ISLA VERDE/BIONDI",
    coordenadas: "33°13'24\"S  62°24'17\"W",
    latitud: -62.40464,
    longitud: -33.2232,
    elev: 119,
    uom_elev: "Metros",
    ref: "Isla Verde",
    distancia_ref: 2,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "JAH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JUNIN DE LOS ANDES/HOSTERIA SAN HUBERTO",
    coordenadas: "39°42'14\"S  71°10'12\"W",
    latitud: -71.17,
    longitud: -39.70388889,
    elev: 691,
    uom_elev: "Metros",
    ref: "Junin de los Andes",
    distancia_ref: 22,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "JAR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JACINTO ARAUZ",
    coordenadas: "38° 3'58\"S  63°25'44\"W",
    latitud: -63.42902,
    longitud: -38.066,
    elev: 160,
    uom_elev: "Metros",
    ref: "Jacinto Arauz",
    distancia_ref: 1,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "JBA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JUAN BAUTISTA ALBERDI",
    coordenadas: "34°29' 1\"S  61°54'16\"W",
    latitud: -61.90455,
    longitud: -34.48351,
    elev: 102,
    uom_elev: "Metros",
    ref: "Juan Bautista Alberdi",
    distancia_ref: 10,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "JCM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JUAREZ CELMAN/BRIG. MY. JUAN IGNACIO SAN MARTIN",
    coordenadas: "31°12'40\"S  64° 9'38\"W",
    latitud: -64.16064,
    longitud: -31.21113,
    elev: 495,
    uom_elev: "Metros",
    ref: "Juarez Celman",
    distancia_ref: 20,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "JDA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JARDIN DE AMERICA",
    coordenadas: "27° 1'57\"S  55°11'53\"W",
    latitud: -55.19805556,
    longitud: -27.0325,
    elev: 205,
    uom_elev: "Metros",
    ref: "Jardin America",
    distancia_ref: 3,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "JES",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JESUS MARIA",
    coordenadas: "30°59'18\"S  64° 4'41\"W",
    latitud: -64.07797,
    longitud: -30.9883,
    elev: 530,
    uom_elev: "Metros",
    ref: "Jesus Maria",
    distancia_ref: 1.8,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "JGA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JOAQUIN V. GONZALEZ/AGROPECUARIA RIO JURAMENTO",
    coordenadas: "25°11'12\"S  64° 4'53\"W",
    latitud: -64.08135,
    longitud: -25.1866,
    elev: 1184,
    uom_elev: "Metros",
    ref: "Salta",
    distancia_ref: 8,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "JLA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JUNIN DE LOS ANDES/SAN IGNACIO",
    coordenadas: "39°50'44\"S  70°51'55\"W",
    latitud: -70.86537,
    longitud: -39.84555,
    elev: 691,
    uom_elev: "Metros",
    ref: "Junin de los Andes",
    distancia_ref: 22,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "JMB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TRES LOMAS",
    coordenadas: "36°26'35\"S  62°52'45\"W",
    latitud: -62.87927,
    longitud: -36.44296,
    elev: 116,
    uom_elev: "Metros",
    ref: "Tres Lomas",
    distancia_ref: 2,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "JOC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JOVITA/ANTARES",
    coordenadas: "34°31'55\"S  63°57'38\"W",
    latitud: -63.96055556,
    longitud: -34.53194444,
    elev: 154,
    uom_elev: "Metros",
    ref: "Jovita",
    distancia_ref: 2,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "JOR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN JORGE",
    coordenadas: "31°52'58\"S  61°50'36\"W",
    latitud: -61.84333333,
    longitud: -31.88277778,
    elev: 106,
    uom_elev: "Metros",
    ref: "San Jorge",
    distancia_ref: 2.5,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "JRZ",
    oaci: "SAZJ",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JUAREZ",
    coordenadas: "37°42'22\"S  59°47'31\"W",
    latitud: -59.79194444,
    longitud: -37.70611111,
    elev: 212,
    uom_elev: "Metros",
    ref: "Benito Juarez",
    distancia_ref: 3,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "JSM",
    oaci: "SAWS",
    iata: "JSM",
    tipo: "Aerodromo",
    denominacion: "JOSE DE SAN MARTIN",
    coordenadas: "44° 2'50\"S  70°26'47\"W",
    latitud: -70.44638889,
    longitud: -44.04722222,
    elev: 734,
    uom_elev: "Metros",
    ref: "Jose de San Martin",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "JUA",
    oaci: "SANU",
    iata: "UAQ",
    tipo: "Aerodromo",
    denominacion: "SAN JUAN/DOMINGO FAUSTINO SARMIENTO",
    coordenadas: "31°34'17\"S  68°25' 6\"W",
    latitud: -68.41833333,
    longitud: -31.57138889,
    elev: 597,
    uom_elev: "Metros",
    ref: "San Juan",
    distancia_ref: 12,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SAN JUAN",
    inhab: "NO",
  },
  {
    local: "JUJ",
    oaci: "SASJ",
    iata: "JUJ",
    tipo: "Aerodromo",
    denominacion: "JUJUY/GOBERNADOR GUZMAN",
    coordenadas: "24°23'33\"S  65° 5'52\"W",
    latitud: -65.09777778,
    longitud: -24.3925,
    elev: 920,
    uom_elev: "Metros",
    ref: "San Salvador de Jujuy",
    distancia_ref: 33,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "JUJUY",
    inhab: "NO",
  },
  {
    local: "LAE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PUNTA ROJA/EA. LA ELBA",
    coordenadas: "44°34'22\"S  65°22'14\"W",
    latitud: -65.37055556,
    longitud: -44.57277778,
    elev: 14,
    uom_elev: "Metros",
    ref: "Camarones",
    distancia_ref: 37,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "LAM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL LAMADRID",
    coordenadas: "37°13'34\"S  61°16'44\"W",
    latitud: -61.27888889,
    longitud: -37.22611111,
    elev: 171,
    uom_elev: "Metros",
    ref: "General La Madrid",
    distancia_ref: 3,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LAN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LANTERI",
    coordenadas: "28°51'27\"S  59°40'22\"W",
    latitud: -59.67277778,
    longitud: -28.8575,
    elev: 56,
    uom_elev: "Metros",
    ref: "Lanteri",
    distancia_ref: 3.5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "LAR",
    oaci: "SANL",
    iata: "IRJ",
    tipo: "Aerodromo",
    denominacion: "LA RIOJA/CAP. VICENTE A. ALMONACID",
    coordenadas: "29°22'50\"S  66°47'45\"W",
    latitud: -66.79583333,
    longitud: -29.38055556,
    elev: 438,
    uom_elev: "Metros",
    ref: "La Rioja",
    distancia_ref: 7,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "LA RIOJA",
    inhab: "NO",
  },
  {
    local: "LAU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TRENQUE LAUQUEN",
    coordenadas: "36° 0'57\"S  62°41'38\"W",
    latitud: -62.69388889,
    longitud: -36.01583333,
    elev: 99,
    uom_elev: "Metros",
    ref: "Trenque Lauquen",
    distancia_ref: 4,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LAZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA PAZ/AEROCLUB",
    coordenadas: "30°44'37\"S  59°34' 8\"W",
    latitud: -59.56887,
    longitud: -30.74368,
    elev: 61,
    uom_elev: "Metros",
    ref: "La Paz",
    distancia_ref: 6,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "LBI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LOBERIA",
    coordenadas: "38°11'22\"S  58°47'14\"W",
    latitud: -58.7872,
    longitud: -38.18951,
    elev: 81,
    uom_elev: "Metros",
    ref: "Loberia",
    distancia_ref: 2.5,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LCC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA CARLOTA/CASAJUS",
    coordenadas: "33°23'18\"S  63°18'20\"W",
    latitud: -63.30551,
    longitud: -33.38823,
    elev: 143,
    uom_elev: "Metros",
    ref: "La Carlota",
    distancia_ref: 3.5,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LCP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LONCOPUE",
    coordenadas: "38° 4'54\"S  70°38'39\"W",
    latitud: -70.64406,
    longitud: -38.08177,
    elev: 1106,
    uom_elev: "Metros",
    ref: "Loncopue",
    distancia_ref: 3,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "LCT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA CARLOTA",
    coordenadas: "33°27'27\"S  63°18'49\"W",
    latitud: -63.31375,
    longitud: -33.45761,
    elev: 154,
    uom_elev: "Metros",
    ref: "La Carlota",
    distancia_ref: 4,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LDA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LEZAMA/DON ALBERTO",
    coordenadas: "35°52'11\"S  57°52'36\"W",
    latitud: -57.87667,
    longitud: -35.86972,
    elev: 8,
    uom_elev: "Metros",
    ref: "Manuel J. Cobo",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LDG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAGUNA DE GOMEZ",
    coordenadas: "34°39'17\"S  61° 0'33\"W",
    latitud: -61.0091,
    longitud: -34.65469,
    elev: 80,
    uom_elev: "Metros",
    ref: "Junin",
    distancia_ref: 11,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LDR",
    oaci: "SAOD",
    iata: "VDR",
    tipo: "Aerodromo",
    denominacion: "VILLA DOLORES",
    coordenadas: "31°56'51\"S  65° 8'51\"W",
    latitud: -65.1475,
    longitud: -31.9475,
    elev: 563,
    uom_elev: "Metros",
    ref: "Cordoba",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LEN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BELEN DE ESCOBAR",
    coordenadas: "34°17'55\"S  58°47'56\"W",
    latitud: -58.79888889,
    longitud: -34.29861111,
    elev: 4,
    uom_elev: "Metros",
    ref: "Belen de Escobar",
    distancia_ref: 0,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LEO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LEONES",
    coordenadas: "32°38'34\"S  62°19' 1\"W",
    latitud: -62.31681,
    longitud: -32.64264,
    elev: 114,
    uom_elev: "Metros",
    ref: "Leones",
    distancia_ref: 3,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LGM",
    oaci: "SAVM",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SARMIENTO/LAGO MUSTERS",
    coordenadas: "45°34'30\"S  69° 4'38\"W",
    latitud: -69.07713,
    longitud: -45.57506,
    elev: 27,
    uom_elev: "Metros",
    ref: "Sarmiento",
    distancia_ref: 0,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "LHP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS HERAS/LOS PERALES",
    coordenadas: "46°11'31\"S  69°17'13\"W",
    latitud: -69.28694444,
    longitud: -46.19194444,
    elev: 426,
    uom_elev: "Metros",
    ref: "Las Heras",
    distancia_ref: 47,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "LIB",
    oaci: "SARL",
    iata: "AOL",
    tipo: "Aerodromo",
    denominacion: "PASO DE LOS LIBRES",
    coordenadas: "29°41'17\"S  57° 9' 8\"W",
    latitud: -57.15222222,
    longitud: -29.68805556,
    elev: 70,
    uom_elev: "Metros",
    ref: "Paso de los Libres",
    distancia_ref: 6,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "LIN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LINCOLN",
    coordenadas: "34°53'27\"S  61°31'53\"W",
    latitud: -61.53138889,
    longitud: -34.89083333,
    elev: 85,
    uom_elev: "Metros",
    ref: "Lincoln",
    distancia_ref: 3,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LIO",
    oaci: "SAZX",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NUEVE DE JULIO",
    coordenadas: "35°23'58\"S  60°55'60\"W",
    latitud: -60.93333333,
    longitud: -35.39944444,
    elev: 75,
    uom_elev: "Metros",
    ref: "9 de Julio",
    distancia_ref: 5,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LJN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LUJAN",
    coordenadas: "34°33' 2\"S  59° 4'45\"W",
    latitud: -59.07916667,
    longitud: -34.55055556,
    elev: 25,
    uom_elev: "Metros",
    ref: "Lujan",
    distancia_ref: 2,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LLA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS LAJITAS/AEROSOLUCIONES",
    coordenadas: "24°44'56\"S  64°14' 6\"W",
    latitud: -64.235,
    longitud: -24.74888889,
    elev: 492,
    uom_elev: "Metros",
    ref: "Las Lajitas",
    distancia_ref: 4,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "LLC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LONGCHAMPS/LA CAIDA",
    coordenadas: "34°51'45\"S  58°20'41\"W",
    latitud: -58.34472222,
    longitud: -34.8625,
    elev: 28,
    uom_elev: "Metros",
    ref: "Longchamps",
    distancia_ref: 4,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LLE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LIBERTAD/LA ESMERALDA",
    coordenadas: "29°59'42\"S  57°50'18\"W",
    latitud: -57.83833,
    longitud: -29.9951,
    elev: 81,
    uom_elev: "Metros",
    ref: "Libertad",
    distancia_ref: 8,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "LLJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS LAJAS",
    coordenadas: "38°32'18\"S  70°20'12\"W",
    latitud: -70.3367,
    longitud: -38.53828,
    elev: 850,
    uom_elev: "Metros",
    ref: "Las Lajas",
    distancia_ref: 3,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "LMD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JUAN N. FERNANDEZ/LA MADRUGADA",
    coordenadas: "38° 0'30\"S  59°20'60\"W",
    latitud: -59.34998,
    longitud: -38.00845,
    elev: 137,
    uom_elev: "Metros",
    ref: "Juan N. Fernandez",
    distancia_ref: 7,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LMF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LOS MOLINOS/ESTABLECIMIENTO LA FLORENCIA",
    coordenadas: "33° 4'45\"S  61°18'59\"W",
    latitud: -61.31628,
    longitud: -33.07912,
    elev: 75,
    uom_elev: "Metros",
    ref: "Los Molinos",
    distancia_ref: 3,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "LNH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAGO NAHUEL HUAPI",
    coordenadas: "41° 5'50\"S  71°10'36\"W",
    latitud: -71.17678,
    longitud: -41.09725,
    elev: 780,
    uom_elev: "Metros",
    ref: "San Carlos de Bariloche",
    distancia_ref: 11,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "LNV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LINCOLN/LA NUEVA",
    coordenadas: "34°56'41\"S  61°18' 8\"W",
    latitud: -61.30217,
    longitud: -34.94464,
    elev: 75,
    uom_elev: "Metros",
    ref: "Lincoln",
    distancia_ref: 22,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LPB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "COMANDANTE LUIS PIEDRABUENA",
    coordenadas: "49°59'42\"S  68°56'59\"W",
    latitud: -68.94984,
    longitud: -49.99499,
    elev: 24,
    uom_elev: "Metros",
    ref: "Comandante Luis Piedrabuena",
    distancia_ref: 3.5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "LPP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS PALMAS/PETRUK",
    coordenadas: "27° 5'16\"S  58°40'10\"W",
    latitud: -58.66944444,
    longitud: -27.08777778,
    elev: 54,
    uom_elev: "Metros",
    ref: "Las Palmas",
    distancia_ref: 4,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "LPR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAPRIDA",
    coordenadas: "37°31'15\"S  60°46'42\"W",
    latitud: -60.77833333,
    longitud: -37.52083333,
    elev: 210,
    uom_elev: "Metros",
    ref: "Laprida",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LRE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA RAMADA DE ABAJO/DON EMILIO",
    coordenadas: "26°43'58\"S  64°53' 5\"W",
    latitud: -64.88463,
    longitud: -26.73288,
    elev: 530,
    uom_elev: "Metros",
    ref: "La Ramada",
    distancia_ref: 5,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TUCUMAN",
    inhab: "NO",
  },
  {
    local: "LRS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS ROSAS",
    coordenadas: "32°29'35\"S  61°34'54\"W",
    latitud: -61.58166667,
    longitud: -32.49305556,
    elev: 102,
    uom_elev: "Metros",
    ref: "Las Rosas",
    distancia_ref: 1,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "LRT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS ROSAS/HORIZONTE APLICACIONES AEREAS",
    coordenadas: "32°31'13\"S  61°33' 3\"W",
    latitud: -61.55083333,
    longitud: -32.52027778,
    elev: 98,
    uom_elev: "Metros",
    ref: "Las Rosas",
    distancia_ref: 6,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "LVA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS VARAS/MACIAS",
    coordenadas: "31°49' 2\"S  62°37'49\"W",
    latitud: -62.63027778,
    longitud: -31.81722222,
    elev: 126,
    uom_elev: "Metros",
    ref: "Las Varas",
    distancia_ref: 2,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LVL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS VARILLAS",
    coordenadas: "31°53'30\"S  62°42'17\"W",
    latitud: -62.70472222,
    longitud: -31.89166667,
    elev: 135,
    uom_elev: "Metros",
    ref: "Las Varillas",
    distancia_ref: 2,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LVM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LUJAN/EA. VILLA MARIA",
    coordenadas: "34°38'37\"S  59° 7'38\"W",
    latitud: -59.12727,
    longitud: -34.6436,
    elev: 32,
    uom_elev: "Metros",
    ref: "Lujan",
    distancia_ref: 9,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "LVR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS VARILLAS/GINEVRO",
    coordenadas: "31°51'29\"S  62°50'40\"W",
    latitud: -62.84449,
    longitud: -31.85801,
    elev: 145,
    uom_elev: "Metros",
    ref: "Las Varillas",
    distancia_ref: 12,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LYE",
    oaci: "SAOL",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LABOULAYE",
    coordenadas: "34° 8' 8\"S  63°21'45\"W",
    latitud: -63.36237,
    longitud: -34.13544,
    elev: 137,
    uom_elev: "Metros",
    ref: "Laboulaye",
    distancia_ref: 2.7,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "LZA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAGO LA ESPERANZA",
    coordenadas: "42°13' 2\"S  71°48'19\"W",
    latitud: -71.80522,
    longitud: -42.21713,
    elev: 560,
    uom_elev: "Metros",
    ref: "Lago Puelo",
    distancia_ref: 24,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "MAB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MAGGIOLO/SAMAVE",
    coordenadas: "33°47'11\"S  62° 7'41\"W",
    latitud: -62.12792,
    longitud: -33.78639,
    elev: 109,
    uom_elev: "Metros",
    ref: "Maggiolo",
    distancia_ref: 13,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "MAC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MACACHIN",
    coordenadas: "37° 8'45\"S  63°40'44\"W",
    latitud: -63.67893,
    longitud: -37.14581,
    elev: 140,
    uom_elev: "Metros",
    ref: "Macachin",
    distancia_ref: 0,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "MAD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL MADARIAGA",
    coordenadas: "37° 2'19\"S  57° 8'11\"W",
    latitud: -57.13638889,
    longitud: -37.03861111,
    elev: 7,
    uom_elev: "Metros",
    ref: "General Juan Madariaga",
    distancia_ref: 4,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MAI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MONTE MAIZ",
    coordenadas: "33°12'40\"S  62°37'52\"W",
    latitud: -62.63111111,
    longitud: -33.21111111,
    elev: 113,
    uom_elev: "Metros",
    ref: "Monte Maiz",
    distancia_ref: 2,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MAO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VEINTICINCO DE MAYO",
    coordenadas: "37°48'35\"S  67°39'34\"W",
    latitud: -67.65938,
    longitud: -37.80974,
    elev: 347,
    uom_elev: "Metros",
    ref: "25 de Mayo",
    distancia_ref: 7.5,
    direccion_ref: "ESE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "MAQ",
    oaci: "SAVQ",
    iata: "MQD",
    tipo: "Aerodromo",
    denominacion: "MAQUINCHAO",
    coordenadas: "41°14'34\"S  68°42'30\"W",
    latitud: -68.70828,
    longitud: -41.24288,
    elev: 880,
    uom_elev: "Metros",
    ref: "Maquinchao",
    distancia_ref: 0,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "MAT",
    oaci: "SADZ",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MATANZA",
    coordenadas: "34°43'42\"S  58°30' 2\"W",
    latitud: -58.50055556,
    longitud: -34.72833333,
    elev: 3,
    uom_elev: "Metros",
    ref: "La Matanza",
    distancia_ref: 3,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MAY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VEINTICINCO DE MAYO",
    coordenadas: "35°26'47\"S  60° 5'19\"W",
    latitud: -60.08861111,
    longitud: -35.44638889,
    elev: 89,
    uom_elev: "Metros",
    ref: "25 de Mayo",
    distancia_ref: 7,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MBF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MONTE BUEY/PEDRO FERRARI",
    coordenadas: "32°55'54\"S  62°26' 5\"W",
    latitud: -62.43474,
    longitud: -32.93173,
    elev: 108,
    uom_elev: "Metros",
    ref: "Monte Buey",
    distancia_ref: 2,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MBI",
    oaci: "SAWB",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VICECOMODORO MARAMBIO",
    coordenadas: "64°14'21\"S  56°37'51\"W",
    latitud: -56.63085,
    longitud: -64.23913,
    elev: 209.5,
    uom_elev: "Metros",
    ref: "Isla Marambio. Mar de Weddell.",
    distancia_ref: "",
    direccion_ref: "",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "MIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "MBL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MIRAMAR/BELLAMAR",
    coordenadas: "38°23' 8\"S  58° 8' 1\"W",
    latitud: -58.13353,
    longitud: -38.38559,
    elev: 13,
    uom_elev: "Metros",
    ref: "Miramar",
    distancia_ref: 29.5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MCL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MINA CLAVERO",
    coordenadas: "31°43'49\"S  64°59'16\"W",
    latitud: -64.98777778,
    longitud: -31.73027778,
    elev: 970,
    uom_elev: "Metros",
    ref: "Mina Clavero",
    distancia_ref: 1,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MCO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LOS MENUCOS",
    coordenadas: "40°48'57\"S  68° 4'19\"W",
    latitud: -68.07203,
    longitud: -40.81596,
    elev: 784,
    uom_elev: "Metros",
    ref: "Los Menucos",
    distancia_ref: 3,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "MCP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MONTE CASEROS/EL PILINCHO",
    coordenadas: "30°23'14\"S  57°58' 6\"W",
    latitud: -57.96833333,
    longitud: -30.38722222,
    elev: 71,
    uom_elev: "Metros",
    ref: "Monte Caseros",
    distancia_ref: 35,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "MCS",
    oaci: "SARM",
    iata: "MCS",
    tipo: "Aerodromo",
    denominacion: "MONTE CASEROS",
    coordenadas: "30°16'13\"S  57°38'22\"W",
    latitud: -57.63944444,
    longitud: -30.27027778,
    elev: 52,
    uom_elev: "Metros",
    ref: "Monte Caseros",
    distancia_ref: 1.5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "MCT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MONTE CASEROS/TIMBOY",
    coordenadas: "30°14' 7\"S  57°50'45\"W",
    latitud: -57.84572,
    longitud: -30.23519,
    elev: 65,
    uom_elev: "Metros",
    ref: "Monte Caseros",
    distancia_ref: 21,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "MDB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MAR DEL PLATA/BATAN",
    coordenadas: "38° 0'42\"S  57°40'39\"W",
    latitud: -57.6775,
    longitud: -38.01166667,
    elev: 62,
    uom_elev: "Metros",
    ref: "Batan",
    distancia_ref: 11.5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MDP",
    oaci: "SAZM",
    iata: "MDQ",
    tipo: "Aerodromo",
    denominacion: "MAR DEL PLATA/ASTOR PIAZZOLLA",
    coordenadas: "37°56' 3\"S  57°34'24\"W",
    latitud: -57.57333333,
    longitud: -37.93416667,
    elev: 22,
    uom_elev: "Metros",
    ref: "Mar del Plata",
    distancia_ref: 7,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MER",
    oaci: "SADR",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MERLO",
    coordenadas: "34°40'35\"S  58°44'38\"W",
    latitud: -58.74388889,
    longitud: -34.67638889,
    elev: 15,
    uom_elev: "Metros",
    ref: "Merlo",
    distancia_ref: 2,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MEZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORDOBA/LA MEZQUITA",
    coordenadas: "31°24' 4\"S  64°18' 1\"W",
    latitud: -64.3003,
    longitud: -31.40103,
    elev: 510,
    uom_elev: "Metros",
    ref: "La Mezquita",
    distancia_ref: 6,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MGI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ISLA MARTIN GARCIA",
    coordenadas: "34°10'56\"S  58°14'49\"W",
    latitud: -58.24694444,
    longitud: -34.18222222,
    elev: 2,
    uom_elev: "Metros",
    ref: "Isla Martin Garcia",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MIN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA MINETTI",
    coordenadas: "28°37' 8\"S  61°36'13\"W",
    latitud: -61.60359,
    longitud: -28.61901,
    elev: 75,
    uom_elev: "Metros",
    ref: "Villa Minetti",
    distancia_ref: 5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "MJZ",
    oaci: "SAOM",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MARCOS JUAREZ",
    coordenadas: "32°41' 2\"S  62° 9'28\"W",
    latitud: -62.15772,
    longitud: -32.684,
    elev: 110,
    uom_elev: "Metros",
    ref: "Marcos Juarez",
    distancia_ref: 5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MLA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MALABRIGO",
    coordenadas: "29°22' 2\"S  59°58'41\"W",
    latitud: -59.97805556,
    longitud: -29.36722222,
    elev: 54,
    uom_elev: "Metros",
    ref: "Malabrigo",
    distancia_ref: 1.5,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "MLD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL MOLDES",
    coordenadas: "33°37' 3\"S  64°37' 1\"W",
    latitud: -64.61701,
    longitud: -33.61743,
    elev: 357,
    uom_elev: "Metros",
    ref: "Coronel Moldes",
    distancia_ref: 1.5,
    direccion_ref: "NNO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MLG",
    oaci: "SAMM",
    iata: "LGS",
    tipo: "Aerodromo",
    denominacion: "MALARGÜE/COMODORO D. RICARDO SALOMON",
    coordenadas: "35°29'43\"S  69°34'23\"W",
    latitud: -69.57305556,
    longitud: -35.49527778,
    elev: 1424,
    uom_elev: "Metros",
    ref: "Malargüe",
    distancia_ref: 1,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "MOI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORRALITO/DON MOISES",
    coordenadas: "32° 2' 8\"S  64°11'28\"W",
    latitud: -64.19111111,
    longitud: -32.03555556,
    elev: 489,
    uom_elev: "Metros",
    ref: "Corralito",
    distancia_ref: 1.5,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MON",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MONJE/FUMIGACIONES GONZALEZ",
    coordenadas: "32°21'32\"S  60°58'47\"W",
    latitud: -60.97972222,
    longitud: -32.35888889,
    elev: 30,
    uom_elev: "Metros",
    ref: "Monje",
    distancia_ref: 3,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "MOR",
    oaci: "SADM",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MORON",
    coordenadas: "34°40'45\"S  58°38'37\"W",
    latitud: -58.64361111,
    longitud: -34.67916667,
    elev: 29,
    uom_elev: "Metros",
    ref: "Moron",
    distancia_ref: 3,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MPH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MAR DEL PLATA/PARQUE HERMOSO",
    coordenadas: "38° 1'42\"S  57°38'23\"W",
    latitud: -57.63972222,
    longitud: -38.02833333,
    elev: 35,
    uom_elev: "Metros",
    ref: "Parque Hermoso",
    distancia_ref: 9,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MPP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MAR DEL PLATA/CLUB DE PLANEADORES",
    coordenadas: "38° 0'55\"S  57°39'13\"W",
    latitud: -57.65361111,
    longitud: -38.01527778,
    elev: 45,
    uom_elev: "Metros",
    ref: "Mar del Plata",
    distancia_ref: 9.5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MPU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MAIPU",
    coordenadas: "36°53'20\"S  57°51' 6\"W",
    latitud: -57.85166667,
    longitud: -36.88888889,
    elev: 16,
    uom_elev: "Metros",
    ref: "Maipu",
    distancia_ref: 3,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MRD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MERCEDES",
    coordenadas: "34°38'20\"S  59°27'19\"W",
    latitud: -59.45527778,
    longitud: -34.63888889,
    elev: 42,
    uom_elev: "Metros",
    ref: "Mercedes",
    distancia_ref: 2.5,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MSA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VEINTICINCO DE MAYO/SERVICIOS AGROAEREOS",
    coordenadas: "35°26'58\"S  60° 9'39\"W",
    latitud: -60.16088,
    longitud: -35.44932,
    elev: 50,
    uom_elev: "Metros",
    ref: "25 de Mayo",
    distancia_ref: 2,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MSP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MARCOS PAZ",
    coordenadas: "34°47'51\"S  58°53'49\"W",
    latitud: -58.89693,
    longitud: -34.79759,
    elev: 28,
    uom_elev: "Metros",
    ref: "Marcos Paz",
    distancia_ref: 6.5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "MSR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MERCEDES/EA. SANTA ROMANA",
    coordenadas: "33°44'49\"S  65°14'44\"W",
    latitud: -65.24549,
    longitud: -33.74683,
    elev: 472,
    uom_elev: "Metros",
    ref: "Villa Reynolds",
    distancia_ref: 13,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "MTL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MONTECARLO",
    coordenadas: "26°32'39\"S  54°43'26\"W",
    latitud: -54.72388889,
    longitud: -26.54416667,
    elev: 240,
    uom_elev: "Metros",
    ref: "Montecarlo",
    distancia_ref: 3.5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "MTN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "METAN",
    coordenadas: "25°30'51\"S  64°57'56\"W",
    latitud: -64.96555556,
    longitud: -25.51416667,
    elev: 843,
    uom_elev: "Metros",
    ref: "Metan",
    distancia_ref: 2,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "MTR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MORTEROS",
    coordenadas: "30°40'33\"S  62° 1'33\"W",
    latitud: -62.0259,
    longitud: -30.67594,
    elev: 94,
    uom_elev: "Metros",
    ref: "Morteros",
    distancia_ref: 3,
    direccion_ref: "NNO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "MUQ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "QUEMU QUEMU",
    coordenadas: "36° 3'27\"S  63°37'53\"W",
    latitud: -63.63138889,
    longitud: -36.0575,
    elev: 0,
    uom_elev: "Metros",
    ref: "Quemu Quemu",
    distancia_ref: 6,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "MUS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHASCOMUS",
    coordenadas: "35°32'32\"S  58° 3' 7\"W",
    latitud: -58.05194444,
    longitud: -35.54222222,
    elev: 10,
    uom_elev: "Metros",
    ref: "Chascomus",
    distancia_ref: 5,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NAN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "HERNANDO/AEROCLUB",
    coordenadas: "32°20'25\"S  63°41' 9\"W",
    latitud: -63.68583333,
    longitud: -32.34027778,
    elev: 282,
    uom_elev: "Metros",
    ref: "Hernando",
    distancia_ref: 1,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "NDL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TANDIL/AEROCLUB",
    coordenadas: "37°15'47\"S  59° 5'37\"W",
    latitud: -59.09361111,
    longitud: -37.26305556,
    elev: 165,
    uom_elev: "Metros",
    ref: "Tandil",
    distancia_ref: 7,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NDR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NORBERTO DE LA RIESTRA",
    coordenadas: "35°19'39\"S  59°47'28\"W",
    latitud: -59.7910805,
    longitud: -35.327583,
    elev: 38.5,
    uom_elev: "Metros",
    ref: "Norberto de la Riestra",
    distancia_ref: 6,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NEC",
    oaci: "SAZO",
    iata: "NEC",
    tipo: "Aerodromo",
    denominacion: "NECOCHEA",
    coordenadas: "38°29'22\"S  58°48'59\"W",
    latitud: -58.81626,
    longitud: -38.48954,
    elev: 22,
    uom_elev: "Metros",
    ref: "Necochea",
    distancia_ref: 10,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NEI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NECOCHEA/IRIBERRI",
    coordenadas: "38°28'44\"S  58°48'16\"W",
    latitud: -58.80453,
    longitud: -38.47884,
    elev: 33,
    uom_elev: "Metros",
    ref: "Necochea",
    distancia_ref: 10,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NEU",
    oaci: "SAZN",
    iata: "NQN",
    tipo: "Aerodromo",
    denominacion: "NEUQUEN/PRESIDENTE PERON",
    coordenadas: "38°56'56\"S  68° 9'21\"W",
    latitud: -68.15583333,
    longitud: -38.94888889,
    elev: 273,
    uom_elev: "Metros",
    ref: "Neuquen",
    distancia_ref: 8,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "NIK",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LOBERIA/NIKA",
    coordenadas: "38° 9'24\"S  58°45'39\"W",
    latitud: -58.76087,
    longitud: -38.15666,
    elev: 80,
    uom_elev: "Metros",
    ref: "Loberia",
    distancia_ref: 2,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NIN",
    oaci: "SAAJ",
    iata: "JNI",
    tipo: "Aerodromo",
    denominacion: "JUNIN",
    coordenadas: "34°32'45\"S  60°55'50\"W",
    latitud: -60.93051,
    longitud: -34.54589,
    elev: 80,
    uom_elev: "Metros",
    ref: "Junin",
    distancia_ref: 6.5,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NJB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NOGOYA/JUAN CARLOS BAGUR",
    coordenadas: "32°25' 7\"S  59°48'57\"W",
    latitud: -59.81583333,
    longitud: -32.41861111,
    elev: 58,
    uom_elev: "Metros",
    ref: "Nogoya",
    distancia_ref: 4,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "NOG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NOGOYA",
    coordenadas: "32°23'58\"S  59°45' 2\"W",
    latitud: -59.75055556,
    longitud: -32.39944444,
    elev: 43,
    uom_elev: "Metros",
    ref: "Nogoya",
    distancia_ref: 5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "NOT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NOGOYA/TOGNOLI",
    coordenadas: "32°26'50\"S  59°51'58\"W",
    latitud: -59.86611,
    longitud: -32.44736,
    elev: 60,
    uom_elev: "Metros",
    ref: "Nogoya",
    distancia_ref: 9.5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "NPA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NECOCHEA/PULVERIZACIONES AEROSUR",
    coordenadas: "38°34'31\"S  58°47'42\"W",
    latitud: -58.795,
    longitud: -38.57527778,
    elev: 15,
    uom_elev: "Metros",
    ref: "Necochea",
    distancia_ref: 5.5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "NST",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NUESTRA SEÑORA DE TALAVERA/FINCA TOLOCHE",
    coordenadas: "25°26'15\"S  63°51'29\"W",
    latitud: -63.85805556,
    longitud: -25.4375,
    elev: 317,
    uom_elev: "Metros",
    ref: "Nuestra Señora de Talavera",
    distancia_ref: 8,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "NVR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "NAVARRO",
    coordenadas: "35° 1'25\"S  59°17' 9\"W",
    latitud: -59.28583333,
    longitud: -35.02361111,
    elev: 30,
    uom_elev: "Metros",
    ref: "Navarro",
    distancia_ref: 2,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "OBE",
    oaci: "SATO",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "OBERA",
    coordenadas: "27°31' 5\"S  55° 7'27\"W",
    latitud: -55.12421,
    longitud: -27.5181,
    elev: 343,
    uom_elev: "Metros",
    ref: "Obera",
    distancia_ref: 3,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "OCA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MONTES DE OCA",
    coordenadas: "32°35' 3\"S  61°50'30\"W",
    latitud: -61.84167,
    longitud: -32.58417,
    elev: 19,
    uom_elev: "Metros",
    ref: "Montes de Oca",
    distancia_ref: 9,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "OEL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHOELE CHOEL",
    coordenadas: "39°17'11\"S  65°36'36\"W",
    latitud: -65.61,
    longitud: -39.28638889,
    elev: 196,
    uom_elev: "Metros",
    ref: "Choele Choel",
    distancia_ref: 3.5,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "OGB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL BOGADO/AEROFUMIGACIONES DON ALEJANDRO",
    coordenadas: "33°18'22\"S  60°39'22\"W",
    latitud: -60.6561,
    longitud: -33.30609,
    elev: 52,
    uom_elev: "Metros",
    ref: "Coronel Bogado",
    distancia_ref: 11,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "OLA",
    oaci: "SAZF",
    iata: "OVR",
    tipo: "Aerodromo",
    denominacion: "OLAVARRIA",
    coordenadas: "36°53'20\"S  60°13'40\"W",
    latitud: -60.22777778,
    longitud: -36.88888889,
    elev: 168,
    uom_elev: "Metros",
    ref: "Olavarria",
    distancia_ref: 11,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "OLV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "OLIVA",
    coordenadas: "32° 3'37\"S  63°32'53\"W",
    latitud: -63.54799,
    longitud: -32.06029,
    elev: 268,
    uom_elev: "Metros",
    ref: "Oliva",
    distancia_ref: 2,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "OMA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LOMA LA LATA",
    coordenadas: "38°24'50\"S  68°44'14\"W",
    latitud: -68.73715,
    longitud: -38.41383,
    elev: 405,
    uom_elev: "Metros",
    ref: "Neuquen",
    distancia_ref: 80,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "ORA",
    oaci: "SASO",
    iata: "ORA",
    tipo: "Aerodromo",
    denominacion: "ORAN",
    coordenadas: "23° 9' 8\"S  64°19'44\"W",
    latitud: -64.3288,
    longitud: -23.15221,
    elev: 357,
    uom_elev: "Metros",
    ref: "San Ramon de la Nueva Oran",
    distancia_ref: 2.5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "OSA",
    oaci: "SAZR",
    iata: "RSA",
    tipo: "Aerodromo",
    denominacion: "SANTA ROSA",
    coordenadas: "36°35'18\"S  64°16'33\"W",
    latitud: -64.27583333,
    longitud: -36.58833333,
    elev: 192,
    uom_elev: "Metros",
    ref: "Santa Rosa",
    distancia_ref: 4.5,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "OVJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LAS OVEJAS",
    coordenadas: "36°59'57\"S  70°44'32\"W",
    latitud: -70.74222222,
    longitud: -36.99916667,
    elev: 1200,
    uom_elev: "Metros",
    ref: "Las Ovejas",
    distancia_ref: 1.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "PAL",
    oaci: "SADP",
    iata: "EPA",
    tipo: "Aerodromo",
    denominacion: "EL PALOMAR",
    coordenadas: "34°36'36\"S  58°36'45\"W",
    latitud: -58.6125,
    longitud: -34.61,
    elev: 18,
    uom_elev: "Metros",
    ref: "El Palomar",
    distancia_ref: 1.5,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "JOINT",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PAN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PASCANAS/EL RECUERDO S.R.L.",
    coordenadas: "33° 6'20\"S  63°11'35\"W",
    latitud: -63.19298,
    longitud: -33.1055,
    elev: 138,
    uom_elev: "Metros",
    ref: "Pascanas",
    distancia_ref: 14,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "PAR",
    oaci: "SAAP",
    iata: "PRA",
    tipo: "Aerodromo",
    denominacion: "PARANA/GRAL. URQUIZA",
    coordenadas: "31°47'41\"S  60°28'49\"W",
    latitud: -60.48027778,
    longitud: -31.79472222,
    elev: 74,
    uom_elev: "Metros",
    ref: "Parana",
    distancia_ref: 7.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "PAS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PASTEUR/LAS LILAS",
    coordenadas: "35° 6'34\"S  62°13' 4\"W",
    latitud: -62.21764,
    longitud: -35.10957,
    elev: 107,
    uom_elev: "Metros",
    ref: "Pasteur",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PAT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARMEN DE PATAGONES",
    coordenadas: "40°46'41\"S  62°58'49\"W",
    latitud: -62.98027778,
    longitud: -40.77805556,
    elev: 40,
    uom_elev: "Metros",
    ref: "Carmen de Patagones",
    distancia_ref: 1.5,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PBE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "POBLET",
    coordenadas: "35° 5'17\"S  57°56'57\"W",
    latitud: -57.94917,
    longitud: -35.08795,
    elev: 20,
    uom_elev: "Metros",
    ref: "Poblet",
    distancia_ref: 3.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "ULM",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PBO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "POSADAS/BONETTI",
    coordenadas: "27°36'24\"S  55°51'54\"W",
    latitud: -55.86498,
    longitud: -27.60678,
    elev: 141,
    uom_elev: "Metros",
    ref: "Parada Leis",
    distancia_ref: 3,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "PCA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PIQUETE CABADO/SAS AEROAPLICACIONES",
    coordenadas: "24°48'24\"S  64°10'52\"W",
    latitud: -64.18111111,
    longitud: -24.80666667,
    elev: 457,
    uom_elev: "Metros",
    ref: "Piquete Cabado",
    distancia_ref: 1,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "PDA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "JUJUY/PUERTA DE AVALOS",
    coordenadas: "24°18'53\"S  65°14'50\"W",
    latitud: -65.24727,
    longitud: -24.31467,
    elev: 1190,
    uom_elev: "Metros",
    ref: "San Salvador de Jujuy",
    distancia_ref: 14,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "JUJUY",
    inhab: "NO",
  },
  {
    local: "PDP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PRESIDENCIA ROCA/EA. DON PANOS",
    coordenadas: "26°17'45\"S  59°32' 7\"W",
    latitud: -59.53539,
    longitud: -26.29586,
    elev: 80,
    uom_elev: "Metros",
    ref: "Presidencia Roca",
    distancia_ref: 16,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "PED",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN PEDRO",
    coordenadas: "33°42'12\"S  59°43'31\"W",
    latitud: -59.72527778,
    longitud: -33.70333333,
    elev: 27,
    uom_elev: "Metros",
    ref: "San Pedro",
    distancia_ref: 3.7,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PEH",
    oaci: "SAZP",
    iata: "PEH",
    tipo: "Aerodromo",
    denominacion: "PEHUAJO/COM. PEDRO ZANNI",
    coordenadas: "35°50'40\"S  61°51'27\"W",
    latitud: -61.85748,
    longitud: -35.84451,
    elev: 85,
    uom_elev: "Metros",
    ref: "Pehuajo",
    distancia_ref: 5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PEL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA PELADA",
    coordenadas: "30°57'39\"S  60°53'13\"W",
    latitud: -60.88698,
    longitud: -30.96087,
    elev: 44,
    uom_elev: "Metros",
    ref: "La Pelada",
    distancia_ref: 13,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "PEN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PERGAMINO/LA NORIA",
    coordenadas: "33°51'25\"S  60°42' 1\"W",
    latitud: -60.70038,
    longitud: -33.85694,
    elev: 74,
    uom_elev: "Metros",
    ref: "Pergamino",
    distancia_ref: 11,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PEP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RICARDONE/PETTILEP II",
    coordenadas: "32°48'14\"S  60°47'56\"W",
    latitud: -60.79888889,
    longitud: -32.80388889,
    elev: 55,
    uom_elev: "Metros",
    ref: "Ricardone",
    distancia_ref: 4,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "PER",
    oaci: "SAAN",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PERGAMINO",
    coordenadas: "33°55'13\"S  60°38'53\"W",
    latitud: -60.64805556,
    longitud: -33.92027778,
    elev: 72,
    uom_elev: "Metros",
    ref: "Pergamino",
    distancia_ref: 10,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PIG",
    oaci: "SAZE",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PIGÜE",
    coordenadas: "37°36'22\"S  62°22'55\"W",
    latitud: -62.38194444,
    longitud: -37.60611111,
    elev: 312,
    uom_elev: "Metros",
    ref: "Pigüe",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PJO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PEHUAJO/LA MARIELA",
    coordenadas: "35°47'26\"S  61°56'31\"W",
    latitud: -61.94194444,
    longitud: -35.79055556,
    elev: 86,
    uom_elev: "Metros",
    ref: "Pehuajo",
    distancia_ref: 4.5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PLC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PIÑERO/EA. LA CAROLINA",
    coordenadas: "33° 4'32\"S  60°42'54\"W",
    latitud: -60.715,
    longitud: -33.07559,
    elev: 30,
    uom_elev: "Metros",
    ref: "Piñero",
    distancia_ref: 8,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "PLG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PELLEGRINI",
    coordenadas: "36°16'43\"S  63° 8'49\"W",
    latitud: -63.14695,
    longitud: -36.27873,
    elev: 113,
    uom_elev: "Metros",
    ref: "Pellegrini",
    distancia_ref: 1.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PLL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PUJATO/LA LUCIA",
    coordenadas: "33° 0'33\"S  61° 3'46\"W",
    latitud: -61.06286,
    longitud: -33.00928,
    elev: 73,
    uom_elev: "Metros",
    ref: "Pujato",
    distancia_ref: 1.5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "PLS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PIRANE/EA. LA SALVACION",
    coordenadas: "25°16'52\"S  58°56'16\"W",
    latitud: -58.93781,
    longitud: -25.281,
    elev: 98,
    uom_elev: "Metros",
    ref: "Pirane",
    distancia_ref: 52,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "FORMOSA",
    inhab: "NO",
  },
  {
    local: "PLT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PUNTA ALTA",
    coordenadas: "38°50' 3\"S  62° 5'14\"W",
    latitud: -62.08722222,
    longitud: -38.83416667,
    elev: 3,
    uom_elev: "Metros",
    ref: "Punta Alta",
    distancia_ref: 5.5,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PNA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PARANA/CLUB DE PLANEADORES",
    coordenadas: "31°43'51\"S  60°13'12\"W",
    latitud: -60.22,
    longitud: -31.73083333,
    elev: 46,
    uom_elev: "Metros",
    ref: "Parana",
    distancia_ref: 29,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "PNR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PINAMAR",
    coordenadas: "37° 5'47\"S  56°58'27\"W",
    latitud: -56.97416667,
    longitud: -37.09638889,
    elev: 9,
    uom_elev: "Metros",
    ref: "Pinamar",
    distancia_ref: 10,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PNT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL PINTO",
    coordenadas: "34°47' 9\"S  61°54'51\"W",
    latitud: -61.91415,
    longitud: -34.78595,
    elev: 97,
    uom_elev: "Metros",
    ref: "General Pinto",
    distancia_ref: 4,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "POS",
    oaci: "SARP",
    iata: "PSS",
    tipo: "Aerodromo",
    denominacion: "POSADAS/LIBERTADOR GRAL. D. JOSE DE SAN MARTIN",
    coordenadas: "27°23' 9\"S  55°58'14\"W",
    latitud: -55.97049,
    longitud: -27.38573,
    elev: 131,
    uom_elev: "Metros",
    ref: "Posadas",
    distancia_ref: 7.5,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "PRA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PRESIDENTE ROCA/EA. LA LEONOR",
    coordenadas: "26° 8'16\"S  59°39'50\"W",
    latitud: -59.66378,
    longitud: -26.13774,
    elev: 87,
    uom_elev: "Metros",
    ref: "Presidencia Roca",
    distancia_ref: 7,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "PRC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "HUNTER/FUMIGACIONES FREDY",
    coordenadas: "34°14'10\"S  60°34'55\"W",
    latitud: -60.58194444,
    longitud: -34.23611111,
    elev: 53.7,
    uom_elev: "Metros",
    ref: "Hunter",
    distancia_ref: 5,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PRI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL PRINGLES",
    coordenadas: "38° 0'24\"S  61°19'55\"W",
    latitud: -61.33194444,
    longitud: -38.00666667,
    elev: 247,
    uom_elev: "Metros",
    ref: "Coronel Pringles",
    distancia_ref: 3,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PSA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PIGÜE/SERVICIOS AERONAUTICOS",
    coordenadas: "37°31'23\"S  62°27' 8\"W",
    latitud: -62.45231389,
    longitud: -37.52304444,
    elev: 247,
    uom_elev: "Metros",
    ref: "Pigüe",
    distancia_ref: 9,
    direccion_ref: "NNO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PSP",
    oaci: "SARS",
    iata: "PRQ",
    tipo: "Aerodromo",
    denominacion: "PRESIDENCIA ROQUE SAENZ PEÑA/TERMAL",
    coordenadas: "26°45'20\"S  60°29'36\"W",
    latitud: -60.49329,
    longitud: -26.75564,
    elev: 94,
    uom_elev: "Metros",
    ref: "Presidencia Roque Saenz Peña",
    distancia_ref: 6,
    direccion_ref: "NNO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "PST",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PUERTO SAN MARTIN/TERMINAL 6",
    coordenadas: "32°38'30\"S  60°45'12\"W",
    latitud: -60.7534,
    longitud: -32.64155,
    elev: 0,
    uom_elev: "Metros",
    ref: "Puerto General San Martin",
    distancia_ref: 7,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "PSV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PRESIDENCIA ROQUE SAENZ PEÑA/ROVERE",
    coordenadas: "26°46'59\"S  60°29'15\"W",
    latitud: -60.48741,
    longitud: -26.78309,
    elev: 0,
    uom_elev: "Metros",
    ref: "Presidencia Roque Saenz Peña",
    distancia_ref: 5.2,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "PTA",
    oaci: "SADL",
    iata: "LPG",
    tipo: "Aerodromo",
    denominacion: "LA PLATA",
    coordenadas: "34°58' 9\"S  57°53'35\"W",
    latitud: -57.89305556,
    longitud: -34.96916667,
    elev: 22,
    uom_elev: "Metros",
    ref: "La Plata",
    distancia_ref: 5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PTL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "LA PLATA/TOLOSA",
    coordenadas: "34°52'28\"S  57°57'41\"W",
    latitud: -57.96138889,
    longitud: -34.87444444,
    elev: 6,
    uom_elev: "Metros",
    ref: "La Plata",
    distancia_ref: 5,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PTM",
    oaci: "SAWP",
    iata: "PMQ",
    tipo: "Aerodromo",
    denominacion: "PERITO MORENO",
    coordenadas: "46°32'18\"S  70°58'44\"W",
    latitud: -70.97879,
    longitud: -46.53844,
    elev: 430,
    uom_elev: "Metros",
    ref: "Perito Moreno",
    distancia_ref: 8,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "PUA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PUAN",
    coordenadas: "37°32'22\"S  62°44' 4\"W",
    latitud: -62.73444444,
    longitud: -37.53944444,
    elev: 240,
    uom_elev: "Metros",
    ref: "Puan",
    distancia_ref: 3,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "PUP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PUJATO/PETTILEP",
    coordenadas: "33° 0'28\"S  61° 1' 4\"W",
    latitud: -61.01765,
    longitud: -33.0077,
    elev: 61,
    uom_elev: "Metros",
    ref: "Pujato",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "RAE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIVADAVIA/AEROTEC",
    coordenadas: "33°12'24\"S  68°29'33\"W",
    latitud: -68.49242,
    longitud: -33.2068,
    elev: 665,
    uom_elev: "Metros",
    ref: "Rivadavia",
    distancia_ref: 3,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "RAI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RANCHOS/LA IGUALDAD",
    coordenadas: "35°34' 7\"S  58°26'25\"W",
    latitud: -58.44027778,
    longitud: -35.56861111,
    elev: 18,
    uom_elev: "Metros",
    ref: "Ranchos",
    distancia_ref: 10,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "RAU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RAUCH",
    coordenadas: "36°46'19\"S  59° 3'28\"W",
    latitud: -59.05772,
    longitud: -36.7719,
    elev: 94,
    uom_elev: "Metros",
    ref: "Rauch",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "RAW",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RAWSON",
    coordenadas: "43°17'38\"S  65° 3'47\"W",
    latitud: -65.06319021,
    longitud: -43.29391627,
    elev: 11,
    uom_elev: "Metros",
    ref: "Rawson",
    distancia_ref: 2,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "RBS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RUFINO/BSG",
    coordenadas: "34°14'57\"S  62°40'27\"W",
    latitud: -62.67405,
    longitud: -34.24928,
    elev: 120,
    uom_elev: "Metros",
    ref: "Rufino",
    distancia_ref: 3.4,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "RCE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "MERCEDES",
    coordenadas: "29°13'20\"S  58° 5'17\"W",
    latitud: -58.08805556,
    longitud: -29.22222222,
    elev: 106,
    uom_elev: "Metros",
    ref: "Mercedes",
    distancia_ref: 4,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "RCR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIO TERCERO",
    coordenadas: "32°10'22\"S  64° 5'18\"W",
    latitud: -64.08833333,
    longitud: -32.17277778,
    elev: 380,
    uom_elev: "Metros",
    ref: "Rio Tercero",
    distancia_ref: 1.5,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "RCV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIO COLORADO/VALE",
    coordenadas: "37° 3'56\"S  69°23'44\"W",
    latitud: -69.39555556,
    longitud: -37.06555556,
    elev: 930,
    uom_elev: "Metros",
    ref: "Rincon de los Sauces",
    distancia_ref: 56,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "RDJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RICARDONE/DON JOSE",
    coordenadas: "32°49'40\"S  60°46'54\"W",
    latitud: -60.78168,
    longitud: -32.82771,
    elev: 25,
    uom_elev: "Metros",
    ref: "Ricardone",
    distancia_ref: 8,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "RES",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RESISTENCIA/AEROCLUB",
    coordenadas: "27°37'52\"S  59°10'47\"W",
    latitud: -59.17972222,
    longitud: -27.63111111,
    elev: 50,
    uom_elev: "Metros",
    ref: "Resistencia",
    distancia_ref: 30,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "RGR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIO GALLEGOS/RIO CHICO",
    coordenadas: "51°40' 7\"S  69°15'37\"W",
    latitud: -69.26027778,
    longitud: -51.66861111,
    elev: 21,
    uom_elev: "Metros",
    ref: "Rio Chico",
    distancia_ref: 5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "RIE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIO CUARTO/ESTINDHER",
    coordenadas: "33° 5'34\"S  64°25'45\"W",
    latitud: -64.42926,
    longitud: -33.09288,
    elev: 0,
    uom_elev: "Metros",
    ref: "Rio Cuarto",
    distancia_ref: 9,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "RIN",
    oaci: "SAHS",
    iata: "RDS",
    tipo: "Aerodromo",
    denominacion: "RINCON DE LOS SAUCES",
    coordenadas: "37°23'25\"S  68°54'16\"W",
    latitud: -68.90444444,
    longitud: -37.39027778,
    elev: 600,
    uom_elev: "Metros",
    ref: "Rincon de los Sauces",
    distancia_ref: 0,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "RJA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ROJAS",
    coordenadas: "34°12'55\"S  60°40'24\"W",
    latitud: -60.67325,
    longitud: -34.21534,
    elev: 6,
    uom_elev: "Metros",
    ref: "Rojas",
    distancia_ref: 6,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "RLA",
    oaci: "SAFR",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RAFAELA",
    coordenadas: "31°16'57\"S  61°30' 6\"W",
    latitud: -61.50166667,
    longitud: -31.2825,
    elev: 99,
    uom_elev: "Metros",
    ref: "Rafaela",
    distancia_ref: 3.5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "RLC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "REALICO",
    coordenadas: "35° 3'32\"S  64°12'46\"W",
    latitud: -64.21277,
    longitud: -35.05892,
    elev: 165,
    uom_elev: "Metros",
    ref: "Realico",
    distancia_ref: 6,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "RMY",
    oaci: "SAWM",
    iata: "ROY",
    tipo: "Aerodromo",
    denominacion: "RIO MAYO",
    coordenadas: "45°42'14\"S  70°14'40\"W",
    latitud: -70.24444444,
    longitud: -45.70388889,
    elev: 544,
    uom_elev: "Metros",
    ref: "Rio Mayo",
    distancia_ref: 3,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "ROB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ROBERTS/AGROAEREO",
    coordenadas: "35° 8' 9\"S  61°59'50\"W",
    latitud: -61.99718,
    longitud: -35.13588,
    elev: 99,
    uom_elev: "Metros",
    ref: "Roberts",
    distancia_ref: 3,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ROH",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ROBERTS/FUMIGACIONES HERBINSEC",
    coordenadas: "35° 8'11\"S  61°59'25\"W",
    latitud: -61.99028,
    longitud: -35.13652,
    elev: 102,
    uom_elev: "Metros",
    ref: "Roberts",
    distancia_ref: 1.8,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "ROP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ROSARIO/PUEBLO ESTHER",
    coordenadas: "33° 4'54\"S  60°33'53\"W",
    latitud: -60.56472222,
    longitud: -33.08166667,
    elev: 25,
    uom_elev: "Metros",
    ref: "Pueblo Esther",
    distancia_ref: 1,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ROS",
    oaci: "SAAR",
    iata: "ROS",
    tipo: "Aerodromo",
    denominacion: "ROSARIO/ISLAS MALVINAS",
    coordenadas: "32°54'13\"S  60°47' 4\"W",
    latitud: -60.78444444,
    longitud: -32.90361111,
    elev: 26,
    uom_elev: "Metros",
    ref: "Rosario",
    distancia_ref: 13,
    direccion_ref: "ONO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "ROT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ROSARIO DEL TALA",
    coordenadas: "32°19'46\"S  59°11'29\"W",
    latitud: -59.19146,
    longitud: -32.32954,
    elev: 54,
    uom_elev: "Metros",
    ref: "Rosario del Tala",
    distancia_ref: 4,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "RST",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑADA ROSQUIN/STIEFEL",
    coordenadas: "31°59'41\"S  61°36'10\"W",
    latitud: -61.60277778,
    longitud: -31.99472222,
    elev: 71,
    uom_elev: "Metros",
    ref: "Cañada Rosquin",
    distancia_ref: 6.5,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "RTA",
    oaci: "SATR",
    iata: "RCQ",
    tipo: "Aerodromo",
    denominacion: "RECONQUISTA",
    coordenadas: "29°12'37\"S  59°40'48\"W",
    latitud: -59.68,
    longitud: -29.21027778,
    elev: 49,
    uom_elev: "Metros",
    ref: "Reconquista",
    distancia_ref: 7,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "RUF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RUFINO",
    coordenadas: "34°16'58\"S  62°40' 3\"W",
    latitud: -62.6675,
    longitud: -34.28277778,
    elev: 114,
    uom_elev: "Metros",
    ref: "Rufino",
    distancia_ref: 5,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "RVA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AMERICA",
    coordenadas: "35°30' 7\"S  62°59'24\"W",
    latitud: -62.99,
    longitud: -35.50194444,
    elev: 106,
    uom_elev: "Metros",
    ref: "America",
    distancia_ref: 1,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "RVD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "RIVADAVIA",
    coordenadas: "33°13'42\"S  68°28'27\"W",
    latitud: -68.47406,
    longitud: -33.22834,
    elev: 659,
    uom_elev: "Metros",
    ref: "Rivadavia",
    distancia_ref: 3,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "RYD",
    oaci: "SAOR",
    iata: "VME",
    tipo: "Aerodromo",
    denominacion: "VILLA REYNOLDS",
    coordenadas: "33°43'54\"S  65°22'33\"W",
    latitud: -65.37579,
    longitud: -33.73178,
    elev: 485,
    uom_elev: "Metros",
    ref: "Villa Mercedes",
    distancia_ref: 9,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "SAB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALADILLO/ABELENDA",
    coordenadas: "35°44'19\"S  59°45'43\"W",
    latitud: -59.76197,
    longitud: -35.73851,
    elev: 39,
    uom_elev: "Metros",
    ref: "Saladillo",
    distancia_ref: 9,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SAF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAFORCADA/PARAJON",
    coordenadas: "34°34'35\"S  61° 0'20\"W",
    latitud: -61.00568,
    longitud: -34.57637,
    elev: 84,
    uom_elev: "Metros",
    ref: "Saforcada",
    distancia_ref: 6,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SAL",
    oaci: "SASA",
    iata: "SLA",
    tipo: "Aerodromo",
    denominacion: "SALTA/GENERAL D. MARTIN MIGUEL DE GÜEMES",
    coordenadas: "24°51'35\"S  65°29'13\"W",
    latitud: -65.48694444,
    longitud: -24.85972222,
    elev: 1246,
    uom_elev: "Metros",
    ref: "Salta",
    distancia_ref: 6,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "SAN",
    oaci: "SAVN",
    iata: "OES",
    tipo: "Aerodromo",
    denominacion: "SAN ANTONIO OESTE/ANTOINE DE SAINT EXUPERY",
    coordenadas: "40°45' 2\"S  65° 2' 7\"W",
    latitud: -65.03527778,
    longitud: -40.75055556,
    elev: 26,
    uom_elev: "Metros",
    ref: "San Antonio Oeste",
    distancia_ref: 10,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "SBE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN BENITO",
    coordenadas: "31°48'31\"S  60°27' 6\"W",
    latitud: -60.45166667,
    longitud: -31.80861111,
    elev: 59,
    uom_elev: "Metros",
    ref: "San Benito",
    distancia_ref: 2.8,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "SCA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SUNCHALES/AEROCLUB",
    coordenadas: "30°57'26\"S  61°31'44\"W",
    latitud: -61.52888889,
    longitud: -30.95722222,
    elev: 91,
    uom_elev: "Metros",
    ref: "Sunchales",
    distancia_ref: 2,
    direccion_ref: "ESE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SCF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANFORD/CASILDA FUMIGACIONES",
    coordenadas: "33°10'34\"S  61°12'10\"W",
    latitud: -61.20267,
    longitud: -33.17625,
    elev: 79,
    uom_elev: "Metros",
    ref: "Casilda",
    distancia_ref: 9,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SCL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANTA CLARA DE SAGUIER",
    coordenadas: "31°21'20\"S  61°49'47\"W",
    latitud: -61.82983,
    longitud: -31.35548,
    elev: 105,
    uom_elev: "Metros",
    ref: "Santa Clara de Saguier",
    distancia_ref: 2.5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SCT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN CRISTOBAL",
    coordenadas: "30°15'51\"S  61°13'12\"W",
    latitud: -61.22,
    longitud: -30.26416667,
    elev: 74,
    uom_elev: "Metros",
    ref: "San Cristobal",
    distancia_ref: 4,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SCZ",
    oaci: "SAWU",
    iata: "RZA",
    tipo: "Aerodromo",
    denominacion: "SANTA CRUZ",
    coordenadas: "50° 1' 4\"S  68°34'49\"W",
    latitud: -68.58027778,
    longitud: -50.01777778,
    elev: 111,
    uom_elev: "Metros",
    ref: "Puerto Santa Cruz",
    distancia_ref: 5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "SDE",
    oaci: "SANE",
    iata: "SDE",
    tipo: "Aerodromo",
    denominacion: "SANTIAGO DEL ESTERO/VCOM. ANGEL DE LA PAZ ARAGONES",
    coordenadas: "27°45'56\"S  64°18'36\"W",
    latitud: -64.31,
    longitud: -27.76555556,
    elev: 200,
    uom_elev: "Metros",
    ref: "Santiago del Estero",
    distancia_ref: 6,
    direccion_ref: "NNO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "SDL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALADILLO",
    coordenadas: "35°36'16\"S  59°49' 0\"W",
    latitud: -59.81676,
    longitud: -35.60439,
    elev: 45,
    uom_elev: "Metros",
    ref: "Saladillo",
    distancia_ref: 4,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SEN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL BRANDSEN",
    coordenadas: "35°10'54\"S  58°17'43\"W",
    latitud: -58.29517,
    longitud: -35.18174,
    elev: 16,
    uom_elev: "Metros",
    ref: "Coronel Brandsen",
    distancia_ref: 5,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SER",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SERODINO/FUMIGACIONES STANDLER",
    coordenadas: "32°34'47\"S  60°54'34\"W",
    latitud: -60.90944,
    longitud: -32.57978,
    elev: 37,
    uom_elev: "Metros",
    ref: "Serodino",
    distancia_ref: 5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SEZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL PINTO/ALFREDO SANCHEZ",
    coordenadas: "34°48' 5\"S  61°52'10\"W",
    latitud: -61.86958,
    longitud: -34.80139,
    elev: 100,
    uom_elev: "Metros",
    ref: "General Pinto",
    distancia_ref: 6,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SFN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SELVA NUEVA/FUMIGACIONES NANDO S.H.",
    coordenadas: "29°46'45\"S  62° 1'52\"W",
    latitud: -62.03107,
    longitud: -29.77908,
    elev: 86,
    uom_elev: "Metros",
    ref: "Selva",
    distancia_ref: 2,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "SGE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN GREGORIO",
    coordenadas: "34°19' 1\"S  62° 1' 9\"W",
    latitud: -62.01916667,
    longitud: -34.31694444,
    elev: 106,
    uom_elev: "Metros",
    ref: "San Gregorio",
    distancia_ref: 2,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SGI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TRES ARROYOS/SANTAGIULIAN",
    coordenadas: "38°24'30\"S  60°18' 4\"W",
    latitud: -60.30111111,
    longitud: -38.40833333,
    elev: 104,
    uom_elev: "Metros",
    ref: "Tres Arroyos",
    distancia_ref: 1.5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SGR",
    oaci: "SAVS",
    iata: "SGV",
    tipo: "Aerodromo",
    denominacion: "SIERRA GRANDE",
    coordenadas: "41°35'29\"S  65°20'24\"W",
    latitud: -65.33991,
    longitud: -41.59138,
    elev: 210,
    uom_elev: "Metros",
    ref: "Sierra Grande",
    distancia_ref: 2.5,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "SGV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN GUILLERMO/VERGNANO",
    coordenadas: "30°19' 0\"S  61°54' 3\"W",
    latitud: -61.90083333,
    longitud: -30.31666667,
    elev: 96,
    uom_elev: "Metros",
    ref: "San Guillermo",
    distancia_ref: 5,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SHP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN ANTONIO DE ARECO/HARAS LA POMME",
    coordenadas: "34°12'40\"S  59°23'30\"W",
    latitud: -59.39154,
    longitud: -34.21122,
    elev: 28,
    uom_elev: "Metros",
    ref: "San Antonio de Areco",
    distancia_ref: 6.5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SIS",
    oaci: "SARE",
    iata: "RES",
    tipo: "Aerodromo",
    denominacion: "RESISTENCIA",
    coordenadas: "27°26'60\"S  59° 3'22\"W",
    latitud: -59.05611111,
    longitud: -27.45,
    elev: 53,
    uom_elev: "Metros",
    ref: "Resistencia",
    distancia_ref: 5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "SJA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN JUAN/AEROCLUB",
    coordenadas: "31°36'11\"S  68°32'50\"W",
    latitud: -68.54722222,
    longitud: -31.60305556,
    elev: 634,
    uom_elev: "Metros",
    ref: "San Juan",
    distancia_ref: 7,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN JUAN",
    inhab: "NO",
  },
  {
    local: "SJB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN JORGE/BOCCA",
    coordenadas: "31°52'16\"S  61°57' 4\"W",
    latitud: -61.95111111,
    longitud: -31.87111111,
    elev: 105,
    uom_elev: "Metros",
    ref: "San Jorge",
    distancia_ref: 9,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SJD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN JOSE DE LA DORMIDA",
    coordenadas: "30°16'27\"S  63°51'27\"W",
    latitud: -63.85751,
    longitud: -30.27423,
    elev: 423,
    uom_elev: "Metros",
    ref: "San Jose de la Dormida",
    distancia_ref: 11,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "SJR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN JAVIER/AEROCLUB",
    coordenadas: "30°33'21\"S  59°59'26\"W",
    latitud: -59.99069,
    longitud: -30.55586,
    elev: 23,
    uom_elev: "Metros",
    ref: "San Javier",
    distancia_ref: 6.5,
    direccion_ref: "ONO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SJT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN JUSTO",
    coordenadas: "30°45'58\"S  60°34' 2\"W",
    latitud: -60.56722222,
    longitud: -30.76611111,
    elev: 55,
    uom_elev: "Metros",
    ref: "San Justo",
    distancia_ref: 1.5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SJU",
    oaci: "SAWJ",
    iata: "ULA",
    tipo: "Aerodromo",
    denominacion: "SAN JULIAN/CAPITAN D. DANIEL VAZQUEZ",
    coordenadas: "49°18'24\"S  67°48'10\"W",
    latitud: -67.80282,
    longitud: -49.30671,
    elev: 62,
    uom_elev: "Metros",
    ref: "Puerto San Julian",
    distancia_ref: 7,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA CRUZ",
    inhab: "NO",
  },
  {
    local: "SLG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALDUNGARAY",
    coordenadas: "38°12'19\"S  61°45'40\"W",
    latitud: -61.76115,
    longitud: -38.20517,
    elev: 228,
    uom_elev: "Metros",
    ref: "Saldungaray",
    distancia_ref: 4,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SLO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALLIQUELO",
    coordenadas: "36°45'24\"S  62°56'39\"W",
    latitud: -62.94407,
    longitud: -36.75659,
    elev: 127,
    uom_elev: "Metros",
    ref: "Salliquelo",
    distancia_ref: 1.4,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SLP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANTA ROSA/SAN ALBERTO",
    coordenadas: "36°35'31\"S  64°13'13\"W",
    latitud: -64.22041,
    longitud: -36.59206,
    elev: 186,
    uom_elev: "Metros",
    ref: "Santa Rosa",
    distancia_ref: 9.3,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "SLT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALTO",
    coordenadas: "34°18'23\"S  60°17'12\"W",
    latitud: -60.28678,
    longitud: -34.3065,
    elev: 59,
    uom_elev: "Metros",
    ref: "Salto",
    distancia_ref: 3,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SLV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EMBARCACION/SALVITA",
    coordenadas: "23°12'47\"S  64° 2' 3\"W",
    latitud: -64.03403,
    longitud: -23.21306,
    elev: 283,
    uom_elev: "Metros",
    ref: "Embarcacion",
    distancia_ref: 6,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "SLY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALDUNGARAY/SANTO TOMAS DE LA SIERRA",
    coordenadas: "38°14'30\"S  61°49'40\"W",
    latitud: -61.82767,
    longitud: -38.24173,
    elev: 273,
    uom_elev: "Metros",
    ref: "Saldungaray",
    distancia_ref: 5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SLZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALAZAR/EA. EL TRIANGULO",
    coordenadas: "36°21' 1\"S  62°13'37\"W",
    latitud: -62.22694444,
    longitud: -36.35027778,
    elev: 104,
    uom_elev: "Metros",
    ref: "Salazar",
    distancia_ref: 5,
    direccion_ref: "SSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SMC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANTA MARIA",
    coordenadas: "26°40'26\"S  66° 1'29\"W",
    latitud: -66.02481,
    longitud: -26.67385,
    elev: 1800,
    uom_elev: "Metros",
    ref: "Santa Maria",
    distancia_ref: 2,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CATAMARCA",
    inhab: "NO",
  },
  {
    local: "SMF",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN MARTIN/FINCA LA FRONTERA",
    coordenadas: "22° 7'25\"S  63°17'26\"W",
    latitud: -63.29064,
    longitud: -22.12362,
    elev: 49,
    uom_elev: "Metros",
    ref: "Aguaray",
    distancia_ref: 49,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "SMM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN MIGUEL DEL MONTE/BAHIA AGRADABLE",
    coordenadas: "35°27'34\"S  58°45'50\"W",
    latitud: -58.76388889,
    longitud: -35.45944444,
    elev: 24,
    uom_elev: "Metros",
    ref: "San Miguel del Monte",
    distancia_ref: 4,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SMS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN MARCOS/CHIALVA S.H.",
    coordenadas: "32°44'12\"S  62°31'52\"W",
    latitud: -62.53111111,
    longitud: -32.73666667,
    elev: 115,
    uom_elev: "Metros",
    ref: "Bell Ville",
    distancia_ref: 19,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "SMT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GENERAL SAN MARTIN",
    coordenadas: "37°57'34\"S  63°35'28\"W",
    latitud: -63.59111,
    longitud: -37.95934,
    elev: 161,
    uom_elev: "Metros",
    ref: "General San Martin",
    distancia_ref: 1.5,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "SNT",
    oaci: "SAAA",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN ANTONIO DE ARECO",
    coordenadas: "34°13'11\"S  59°26'21\"W",
    latitud: -59.43911,
    longitud: -34.2198,
    elev: 30,
    uom_elev: "Metros",
    ref: "San Antonio de Areco",
    distancia_ref: 3,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SNY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN NICOLAS DE LOS ARROYOS",
    coordenadas: "33°23'27\"S  60°11'44\"W",
    latitud: -60.19555556,
    longitud: -33.39083333,
    elev: 30,
    uom_elev: "Metros",
    ref: "San Nicolas de los Arroyos",
    distancia_ref: 6,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SQI",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CAÑADA ROSQUIN",
    coordenadas: "32° 6'20\"S  61°36'49\"W",
    latitud: -61.61348,
    longitud: -32.10557,
    elev: 67,
    uom_elev: "Metros",
    ref: "Cañada Rosquin",
    distancia_ref: 5,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "SRA",
    oaci: "SAMR",
    iata: "AFA",
    tipo: "Aerodromo",
    denominacion: "SAN RAFAEL/S.A. SANTIAGO GERMANO",
    coordenadas: "34°35'16\"S  68°24'13\"W",
    latitud: -68.40358889,
    longitud: -34.58781667,
    elev: 753,
    uom_elev: "Metros",
    ref: "San Rafael",
    distancia_ref: 8,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "SRC",
    oaci: "SAOS",
    iata: "RLO",
    tipo: "Aerodromo",
    denominacion: "SANTA ROSA DE CONLARA/VALLE DEL CONLARA",
    coordenadas: "32°23' 5\"S  65°11' 9\"W",
    latitud: -65.18583333,
    longitud: -32.38472222,
    elev: 616,
    uom_elev: "Metros",
    ref: "Santa Rosa del Conlara",
    distancia_ref: 4.5,
    direccion_ref: "SSE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "SRE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANTA REGINA/FORTIN DE GAINZA",
    coordenadas: "34°32'48\"S  63° 7'28\"W",
    latitud: -63.12451,
    longitud: -34.54661,
    elev: 130,
    uom_elev: "Metros",
    ref: "Santa Regina",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SRM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SARMIENTO",
    coordenadas: "45°34'59\"S  69° 0' 4\"W",
    latitud: -69.00111111,
    longitud: -45.58305556,
    elev: 270,
    uom_elev: "Metros",
    ref: "Sarmiento",
    distancia_ref: 3,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "SSK",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALTO/SKARE",
    coordenadas: "34°21'25\"S  60° 9'21\"W",
    latitud: -60.15597,
    longitud: -34.35684,
    elev: 60,
    uom_elev: "Metros",
    ref: "Est. Gahan",
    distancia_ref: 4,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SSR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SALADILLO/SANTA RITA",
    coordenadas: "35°49'42\"S  60° 8'48\"W",
    latitud: -60.14666667,
    longitud: -35.82833333,
    elev: 54,
    uom_elev: "Metros",
    ref: "Saladillo",
    distancia_ref: 38,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "STD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "STROEDER",
    coordenadas: "40°12'37\"S  62°37' 3\"W",
    latitud: -62.61747,
    longitud: -40.21038,
    elev: 28,
    uom_elev: "Metros",
    ref: "Stroeder",
    distancia_ref: 1.5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "STI",
    oaci: "SAMI",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN MARTIN",
    coordenadas: "33° 3'44\"S  68°30'34\"W",
    latitud: -68.50944444,
    longitud: -33.06222222,
    elev: 696,
    uom_elev: "Metros",
    ref: "San Martin",
    distancia_ref: 3,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MENDOZA",
    inhab: "NO",
  },
  {
    local: "STR",
    oaci: "SAZL",
    iata: "SST",
    tipo: "Aerodromo",
    denominacion: "SANTA TERESITA",
    coordenadas: "36°32'32\"S  56°43'17\"W",
    latitud: -56.72138889,
    longitud: -36.54222222,
    elev: 3,
    uom_elev: "Metros",
    ref: "Santa Teresita",
    distancia_ref: 2,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SUZ",
    oaci: "SAZC",
    iata: "CSZ",
    tipo: "Aerodromo",
    denominacion: "CORONEL SUAREZ/BRIG. D. H. E.  RUIZ",
    coordenadas: "37°26'46\"S  61°53'22\"W",
    latitud: -61.88934,
    longitud: -37.44609,
    elev: 234,
    uom_elev: "Metros",
    ref: "Coronel Suarez",
    distancia_ref: 3,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "SVO",
    oaci: "SAAV",
    iata: "SFN",
    tipo: "Aerodromo",
    denominacion: "SANTA FE/SAUCE VIEJO",
    coordenadas: "31°42'39\"S  60°48'41\"W",
    latitud: -60.81138889,
    longitud: -31.71083333,
    elev: 17,
    uom_elev: "Metros",
    ref: "Santa Fe",
    distancia_ref: 10,
    direccion_ref: "SSO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "TAR",
    oaci: "SAST",
    iata: "TTG",
    tipo: "Aerodromo",
    denominacion: "TARTAGAL/GENERAL ENRIQUE MOSCONI",
    coordenadas: "22°37' 6\"S  63°47'35\"W",
    latitud: -63.79305556,
    longitud: -22.61833333,
    elev: 449,
    uom_elev: "Metros",
    ref: "Tartagal",
    distancia_ref: 11,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "TBL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EL TREBOL/BURDISSO",
    coordenadas: "32°14'38\"S  61°45'33\"W",
    latitud: -61.75915,
    longitud: -32.24383,
    elev: 111,
    uom_elev: "Metros",
    ref: "El Trebol",
    distancia_ref: 7,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "TCM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TUCUMAN/AEROCLUB HORCO MOLLE",
    coordenadas: "26°47'46\"S  65°18'34\"W",
    latitud: -65.30937,
    longitud: -26.79606,
    elev: 580,
    uom_elev: "Metros",
    ref: "San Miguel de Tucuman",
    distancia_ref: 8,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TUCUMAN",
    inhab: "NO",
  },
  {
    local: "TDB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EL TREBOL/DE BERNARDO",
    coordenadas: "32°15' 2\"S  61°39' 6\"W",
    latitud: -61.65166667,
    longitud: -32.25055556,
    elev: 87,
    uom_elev: "Metros",
    ref: "El Trebol",
    distancia_ref: 7,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "TEC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ESTANCIA TECKA",
    coordenadas: "43°36'44\"S  71° 1'19\"W",
    latitud: -71.02194444,
    longitud: -43.61222222,
    elev: 720,
    uom_elev: "Metros",
    ref: "Estancia Tecka",
    distancia_ref: 2.8,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "TEJ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CARLOS TEJEDOR",
    coordenadas: "35°25'31\"S  62°28'10\"W",
    latitud: -62.46944444,
    longitud: -35.42527778,
    elev: 94,
    uom_elev: "Metros",
    ref: "Carlos Tejedor",
    distancia_ref: 5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "TEO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TEODELINA/F.A.T.",
    coordenadas: "34°10'36\"S  61°30'25\"W",
    latitud: -61.50694444,
    longitud: -34.17666667,
    elev: 87,
    uom_elev: "Metros",
    ref: "Teodelina",
    distancia_ref: 1,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "TEV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TINTINA/ESTABLECIMIENTO EL 21",
    coordenadas: "26°53'43\"S  62°18'35\"W",
    latitud: -62.30972222,
    longitud: -26.89527778,
    elev: 68,
    uom_elev: "Metros",
    ref: "Tintina",
    distancia_ref: 41,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "THN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TOLHUIN",
    coordenadas: "54°29'59\"S  67°10'20\"W",
    latitud: -67.17226,
    longitud: -54.49961,
    elev: 213,
    uom_elev: "Metros",
    ref: "Tolhuin",
    distancia_ref: 1.5,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "TIN",
    oaci: "SANI",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TINOGASTA",
    coordenadas: "28° 2'27\"S  67°34'39\"W",
    latitud: -67.57759,
    longitud: -28.04089,
    elev: 1210,
    uom_elev: "Metros",
    ref: "Tinogasta",
    distancia_ref: 1,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CATAMARCA",
    inhab: "NO",
  },
  {
    local: "TIO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TIO PUJIO",
    coordenadas: "32°17'35\"S  63°24' 7\"W",
    latitud: -63.40194444,
    longitud: -32.29305556,
    elev: 237,
    uom_elev: "Metros",
    ref: "Tio Pujio",
    distancia_ref: 9,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "TIR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "COLONIA TIROLESA",
    coordenadas: "31°14'53\"S  64° 2'18\"W",
    latitud: -64.03847,
    longitud: -31.24797,
    elev: 407,
    uom_elev: "Metros",
    ref: "Colonia Tirolesa",
    distancia_ref: 3,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "TLS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TILISARAO",
    coordenadas: "32°45' 8\"S  65°16'54\"W",
    latitud: -65.28158,
    longitud: -32.75226,
    elev: 751,
    uom_elev: "Metros",
    ref: "Tilisarao",
    distancia_ref: 2.5,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "TOR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TORNQUIST",
    coordenadas: "38° 5'42\"S  62°14'58\"W",
    latitud: -62.24944444,
    longitud: -38.095,
    elev: 285,
    uom_elev: "Metros",
    ref: "Tornquist",
    distancia_ref: 2,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "TOS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TOSTADO",
    coordenadas: "29°14' 8\"S  61°47'18\"W",
    latitud: -61.78845,
    longitud: -29.23552,
    elev: 69,
    uom_elev: "Metros",
    ref: "Tostado",
    distancia_ref: 1,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "TOT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "ALTA GRACIA /EL TOTO",
    coordenadas: "31°39' 1\"S  64°22' 8\"W",
    latitud: -64.36888889,
    longitud: -31.65027778,
    elev: 540,
    uom_elev: "Metros",
    ref: "Alta Gracia",
    distancia_ref: 5,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "TQL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TRENQUE LAUQUEN/ÑANCO LAUQUEN",
    coordenadas: "35°58'13\"S  62°46'19\"W",
    latitud: -62.77194444,
    longitud: -35.97027778,
    elev: 92,
    uom_elev: "Metros",
    ref: "Trenque Lauquen",
    distancia_ref: 3.5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "TRC",
    oaci: "SAOC",
    iata: "RCU",
    tipo: "Aerodromo",
    denominacion: "RIO CUARTO/AREA DE MATERIAL",
    coordenadas: "33° 5'32\"S  64°16'10\"W",
    latitud: -64.26934,
    longitud: -33.09216,
    elev: 421,
    uom_elev: "Metros",
    ref: "Rio Cuarto",
    distancia_ref: 8,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "TRE",
    oaci: "SAVT",
    iata: "REL",
    tipo: "Aerodromo",
    denominacion: "TRELEW/ALMIRANTE ZAR",
    coordenadas: "43°12'38\"S  65°16'13\"W",
    latitud: -65.27027778,
    longitud: -43.21055556,
    elev: 43,
    uom_elev: "Metros",
    ref: "Trelew",
    distancia_ref: 6.5,
    direccion_ref: "NNE",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "TRH",
    oaci: "SANR",
    iata: "RHD",
    tipo: "Aerodromo",
    denominacion: "TERMAS DE RIO HONDO",
    coordenadas: "27°29'48\"S  64°56' 9\"W",
    latitud: -64.93596,
    longitud: -27.49662,
    elev: 280.5,
    uom_elev: "Metros",
    ref: "Termas de Rio Hondo",
    distancia_ref: 7.5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SANTIAGO DEL ESTERO",
    inhab: "NO",
  },
  {
    local: "TRW",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TRELEW/AEROCLUB",
    coordenadas: "43°14' 8\"S  65°19'27\"W",
    latitud: -65.32414,
    longitud: -43.23564,
    elev: 39,
    uom_elev: "Metros",
    ref: "Trelew",
    distancia_ref: 2.5,
    direccion_ref: "NNO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "TSV",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TORTUGAS/EA. SAN VICENTE",
    coordenadas: "32°59'56\"S  61°46'41\"W",
    latitud: -61.77805556,
    longitud: -32.99888889,
    elev: 70,
    uom_elev: "Metros",
    ref: "Tortugas",
    distancia_ref: 28,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "TUC",
    oaci: "SANT",
    iata: "TUC",
    tipo: "Aerodromo",
    denominacion: "TUCUMAN/TENIENTE BENJAMIN MATIENZO",
    coordenadas: "26°50'27\"S  65° 6'17\"W",
    latitud: -65.10472222,
    longitud: -26.84083333,
    elev: 455,
    uom_elev: "Metros",
    ref: "San Miguel de Tucuman",
    distancia_ref: 12,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "TUCUMAN",
    inhab: "NO",
  },
  {
    local: "TVN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TREVELIN",
    coordenadas: "43° 5'15\"S  71°28'41\"W",
    latitud: -71.47808,
    longitud: -43.08742,
    elev: 397,
    uom_elev: "Metros",
    ref: "Trevelin",
    distancia_ref: 2,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "TXO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EL TRAPIAL/CHEVRON TEXACO",
    coordenadas: "37°21'54\"S  69°18' 7\"W",
    latitud: -69.30194444,
    longitud: -37.365,
    elev: 883,
    uom_elev: "Metros",
    ref: "Rincon de los Sauces",
    distancia_ref: 20,
    direccion_ref: "O",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAMF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "UAE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GUALEGUAY/AEROCLUB",
    coordenadas: "33° 6' 8\"S  59°22'26\"W",
    latitud: -59.37388889,
    longitud: -33.10222222,
    elev: 13,
    uom_elev: "Metros",
    ref: "Gualeguay",
    distancia_ref: 8,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "UCO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CHACABUCO",
    coordenadas: "34°36'26\"S  60°24'35\"W",
    latitud: -60.40972222,
    longitud: -34.60722222,
    elev: 69,
    uom_elev: "Metros",
    ref: "Chacabuco",
    distancia_ref: 7,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "UEL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLAGUAY/EL JAGÜEL",
    coordenadas: "31°48'14\"S  59° 2' 5\"W",
    latitud: -59.03479,
    longitud: -31.80384,
    elev: 61,
    uom_elev: "Metros",
    ref: "Villaguay",
    distancia_ref: 6.5,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "UEN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "QUEQUEN/MOROMAR",
    coordenadas: "38°25'32\"S  58°22'17\"W",
    latitud: -58.37148208,
    longitud: -38.42552552,
    elev: 15,
    uom_elev: "Metros",
    ref: "Quequen",
    distancia_ref: 31,
    direccion_ref: "ENE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "UIS",
    oaci: "SAOU",
    iata: "LUQ",
    tipo: "Aerodromo",
    denominacion: "SAN LUIS/BRIG. MAYOR D. CESAR RAUL OJEDA",
    coordenadas: "33°16'20\"S  66°21'24\"W",
    latitud: -66.35666667,
    longitud: -33.27222222,
    elev: 710,
    uom_elev: "Metros",
    ref: "San Luis",
    distancia_ref: 3.8,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "ULL",
    oaci: "",
    iata: "",
    tipo: "Helipuerto",
    denominacion: "RIO CULLEN/TOTAL AUSTRAL",
    coordenadas: "52°53'37\"S  68°21'19\"W",
    latitud: -68.355331,
    longitud: -52.893494,
    elev: 16,
    uom_elev: "Metros",
    ref: "Cullen",
    distancia_ref: 6,
    direccion_ref: "E",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "UNE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "FUNES/ALAGRO FUMIGACIONES",
    coordenadas: "32°53'18\"S  60°50'37\"W",
    latitud: -60.8436,
    longitud: -32.88841,
    elev: 35,
    uom_elev: "Metros",
    ref: "Funes",
    distancia_ref: 5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "UPE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANTA FE/GUADALUPE",
    coordenadas: "31°35'34\"S  60°40'37\"W",
    latitud: -60.67690162,
    longitud: -31.59274469,
    elev: 18,
    uom_elev: "Metros",
    ref: "Santa Fe",
    distancia_ref: 8,
    direccion_ref: "NNE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "URD",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "URDINARRAIN",
    coordenadas: "32°41'45\"S  58°53'56\"W",
    latitud: -58.8989,
    longitud: -32.69589,
    elev: 66,
    uom_elev: "Metros",
    ref: "Urdinarrain",
    distancia_ref: 0,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "URL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "URIBURU/ESTANCIA LOS ROBLES",
    coordenadas: "36°33'11\"S  63°45'59\"W",
    latitud: -63.76652,
    longitud: -36.55297,
    elev: 137,
    uom_elev: "Metros",
    ref: "Uriburu",
    distancia_ref: 10,
    direccion_ref: "ESE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "URO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "PEDRO LURO",
    coordenadas: "39°27'21\"S  62°40'30\"W",
    latitud: -62.675,
    longitud: -39.45583333,
    elev: 27,
    uom_elev: "Metros",
    ref: "Pedro Luro",
    distancia_ref: 4,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "USU",
    oaci: "SAWH",
    iata: "USH",
    tipo: "Aerodromo",
    denominacion: "USHUAIA/MALVINAS ARGENTINAS",
    coordenadas: "54°50'36\"S  68°17'44\"W",
    latitud: -68.29555556,
    longitud: -54.84333333,
    elev: 31,
    uom_elev: "Metros",
    ref: "Ushuaia",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Internacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "TIERRA DEL FUEGO ANTARTIDA E ISLAS DEL ATLANTICO SUR",
    inhab: "NO",
  },
  {
    local: "VAL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VALCHETA",
    coordenadas: "40°41'57\"S  66° 9'26\"W",
    latitud: -66.1573,
    longitud: -40.69909,
    elev: 192,
    uom_elev: "Metros",
    ref: "Valcheta",
    distancia_ref: 1.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "VAN",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA ANGELA",
    coordenadas: "27°35'42\"S  60°40'55\"W",
    latitud: -60.68196,
    longitud: -27.59505,
    elev: 75,
    uom_elev: "Metros",
    ref: "Villa Angela",
    distancia_ref: 3.5,
    direccion_ref: "SE",
    condicion: "PUBLICO",
    control: "AERADIO",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHACO",
    inhab: "NO",
  },
  {
    local: "VAY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA AMANCAY/HALLPA HUAYRA",
    coordenadas: "32°12'29\"S  64°32'25\"W",
    latitud: -64.54027778,
    longitud: -32.20805556,
    elev: 557,
    uom_elev: "Metros",
    ref: "Villa Amancay",
    distancia_ref: 7,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VCA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VICTORICA",
    coordenadas: "36°12'25\"S  65°24'58\"W",
    latitud: -65.41617,
    longitud: -36.20694,
    elev: 311,
    uom_elev: "Metros",
    ref: "Victorica",
    distancia_ref: 1.2,
    direccion_ref: "NE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "LA PAMPA",
    inhab: "NO",
  },
  {
    local: "VCC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA CAÑAS/S. A. MIGUEL A. CARDONE",
    coordenadas: "33°57'40\"S  61°38' 0\"W",
    latitud: -61.63335,
    longitud: -33.96101,
    elev: 103,
    uom_elev: "Metros",
    ref: "Villa Cañas",
    distancia_ref: 4.5,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "VDA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VEDIA",
    coordenadas: "34°29'10\"S  61°29'23\"W",
    latitud: -61.48972222,
    longitud: -34.48611111,
    elev: 89,
    uom_elev: "Metros",
    ref: "Vedia",
    distancia_ref: 5,
    direccion_ref: "NE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "VDL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORONEL VIDAL",
    coordenadas: "37°28' 4\"S  57°46' 2\"W",
    latitud: -57.76722222,
    longitud: -37.46777778,
    elev: 26,
    uom_elev: "Metros",
    ref: "Coronel Vidal",
    distancia_ref: 3.7,
    direccion_ref: "OSO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "VDO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "EL CORCOVADO",
    coordenadas: "43°31'58\"S  71°29' 9\"W",
    latitud: -71.48582,
    longitud: -43.53287,
    elev: 600,
    uom_elev: "Metros",
    ref: "",
    distancia_ref: 0,
    direccion_ref: "Lindando",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "VDR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA DEL ROSARIO",
    coordenadas: "31°34'50\"S  63°32'20\"W",
    latitud: -63.53888889,
    longitud: -31.58055556,
    elev: 253,
    uom_elev: "Metros",
    ref: "Villa del Rosario",
    distancia_ref: 1.5,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VEC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "CORCOVADO/EA. CARIDAD",
    coordenadas: "43°43'17\"S  71°14'44\"W",
    latitud: -71.24555556,
    longitud: -43.72138889,
    elev: 740,
    uom_elev: "Metros",
    ref: "Corcovado",
    distancia_ref: 27,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CHUBUT",
    inhab: "NO",
  },
  {
    local: "VER",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VERA",
    coordenadas: "29°28' 6\"S  60°13'35\"W",
    latitud: -60.2264,
    longitud: -29.46835,
    elev: 58,
    uom_elev: "Metros",
    ref: "Vera",
    distancia_ref: 1,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "VEZ",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "GALVEZ",
    coordenadas: "32° 2' 7\"S  61°10'40\"W",
    latitud: -61.17777778,
    longitud: -32.03527778,
    elev: 41,
    uom_elev: "Metros",
    ref: "Galvez",
    distancia_ref: 4,
    direccion_ref: "E",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "VGB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA GENERAL BELGRANO",
    coordenadas: "31°57'52\"S  64°33'52\"W",
    latitud: -64.56444444,
    longitud: -31.96444444,
    elev: 840,
    uom_elev: "Metros",
    ref: "Villa General Belgrano",
    distancia_ref: 0,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VIC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VICTORIA",
    coordenadas: "32°35' 4\"S  60°11'22\"W",
    latitud: -60.1894,
    longitud: -32.5845,
    elev: 12,
    uom_elev: "Metros",
    ref: "Victoria",
    distancia_ref: 4.8,
    direccion_ref: "NO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "VIE",
    oaci: "SAVV",
    iata: "VDM",
    tipo: "Aerodromo",
    denominacion: "VIEDMA/GOBERNADOR CASTELLO",
    coordenadas: "40°52'13\"S  62°59'48\"W",
    latitud: -62.99666667,
    longitud: -40.87027778,
    elev: 6,
    uom_elev: "Metros",
    ref: "Viedma",
    distancia_ref: 6,
    direccion_ref: "S",
    condicion: "PUBLICO",
    control: "CONTROL",
    region: "RASU",
    fir: "SAVF",
    uso: "",
    trafico: "Nacional",
    sna: "SI",
    concesionado: "SI",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "VIG",
    oaci: "SAAU",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLAGUAY",
    coordenadas: "31°51' 2\"S  59° 4'23\"W",
    latitud: -59.07305556,
    longitud: -31.85055556,
    elev: 40,
    uom_elev: "Metros",
    ref: "Villaguay",
    distancia_ref: 5,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "VIT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SANTA VICTORIA",
    coordenadas: "22°17' 8\"S  62°42'49\"W",
    latitud: -62.71372,
    longitud: -22.28551,
    elev: 280,
    uom_elev: "Metros",
    ref: "Santa Victoria",
    distancia_ref: 7,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SALTA",
    inhab: "NO",
  },
  {
    local: "VLL",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLAGUAY/EL MALAGUEÑO",
    coordenadas: "31°41'32\"S  59°24'38\"W",
    latitud: -59.41059,
    longitud: -31.69211,
    elev: 55,
    uom_elev: "Metros",
    ref: "Villaguay",
    distancia_ref: 40,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "ENTRE RIOS",
    inhab: "NO",
  },
  {
    local: "VMA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VICUÑA MACKENNA/DON ANGEL",
    coordenadas: "33°56'18\"S  64°24'28\"W",
    latitud: -64.40775,
    longitud: -33.93823,
    elev: 228,
    uom_elev: "Metros",
    ref: "Vicuña Mackenna",
    distancia_ref: 2,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VMB",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VICUÑA MACKENNA/BENEFICIOS S.R.L.",
    coordenadas: "33°56'15\"S  64°24'54\"W",
    latitud: -64.41509,
    longitud: -33.93757,
    elev: 241,
    uom_elev: "Metros",
    ref: "Vicuña Mackenna",
    distancia_ref: 2,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VMC",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VICUÑA MACKENNA/COMEQUECHEN",
    coordenadas: "33°56' 2\"S  64°24'57\"W",
    latitud: -64.41595,
    longitud: -33.934,
    elev: 243,
    uom_elev: "Metros",
    ref: "Vicuña Mackenna",
    distancia_ref: 3,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VMK",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VICUÑA MACKENNA/MARTIN FIERRO",
    coordenadas: "33°56'35\"S  64°22'16\"W",
    latitud: -64.37117,
    longitud: -33.94302,
    elev: 230,
    uom_elev: "Metros",
    ref: "Vicuña Mackenna",
    distancia_ref: 2,
    direccion_ref: "SSE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VMR",
    oaci: "SAOV",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA MARIA/AEROPUERTO REGIONAL",
    coordenadas: "32°19'12\"S  63°13'36\"W",
    latitud: -63.22654,
    longitud: -32.32006,
    elev: 202,
    uom_elev: "Metros",
    ref: "Villa Maria",
    distancia_ref: 9,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VMT",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA MERCEDES/LAS TOTORITAS",
    coordenadas: "33°50'41\"S  65°19'29\"W",
    latitud: -65.32472222,
    longitud: -33.84472222,
    elev: 448,
    uom_elev: "Metros",
    ref: "Villa Mercedes",
    distancia_ref: 20,
    direccion_ref: "SE",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SAMF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SAN LUIS",
    inhab: "NO",
  },
  {
    local: "VNA",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VERONICA",
    coordenadas: "35°23'58\"S  57°22' 2\"W",
    latitud: -57.36722222,
    longitud: -35.39944444,
    elev: 17,
    uom_elev: "Metros",
    ref: "Veronica",
    distancia_ref: 2.5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "VNO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VENADO TUERTO",
    coordenadas: "33°40'47\"S  61°57'19\"W",
    latitud: -61.95515,
    longitud: -33.67977,
    elev: 112,
    uom_elev: "Metros",
    ref: "Venado Tuerto",
    distancia_ref: 6,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "VNR",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA NUEVA/RAIG SA",
    coordenadas: "32°26'17\"S  63°17'22\"W",
    latitud: -63.28930556,
    longitud: -32.43816667,
    elev: 206,
    uom_elev: "Metros",
    ref: "Villa Maria",
    distancia_ref: 5,
    direccion_ref: "SO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VNS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA NUEVA/SUAREZ AVIACION",
    coordenadas: "32°25'37\"S  63°18' 8\"W",
    latitud: -63.30222222,
    longitud: -32.42694444,
    elev: 207,
    uom_elev: "Metros",
    ref: "Villa Nueva",
    distancia_ref: 6,
    direccion_ref: "OSO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VPO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA OCAMPO",
    coordenadas: "28°29'46\"S  59°19'34\"W",
    latitud: -59.32612,
    longitud: -28.49598,
    elev: 49,
    uom_elev: "Metros",
    ref: "Villa Ocampo",
    distancia_ref: 2.5,
    direccion_ref: "O",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "VRG",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA REGINA",
    coordenadas: "39° 4'29\"S  67° 4'41\"W",
    latitud: -67.07805556,
    longitud: -39.07472222,
    elev: 285,
    uom_elev: "Metros",
    ref: "Villa Regina",
    distancia_ref: 1.4,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "RIO NEGRO",
    inhab: "NO",
  },
  {
    local: "VRU",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VILLA RUMIPAL/PRIMER TENIENTE MARIO NIVOLI",
    coordenadas: "32°11' 3\"S  64°29'20\"W",
    latitud: -64.48888889,
    longitud: -32.18416667,
    elev: 666,
    uom_elev: "Metros",
    ref: "Villa Rumipal",
    distancia_ref: 0,
    direccion_ref: "ENE",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "VTE",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "SAN VICENTE",
    coordenadas: "26°57'11\"S  54°29'16\"W",
    latitud: -54.48789,
    longitud: -26.95314,
    elev: 550,
    uom_elev: "Metros",
    ref: "San Vicente",
    distancia_ref: 2,
    direccion_ref: "N",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "MISIONES",
    inhab: "NO",
  },
  {
    local: "VTO",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VENADO TUERTO/LA SIESTA",
    coordenadas: "33°41'29\"S  62° 3'49\"W",
    latitud: -62.06369,
    longitud: -33.69132,
    elev: 112,
    uom_elev: "Metros",
    ref: "Venado Tuerto",
    distancia_ref: 12,
    direccion_ref: "NO",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "VTS",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "VENADO TUERTO/SAVESA",
    coordenadas: "33°46'43\"S  61°58'34\"W",
    latitud: -61.97609,
    longitud: -33.77872,
    elev: 110,
    uom_elev: "Metros",
    ref: "Venado Tuerto",
    distancia_ref: 3,
    direccion_ref: "S",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "SANTA FE",
    inhab: "NO",
  },
  {
    local: "YOP",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "TRES ARROYOS/PETRAZZINI",
    coordenadas: "38°20'52\"S  60°16'34\"W",
    latitud: -60.27611111,
    longitud: -38.34777778,
    elev: 107,
    uom_elev: "Metros",
    ref: "Tres Arroyos",
    distancia_ref: 3,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "YOS",
    oaci: "SAZH",
    iata: "OYO",
    tipo: "Aerodromo",
    denominacion: "TRES ARROYOS",
    coordenadas: "38°23' 8\"S  60°19'39\"W",
    latitud: -60.3275,
    longitud: -38.38555556,
    elev: 122,
    uom_elev: "Metros",
    ref: "Tres Arroyos",
    distancia_ref: 5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
  {
    local: "YPY",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "YAPEYU",
    coordenadas: "29°21'32\"S  56°47'45\"W",
    latitud: -56.79573,
    longitud: -29.35877,
    elev: 53,
    uom_elev: "Metros",
    ref: "Yapeyu",
    distancia_ref: 12,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANE",
    fir: "SARR",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORRIENTES",
    inhab: "NO",
  },
  {
    local: "ZAP",
    oaci: "SAHZ",
    iata: "APZ",
    tipo: "Aerodromo",
    denominacion: "ZAPALA",
    coordenadas: "38°58'33\"S  70° 6'48\"W",
    latitud: -70.11346389,
    longitud: -38.97588611,
    elev: 1048,
    uom_elev: "Metros",
    ref: "Zapala",
    distancia_ref: 7.5,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "NEUQUEN",
    inhab: "NO",
  },
  {
    local: "ZLM",
    oaci: "",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "BELL VILLE/LA ZULEMA",
    coordenadas: "32°29'23\"S  62°40'17\"W",
    latitud: -62.67138889,
    longitud: -32.48972222,
    elev: 129,
    uom_elev: "Metros",
    ref: "Bell Ville",
    distancia_ref: 13,
    direccion_ref: "N",
    condicion: "PRIVADO",
    control: "NOCONTROL",
    region: "RANO",
    fir: "SACF",
    uso: "AEROAPP",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "CORDOBA",
    inhab: "NO",
  },
  {
    local: "ZUL",
    oaci: "SAZA",
    iata: "",
    tipo: "Aerodromo",
    denominacion: "AZUL",
    coordenadas: "36°50'12\"S  59°52'51\"W",
    latitud: -59.8808,
    longitud: -36.83675,
    elev: 146,
    uom_elev: "Metros",
    ref: "Azul",
    distancia_ref: 3,
    direccion_ref: "SO",
    condicion: "PUBLICO",
    control: "NOCONTROL",
    region: "RACE",
    fir: "SAEF",
    uso: "CIVIL",
    trafico: "Nacional",
    sna: "NO",
    concesionado: "NO",
    provincia: "BUENOS AIRES",
    inhab: "NO",
  },
];
